/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: any;
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: any;
};

export type AboutNode = {
  __typename?: 'AboutNode';
  bannerDescription?: Maybe<Scalars['String']>;
  bannerImageUrl?: Maybe<Scalars['String']>;
  bannerTitle?: Maybe<Scalars['String']>;
  bannerVideo?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  learnMoreUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum AccountType {
  Business = 'business',
  Personal = 'personal'
}

export type AddArtworksToCollectionInput = {
  artworks?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['ID']>;
};

export type AddArtworksToCollectionPayload = {
  __typename?: 'AddArtworksToCollectionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  collection?: Maybe<CollectionNode>;
};

/** There was an error adding your credit card. Please try again. */
export type AddCreditCardFailure = {
  __typename?: 'AddCreditCardFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type AddCreditCardInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  tokenId: Scalars['String'];
};

export type AddCreditCardResult = AddCreditCardFailure | AddCreditCardSuccess;

export type AddCreditCardSuccess = {
  __typename?: 'AddCreditCardSuccess';
  creditCard?: Maybe<CreditCardNode>;
};

/** There was an error addind your featured_storefront. Please try again. */
export type AddFeaturedStorefrontFailure = {
  __typename?: 'AddFeaturedStorefrontFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type AddFeaturedStorefrontInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  page: Scalars['String'];
  position: Scalars['Int'];
  storefrontId: Scalars['ID'];
};

export type AddFeaturedStorefrontResult = AddFeaturedStorefrontFailure | AddFeaturedStorefrontSuccess;

export type AddFeaturedStorefrontSuccess = {
  __typename?: 'AddFeaturedStorefrontSuccess';
  featuredStorefront?: Maybe<FeaturedStorefrontNode>;
};

/** An error occurred while adding the gallery address */
export type AddGalleryAddressFailure = {
  __typename?: 'AddGalleryAddressFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type AddGalleryAddressInput = {
  city: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  country: Country;
  galleryId: Scalars['ID'];
  kind: GalleryAddressKind;
  name: Scalars['String'];
  phone: Scalars['String'];
  postalCode: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
};

export type AddGalleryAddressResult = AddGalleryAddressFailure | AddGalleryAddressSuccess;

export type AddGalleryAddressSuccess = {
  __typename?: 'AddGalleryAddressSuccess';
  address?: Maybe<GalleryAddressNode>;
};

export type AddOrUpdateContactListInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Array<InputMaybe<ContactData>>>;
  listIds?: InputMaybe<Array<Scalars['String']>>;
  listNames?: InputMaybe<Array<Scalars['String']>>;
};

/** There was an error adding registered device. Please try again. */
export type AddRegisteredDeviceFailure = {
  __typename?: 'AddRegisteredDeviceFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type AddRegisteredDeviceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  deviceType: DeviceType;
  registrationToken: Scalars['String'];
};

export type AddRegisteredDeviceResult = AddRegisteredDeviceFailure | AddRegisteredDeviceSuccess;

export type AddRegisteredDeviceSuccess = {
  __typename?: 'AddRegisteredDeviceSuccess';
  registeredDevice?: Maybe<FirebaseNotificationsDeviceNode>;
};

export type AddTevoCreditCardFailure = {
  __typename?: 'AddTevoCreditCardFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type AddTevoCreditCardInput = {
  addressId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  cvv?: InputMaybe<Scalars['String']>;
  expirationMonth: Scalars['String'];
  expirationYear: Scalars['String'];
  name: Scalars['String'];
  number: Scalars['String'];
};

export type AddTevoCreditCardResult = AddTevoCreditCardFailure | AddTevoCreditCardSuccess;

export type AddTevoCreditCardSuccess = {
  __typename?: 'AddTevoCreditCardSuccess';
  tevoCreditCard?: Maybe<CreditCardNode>;
};

export type AddUserAddressFailure = {
  __typename?: 'AddUserAddressFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type AddUserAddressInput = {
  address: Scalars['String'];
  city: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  country: Countries;
  email?: InputMaybe<Scalars['String']>;
  fullName: Scalars['String'];
  isBilling?: InputMaybe<Scalars['Boolean']>;
  phone: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  zipcode: Scalars['String'];
};

export type AddUserAddressResult = AddUserAddressFailure | AddUserAddressSuccess;

export type AddUserAddressSuccess = {
  __typename?: 'AddUserAddressSuccess';
  address?: Maybe<UserAddressNode>;
};

export enum AddressCountry {
  /** Andorra */
  Ad = 'AD',
  /** United Arab Emirates */
  Ae = 'AE',
  /** Afghanistan */
  Af = 'AF',
  /** Antigua and Barbuda */
  Ag = 'AG',
  /** Anguilla */
  Ai = 'AI',
  /** Albania */
  Al = 'AL',
  /** Armenia */
  Am = 'AM',
  /** Angola */
  Ao = 'AO',
  /** Antarctica */
  Aq = 'AQ',
  /** Argentina */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Austria */
  At = 'AT',
  /** Australia */
  Au = 'AU',
  /** Aruba */
  Aw = 'AW',
  /** Åland Islands */
  Ax = 'AX',
  /** Azerbaijan */
  Az = 'AZ',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Barbados */
  Bb = 'BB',
  /** Bangladesh */
  Bd = 'BD',
  /** Belgium */
  Be = 'BE',
  /** Burkina Faso */
  Bf = 'BF',
  /** Bulgaria */
  Bg = 'BG',
  /** Bahrain */
  Bh = 'BH',
  /** Burundi */
  Bi = 'BI',
  /** Benin */
  Bj = 'BJ',
  /** Saint Barthélemy */
  Bl = 'BL',
  /** Bermuda */
  Bm = 'BM',
  /** Brunei */
  Bn = 'BN',
  /** Bolivia */
  Bo = 'BO',
  /** Bonaire, Sint Eustatius and Saba */
  Bq = 'BQ',
  /** Brazil */
  Br = 'BR',
  /** Bahamas */
  Bs = 'BS',
  /** Bhutan */
  Bt = 'BT',
  /** Bouvet Island */
  Bv = 'BV',
  /** Botswana */
  Bw = 'BW',
  /** Belarus */
  By = 'BY',
  /** Belize */
  Bz = 'BZ',
  /** Canada */
  Ca = 'CA',
  /** Cocos (Keeling) Islands */
  Cc = 'CC',
  /** Congo (the Democratic Republic of the) */
  Cd = 'CD',
  /** Central African Republic */
  Cf = 'CF',
  /** Congo */
  Cg = 'CG',
  /** Switzerland */
  Ch = 'CH',
  /** Côte d'Ivoire */
  Ci = 'CI',
  /** Cook Islands */
  Ck = 'CK',
  /** Chile */
  Cl = 'CL',
  /** Cameroon */
  Cm = 'CM',
  /** China */
  Cn = 'CN',
  /** Colombia */
  Co = 'CO',
  /** Costa Rica */
  Cr = 'CR',
  /** Cuba */
  Cu = 'CU',
  /** Cabo Verde */
  Cv = 'CV',
  /** Curaçao */
  Cw = 'CW',
  /** Christmas Island */
  Cx = 'CX',
  /** Cyprus */
  Cy = 'CY',
  /** Czechia */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Djibouti */
  Dj = 'DJ',
  /** Denmark */
  Dk = 'DK',
  /** Dominica */
  Dm = 'DM',
  /** Dominican Republic */
  Do = 'DO',
  /** Algeria */
  Dz = 'DZ',
  /** Ecuador */
  Ec = 'EC',
  /** Estonia */
  Ee = 'EE',
  /** Egypt */
  Eg = 'EG',
  /** Western Sahara */
  Eh = 'EH',
  /** Eritrea */
  Er = 'ER',
  /** Spain */
  Es = 'ES',
  /** Ethiopia */
  Et = 'ET',
  /** Finland */
  Fi = 'FI',
  /** Fiji */
  Fj = 'FJ',
  /** Falkland Islands  [Malvinas] */
  Fk = 'FK',
  /** Micronesia (Federated States of) */
  Fm = 'FM',
  /** Faroe Islands */
  Fo = 'FO',
  /** France */
  Fr = 'FR',
  /** Gabon */
  Ga = 'GA',
  /** United Kingdom */
  Gb = 'GB',
  /** Grenada */
  Gd = 'GD',
  /** Georgia */
  Ge = 'GE',
  /** French Guiana */
  Gf = 'GF',
  /** Guernsey */
  Gg = 'GG',
  /** Ghana */
  Gh = 'GH',
  /** Gibraltar */
  Gi = 'GI',
  /** Greenland */
  Gl = 'GL',
  /** Gambia */
  Gm = 'GM',
  /** Guinea */
  Gn = 'GN',
  /** Guadeloupe */
  Gp = 'GP',
  /** Equatorial Guinea */
  Gq = 'GQ',
  /** Greece */
  Gr = 'GR',
  /** South Georgia and the South Sandwich Islands */
  Gs = 'GS',
  /** Guatemala */
  Gt = 'GT',
  /** Guam */
  Gu = 'GU',
  /** Guinea-Bissau */
  Gw = 'GW',
  /** Guyana */
  Gy = 'GY',
  /** Hong Kong */
  Hk = 'HK',
  /** Heard Island and McDonald Islands */
  Hm = 'HM',
  /** Honduras */
  Hn = 'HN',
  /** Croatia */
  Hr = 'HR',
  /** Haiti */
  Ht = 'HT',
  /** Hungary */
  Hu = 'HU',
  /** Indonesia */
  Id = 'ID',
  /** Ireland */
  Ie = 'IE',
  /** Israel */
  Il = 'IL',
  /** Isle of Man */
  Im = 'IM',
  /** India */
  In = 'IN',
  /** British Indian Ocean Territory */
  Io = 'IO',
  /** Iraq */
  Iq = 'IQ',
  /** Iran */
  Ir = 'IR',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Jersey */
  Je = 'JE',
  /** Jamaica */
  Jm = 'JM',
  /** Jordan */
  Jo = 'JO',
  /** Japan */
  Jp = 'JP',
  /** Kenya */
  Ke = 'KE',
  /** Kyrgyzstan */
  Kg = 'KG',
  /** Cambodia */
  Kh = 'KH',
  /** Kiribati */
  Ki = 'KI',
  /** Comoros */
  Km = 'KM',
  /** Saint Kitts and Nevis */
  Kn = 'KN',
  /** North Korea */
  Kp = 'KP',
  /** South Korea */
  Kr = 'KR',
  /** Kuwait */
  Kw = 'KW',
  /** Cayman Islands */
  Ky = 'KY',
  /** Kazakhstan */
  Kz = 'KZ',
  /** Laos */
  La = 'LA',
  /** Lebanon */
  Lb = 'LB',
  /** Saint Lucia */
  Lc = 'LC',
  /** Liechtenstein */
  Li = 'LI',
  /** Sri Lanka */
  Lk = 'LK',
  /** Liberia */
  Lr = 'LR',
  /** Lesotho */
  Ls = 'LS',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Libya */
  Ly = 'LY',
  /** Morocco */
  Ma = 'MA',
  /** Monaco */
  Mc = 'MC',
  /** Moldova */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** Saint Martin (French part) */
  Mf = 'MF',
  /** Madagascar */
  Mg = 'MG',
  /** Marshall Islands */
  Mh = 'MH',
  /** Macedonia */
  Mk = 'MK',
  /** Mali */
  Ml = 'ML',
  /** Myanmar */
  Mm = 'MM',
  /** Mongolia */
  Mn = 'MN',
  /** Macao */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Martinique */
  Mq = 'MQ',
  /** Mauritania */
  Mr = 'MR',
  /** Montserrat */
  Ms = 'MS',
  /** Malta */
  Mt = 'MT',
  /** Mauritius */
  Mu = 'MU',
  /** Maldives */
  Mv = 'MV',
  /** Malawi */
  Mw = 'MW',
  /** Mexico */
  Mx = 'MX',
  /** Malaysia */
  My = 'MY',
  /** Mozambique */
  Mz = 'MZ',
  /** Namibia */
  Na = 'NA',
  /** New Caledonia */
  Nc = 'NC',
  /** Niger */
  Ne = 'NE',
  /** Norfolk Island */
  Nf = 'NF',
  /** Nigeria */
  Ng = 'NG',
  /** Nicaragua */
  Ni = 'NI',
  /** Netherlands */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Nepal */
  Np = 'NP',
  /** Nauru */
  Nr = 'NR',
  /** Niue */
  Nu = 'NU',
  /** New Zealand */
  Nz = 'NZ',
  /** Oman */
  Om = 'OM',
  /** Panama */
  Pa = 'PA',
  /** Peru */
  Pe = 'PE',
  /** French Polynesia */
  Pf = 'PF',
  /** Papua New Guinea */
  Pg = 'PG',
  /** Philippines */
  Ph = 'PH',
  /** Pakistan */
  Pk = 'PK',
  /** Poland */
  Pl = 'PL',
  /** Saint Pierre and Miquelon */
  Pm = 'PM',
  /** Pitcairn */
  Pn = 'PN',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palestine, State of */
  Ps = 'PS',
  /** Portugal */
  Pt = 'PT',
  /** Palau */
  Pw = 'PW',
  /** Paraguay */
  Py = 'PY',
  /** Qatar */
  Qa = 'QA',
  /** Réunion */
  Re = 'RE',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Russia */
  Ru = 'RU',
  /** Rwanda */
  Rw = 'RW',
  /** Saudi Arabia */
  Sa = 'SA',
  /** Solomon Islands */
  Sb = 'SB',
  /** Seychelles */
  Sc = 'SC',
  /** Sudan */
  Sd = 'SD',
  /** Sweden */
  Se = 'SE',
  /** Singapore */
  Sg = 'SG',
  /** Saint Helena, Ascension and Tristan da Cunha */
  Sh = 'SH',
  /** Slovenia */
  Si = 'SI',
  /** Svalbard and Jan Mayen */
  Sj = 'SJ',
  /** Slovakia */
  Sk = 'SK',
  /** Sierra Leone */
  Sl = 'SL',
  /** San Marino */
  Sm = 'SM',
  /** Senegal */
  Sn = 'SN',
  /** Somalia */
  So = 'SO',
  /** Suriname */
  Sr = 'SR',
  /** South Sudan */
  Ss = 'SS',
  /** Sao Tome and Principe */
  St = 'ST',
  /** El Salvador */
  Sv = 'SV',
  /** Sint Maarten (Dutch part) */
  Sx = 'SX',
  /** Syria */
  Sy = 'SY',
  /** Swaziland */
  Sz = 'SZ',
  /** Turks and Caicos Islands */
  Tc = 'TC',
  /** Chad */
  Td = 'TD',
  /** French Southern Territories */
  Tf = 'TF',
  /** Togo */
  Tg = 'TG',
  /** Thailand */
  Th = 'TH',
  /** Tajikistan */
  Tj = 'TJ',
  /** Tokelau */
  Tk = 'TK',
  /** Timor-Leste */
  Tl = 'TL',
  /** Turkmenistan */
  Tm = 'TM',
  /** Tunisia */
  Tn = 'TN',
  /** Tonga */
  To = 'TO',
  /** Turkey */
  Tr = 'TR',
  /** Trinidad and Tobago */
  Tt = 'TT',
  /** Tuvalu */
  Tv = 'TV',
  /** Taiwan */
  Tw = 'TW',
  /** Tanzania */
  Tz = 'TZ',
  /** Ukraine */
  Ua = 'UA',
  /** Uganda */
  Ug = 'UG',
  /** United States Minor Outlying Islands */
  Um = 'UM',
  /** United States of America */
  Us = 'US',
  /** Uruguay */
  Uy = 'UY',
  /** Uzbekistan */
  Uz = 'UZ',
  /** Holy See */
  Va = 'VA',
  /** Saint Vincent and the Grenadines */
  Vc = 'VC',
  /** Venezuela */
  Ve = 'VE',
  /** Virgin Islands (British) */
  Vg = 'VG',
  /** Virgin Islands (U.S.) */
  Vi = 'VI',
  /** Vietnam */
  Vn = 'VN',
  /** Vanuatu */
  Vu = 'VU',
  /** Wallis and Futuna */
  Wf = 'WF',
  /** Samoa */
  Ws = 'WS',
  /** Yemen */
  Ye = 'YE',
  /** Mayotte */
  Yt = 'YT',
  /** South Africa */
  Za = 'ZA',
  /** Zambia */
  Zm = 'ZM',
  /** Zimbabwe */
  Zw = 'ZW'
}

export enum AddressKind {
  /** Billing */
  Billing = 'BILLING',
  /** Shipping */
  Shipping = 'SHIPPING',
  /** Total Cost Calculator */
  TotalCostCalc = 'TOTAL_COST_CALC',
  /** Trade */
  Trade = 'TRADE'
}

export enum AddressStatus {
  /** Active */
  Active = 'ACTIVE'
}

export type ArtistArtworksNode = Node & {
  __typename?: 'ArtistArtworksNode';
  artistInfo?: Maybe<ArtistInfoNode>;
  artworksCount?: Maybe<Scalars['Int']>;
  bio?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  fame: Scalars['Float'];
  featuredDate?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  followers: Scalars['Int'];
  fullName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  isArs: Scalars['Boolean'];
  isFeatured: Scalars['Boolean'];
  lastName: Scalars['String'];
  lastParentCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
  meta?: Maybe<Scalars['String']>;
  origin: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  status?: Maybe<ArtistStatus>;
  tevoId?: Maybe<Scalars['Int']>;
  tours?: Maybe<TourNodeConnection>;
  updated: Scalars['DateTime'];
  uuid?: Maybe<Scalars['String']>;
};


export type ArtistArtworksNodeToursArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  slug_Icontains?: InputMaybe<Scalars['String']>;
  slug_Istartswith?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Istartswith?: InputMaybe<Scalars['String']>;
};

export type ArtistArtworksNodeCountingConnection = {
  __typename?: 'ArtistArtworksNodeCountingConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ArtistArtworksNodeCountingEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ArtistArtworksNodeCounting` and its cursor. */
export type ArtistArtworksNodeCountingEdge = {
  __typename?: 'ArtistArtworksNodeCountingEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ArtistArtworksNode>;
};

export type ArtistInfoNode = Node & {
  __typename?: 'ArtistInfoNode';
  additionalInfo?: Maybe<Scalars['String']>;
  approved: Scalars['Boolean'];
  artist: ArtistNode;
  auction?: Maybe<AuctionNode>;
  bio: Scalars['String'];
  birthInfo?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  nationality?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['String']>;
  scrapedUrl: Scalars['String'];
  sourceName: Scalars['String'];
  status: ArtistInfoStatus;
};

export type ArtistInfoNodeConnection = {
  __typename?: 'ArtistInfoNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ArtistInfoNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ArtistInfoNode` and its cursor. */
export type ArtistInfoNodeEdge = {
  __typename?: 'ArtistInfoNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ArtistInfoNode>;
};

export enum ArtistInfoStatus {
  /** Deleted */
  Deleted = 'DELETED',
  /** Public */
  Public = 'PUBLIC'
}

export type ArtistNode = EntityWithArtworks & Node & {
  __typename?: 'ArtistNode';
  artistInfo?: Maybe<ArtistInfoNode>;
  artistinfoSet?: Maybe<ArtistInfoNodeConnection>;
  artworkSet?: Maybe<ArtworkNodeConnection>;
  artworks?: Maybe<ArtworkNodeConnection>;
  bio?: Maybe<Scalars['String']>;
  categories?: Maybe<StarCategoryNodeConnection>;
  created: Scalars['DateTime'];
  entrySet?: Maybe<EntryNodeConnection>;
  fame: Scalars['Float'];
  featuredDate?: Maybe<Scalars['DateTime']>;
  file?: Maybe<FileNode>;
  firstName: Scalars['String'];
  followers: Scalars['Int'];
  fullName: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  isArs: Scalars['Boolean'];
  isFeatured: Scalars['Boolean'];
  lastName: Scalars['String'];
  lastParentCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
  mediumSet?: Maybe<MediumNodeConnection>;
  meta?: Maybe<Scalars['String']>;
  origin: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  status?: Maybe<ArtistStatus>;
  tevoId?: Maybe<Scalars['Int']>;
  tours?: Maybe<TourNodeConnection>;
  updated: Scalars['DateTime'];
  userSet?: Maybe<UserNodeConnection>;
  uuid?: Maybe<Scalars['String']>;
};


export type ArtistNodeArtistinfoSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArtistNodeArtworkSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type ArtistNodeArtworksArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  categoryWithChild_Exact?: InputMaybe<Scalars['String']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isEnded?: InputMaybe<Scalars['Boolean']>;
  isEventAnnounced?: InputMaybe<Scalars['Boolean']>;
  isEventStared?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isTransfersToLive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  purchaseType?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venueCoordinates?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type ArtistNodeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isSearchable?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  parent_Name?: InputMaybe<Scalars['String']>;
};


export type ArtistNodeEntrySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArtistNodeMediumSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArtistNodeToursArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  slug_Icontains?: InputMaybe<Scalars['String']>;
  slug_Istartswith?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Istartswith?: InputMaybe<Scalars['String']>;
};


export type ArtistNodeUserSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email_Icontains?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  followedArtists_Slug?: InputMaybe<Scalars['String']>;
  followedArtists_Slug_In?: InputMaybe<Scalars['String']>;
  grantedorder_Orderitem_Artwork_Id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  registrationSource?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  type_In?: InputMaybe<Scalars['String']>;
};

export type ArtistNodeConnection = {
  __typename?: 'ArtistNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ArtistNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ArtistNode` and its cursor. */
export type ArtistNodeEdge = {
  __typename?: 'ArtistNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ArtistNode>;
};

export type ArtistSearchConnection = {
  __typename?: 'ArtistSearchConnection';
  count?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ArtistSearchEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  spellingSuggestions?: Maybe<Array<Maybe<SpellingSuggestionNode>>>;
};

/** A Relay edge containing a `ArtistSearch` and its cursor. */
export type ArtistSearchEdge = {
  __typename?: 'ArtistSearchEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ArtistSearchNode>;
};

export type ArtistSearchInterface = {
  firstName?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  tokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  url?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ArtistSearchNode = ArtistSearchInterface & Node & {
  __typename?: 'ArtistSearchNode';
  artist?: Maybe<ArtistNode>;
  firstName?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  tokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  url?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum ArtistStatus {
  Deleted = 'deleted',
  Draft = 'draft',
  Private = 'private',
  Public = 'public'
}

export type ArtworkAdditionalInfoNode = {
  __typename?: 'ArtworkAdditionalInfoNode';
  content?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum ArtworkCategory {
  /** Experience */
  Experience = 'EXPERIENCE'
}

export type ArtworkConnection = {
  __typename?: 'ArtworkConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ArtworkEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export enum ArtworkCountryOfOrigin {
  /** Andorra */
  Ad = 'AD',
  /** United Arab Emirates */
  Ae = 'AE',
  /** Afghanistan */
  Af = 'AF',
  /** Antigua and Barbuda */
  Ag = 'AG',
  /** Anguilla */
  Ai = 'AI',
  /** Albania */
  Al = 'AL',
  /** Armenia */
  Am = 'AM',
  /** Angola */
  Ao = 'AO',
  /** Antarctica */
  Aq = 'AQ',
  /** Argentina */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Austria */
  At = 'AT',
  /** Australia */
  Au = 'AU',
  /** Aruba */
  Aw = 'AW',
  /** Åland Islands */
  Ax = 'AX',
  /** Azerbaijan */
  Az = 'AZ',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Barbados */
  Bb = 'BB',
  /** Bangladesh */
  Bd = 'BD',
  /** Belgium */
  Be = 'BE',
  /** Burkina Faso */
  Bf = 'BF',
  /** Bulgaria */
  Bg = 'BG',
  /** Bahrain */
  Bh = 'BH',
  /** Burundi */
  Bi = 'BI',
  /** Benin */
  Bj = 'BJ',
  /** Saint Barthélemy */
  Bl = 'BL',
  /** Bermuda */
  Bm = 'BM',
  /** Brunei */
  Bn = 'BN',
  /** Bolivia */
  Bo = 'BO',
  /** Bonaire, Sint Eustatius and Saba */
  Bq = 'BQ',
  /** Brazil */
  Br = 'BR',
  /** Bahamas */
  Bs = 'BS',
  /** Bhutan */
  Bt = 'BT',
  /** Bouvet Island */
  Bv = 'BV',
  /** Botswana */
  Bw = 'BW',
  /** Belarus */
  By = 'BY',
  /** Belize */
  Bz = 'BZ',
  /** Canada */
  Ca = 'CA',
  /** Cocos (Keeling) Islands */
  Cc = 'CC',
  /** Congo (the Democratic Republic of the) */
  Cd = 'CD',
  /** Central African Republic */
  Cf = 'CF',
  /** Congo */
  Cg = 'CG',
  /** Switzerland */
  Ch = 'CH',
  /** Côte d'Ivoire */
  Ci = 'CI',
  /** Cook Islands */
  Ck = 'CK',
  /** Chile */
  Cl = 'CL',
  /** Cameroon */
  Cm = 'CM',
  /** China */
  Cn = 'CN',
  /** Colombia */
  Co = 'CO',
  /** Costa Rica */
  Cr = 'CR',
  /** Cuba */
  Cu = 'CU',
  /** Cabo Verde */
  Cv = 'CV',
  /** Curaçao */
  Cw = 'CW',
  /** Christmas Island */
  Cx = 'CX',
  /** Cyprus */
  Cy = 'CY',
  /** Czechia */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Djibouti */
  Dj = 'DJ',
  /** Denmark */
  Dk = 'DK',
  /** Dominica */
  Dm = 'DM',
  /** Dominican Republic */
  Do = 'DO',
  /** Algeria */
  Dz = 'DZ',
  /** Ecuador */
  Ec = 'EC',
  /** Estonia */
  Ee = 'EE',
  /** Egypt */
  Eg = 'EG',
  /** Western Sahara */
  Eh = 'EH',
  /** Eritrea */
  Er = 'ER',
  /** Spain */
  Es = 'ES',
  /** Ethiopia */
  Et = 'ET',
  /** Finland */
  Fi = 'FI',
  /** Fiji */
  Fj = 'FJ',
  /** Falkland Islands  [Malvinas] */
  Fk = 'FK',
  /** Micronesia (Federated States of) */
  Fm = 'FM',
  /** Faroe Islands */
  Fo = 'FO',
  /** France */
  Fr = 'FR',
  /** Gabon */
  Ga = 'GA',
  /** United Kingdom */
  Gb = 'GB',
  /** Grenada */
  Gd = 'GD',
  /** Georgia */
  Ge = 'GE',
  /** French Guiana */
  Gf = 'GF',
  /** Guernsey */
  Gg = 'GG',
  /** Ghana */
  Gh = 'GH',
  /** Gibraltar */
  Gi = 'GI',
  /** Greenland */
  Gl = 'GL',
  /** Gambia */
  Gm = 'GM',
  /** Guinea */
  Gn = 'GN',
  /** Guadeloupe */
  Gp = 'GP',
  /** Equatorial Guinea */
  Gq = 'GQ',
  /** Greece */
  Gr = 'GR',
  /** South Georgia and the South Sandwich Islands */
  Gs = 'GS',
  /** Guatemala */
  Gt = 'GT',
  /** Guam */
  Gu = 'GU',
  /** Guinea-Bissau */
  Gw = 'GW',
  /** Guyana */
  Gy = 'GY',
  /** Hong Kong */
  Hk = 'HK',
  /** Heard Island and McDonald Islands */
  Hm = 'HM',
  /** Honduras */
  Hn = 'HN',
  /** Croatia */
  Hr = 'HR',
  /** Haiti */
  Ht = 'HT',
  /** Hungary */
  Hu = 'HU',
  /** Indonesia */
  Id = 'ID',
  /** Ireland */
  Ie = 'IE',
  /** Israel */
  Il = 'IL',
  /** Isle of Man */
  Im = 'IM',
  /** India */
  In = 'IN',
  /** British Indian Ocean Territory */
  Io = 'IO',
  /** Iraq */
  Iq = 'IQ',
  /** Iran */
  Ir = 'IR',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Jersey */
  Je = 'JE',
  /** Jamaica */
  Jm = 'JM',
  /** Jordan */
  Jo = 'JO',
  /** Japan */
  Jp = 'JP',
  /** Kenya */
  Ke = 'KE',
  /** Kyrgyzstan */
  Kg = 'KG',
  /** Cambodia */
  Kh = 'KH',
  /** Kiribati */
  Ki = 'KI',
  /** Comoros */
  Km = 'KM',
  /** Saint Kitts and Nevis */
  Kn = 'KN',
  /** North Korea */
  Kp = 'KP',
  /** South Korea */
  Kr = 'KR',
  /** Kuwait */
  Kw = 'KW',
  /** Cayman Islands */
  Ky = 'KY',
  /** Kazakhstan */
  Kz = 'KZ',
  /** Laos */
  La = 'LA',
  /** Lebanon */
  Lb = 'LB',
  /** Saint Lucia */
  Lc = 'LC',
  /** Liechtenstein */
  Li = 'LI',
  /** Sri Lanka */
  Lk = 'LK',
  /** Liberia */
  Lr = 'LR',
  /** Lesotho */
  Ls = 'LS',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Libya */
  Ly = 'LY',
  /** Morocco */
  Ma = 'MA',
  /** Monaco */
  Mc = 'MC',
  /** Moldova */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** Saint Martin (French part) */
  Mf = 'MF',
  /** Madagascar */
  Mg = 'MG',
  /** Marshall Islands */
  Mh = 'MH',
  /** Macedonia */
  Mk = 'MK',
  /** Mali */
  Ml = 'ML',
  /** Myanmar */
  Mm = 'MM',
  /** Mongolia */
  Mn = 'MN',
  /** Macao */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Martinique */
  Mq = 'MQ',
  /** Mauritania */
  Mr = 'MR',
  /** Montserrat */
  Ms = 'MS',
  /** Malta */
  Mt = 'MT',
  /** Mauritius */
  Mu = 'MU',
  /** Maldives */
  Mv = 'MV',
  /** Malawi */
  Mw = 'MW',
  /** Mexico */
  Mx = 'MX',
  /** Malaysia */
  My = 'MY',
  /** Mozambique */
  Mz = 'MZ',
  /** Namibia */
  Na = 'NA',
  /** New Caledonia */
  Nc = 'NC',
  /** Niger */
  Ne = 'NE',
  /** Norfolk Island */
  Nf = 'NF',
  /** Nigeria */
  Ng = 'NG',
  /** Nicaragua */
  Ni = 'NI',
  /** Netherlands */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Nepal */
  Np = 'NP',
  /** Nauru */
  Nr = 'NR',
  /** Niue */
  Nu = 'NU',
  /** New Zealand */
  Nz = 'NZ',
  /** Oman */
  Om = 'OM',
  /** Panama */
  Pa = 'PA',
  /** Peru */
  Pe = 'PE',
  /** French Polynesia */
  Pf = 'PF',
  /** Papua New Guinea */
  Pg = 'PG',
  /** Philippines */
  Ph = 'PH',
  /** Pakistan */
  Pk = 'PK',
  /** Poland */
  Pl = 'PL',
  /** Saint Pierre and Miquelon */
  Pm = 'PM',
  /** Pitcairn */
  Pn = 'PN',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palestine, State of */
  Ps = 'PS',
  /** Portugal */
  Pt = 'PT',
  /** Palau */
  Pw = 'PW',
  /** Paraguay */
  Py = 'PY',
  /** Qatar */
  Qa = 'QA',
  /** Réunion */
  Re = 'RE',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Russia */
  Ru = 'RU',
  /** Rwanda */
  Rw = 'RW',
  /** Saudi Arabia */
  Sa = 'SA',
  /** Solomon Islands */
  Sb = 'SB',
  /** Seychelles */
  Sc = 'SC',
  /** Sudan */
  Sd = 'SD',
  /** Sweden */
  Se = 'SE',
  /** Singapore */
  Sg = 'SG',
  /** Saint Helena, Ascension and Tristan da Cunha */
  Sh = 'SH',
  /** Slovenia */
  Si = 'SI',
  /** Svalbard and Jan Mayen */
  Sj = 'SJ',
  /** Slovakia */
  Sk = 'SK',
  /** Sierra Leone */
  Sl = 'SL',
  /** San Marino */
  Sm = 'SM',
  /** Senegal */
  Sn = 'SN',
  /** Somalia */
  So = 'SO',
  /** Suriname */
  Sr = 'SR',
  /** South Sudan */
  Ss = 'SS',
  /** Sao Tome and Principe */
  St = 'ST',
  /** El Salvador */
  Sv = 'SV',
  /** Sint Maarten (Dutch part) */
  Sx = 'SX',
  /** Syria */
  Sy = 'SY',
  /** Swaziland */
  Sz = 'SZ',
  /** Turks and Caicos Islands */
  Tc = 'TC',
  /** Chad */
  Td = 'TD',
  /** French Southern Territories */
  Tf = 'TF',
  /** Togo */
  Tg = 'TG',
  /** Thailand */
  Th = 'TH',
  /** Tajikistan */
  Tj = 'TJ',
  /** Tokelau */
  Tk = 'TK',
  /** Timor-Leste */
  Tl = 'TL',
  /** Turkmenistan */
  Tm = 'TM',
  /** Tunisia */
  Tn = 'TN',
  /** Tonga */
  To = 'TO',
  /** Turkey */
  Tr = 'TR',
  /** Trinidad and Tobago */
  Tt = 'TT',
  /** Tuvalu */
  Tv = 'TV',
  /** Taiwan */
  Tw = 'TW',
  /** Tanzania */
  Tz = 'TZ',
  /** Ukraine */
  Ua = 'UA',
  /** Uganda */
  Ug = 'UG',
  /** United States Minor Outlying Islands */
  Um = 'UM',
  /** United States of America */
  Us = 'US',
  /** Uruguay */
  Uy = 'UY',
  /** Uzbekistan */
  Uz = 'UZ',
  /** Holy See */
  Va = 'VA',
  /** Saint Vincent and the Grenadines */
  Vc = 'VC',
  /** Venezuela */
  Ve = 'VE',
  /** Virgin Islands (British) */
  Vg = 'VG',
  /** Virgin Islands (U.S.) */
  Vi = 'VI',
  /** Vietnam */
  Vn = 'VN',
  /** Vanuatu */
  Vu = 'VU',
  /** Wallis and Futuna */
  Wf = 'WF',
  /** Samoa */
  Ws = 'WS',
  /** Yemen */
  Ye = 'YE',
  /** Mayotte */
  Yt = 'YT',
  /** South Africa */
  Za = 'ZA',
  /** Zambia */
  Zm = 'ZM',
  /** Zimbabwe */
  Zw = 'ZW'
}

/** A Relay edge containing a `Artwork` and its cursor. */
export type ArtworkEdge = {
  __typename?: 'ArtworkEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ArtworkNode>;
};

export enum ArtworkEventStatus {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Postponed */
  Postponed = 'POSTPONED',
  /** Shown */
  Shown = 'SHOWN'
}

export type ArtworkImageNode = Node & {
  __typename?: 'ArtworkImageNode';
  artist?: Maybe<ArtistNode>;
  artworkSet?: Maybe<ArtworkNodeConnection>;
  bucket: Scalars['String'];
  caption: Scalars['String'];
  created: Scalars['DateTime'];
  extension: Scalars['String'];
  file: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  inS3: Scalars['Boolean'];
  kind: Scalars['String'];
  mime: Scalars['String'];
  package?: Maybe<PackageNode>;
  path: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  starcategorySet?: Maybe<StarCategoryNodeConnection>;
  status?: Maybe<Scalars['String']>;
  submitter: UserNode;
  tour?: Maybe<TourNode>;
  updated: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  venue?: Maybe<VenueNode>;
  width?: Maybe<Scalars['Int']>;
  zoomable: Scalars['Boolean'];
};


export type ArtworkImageNodeArtworkSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type ArtworkImageNodeStarcategorySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isSearchable?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  parent_Name?: InputMaybe<Scalars['String']>;
};

export type ArtworkImageNodeConnection = {
  __typename?: 'ArtworkImageNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ArtworkImageNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ArtworkImageNode` and its cursor. */
export type ArtworkImageNodeEdge = {
  __typename?: 'ArtworkImageNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ArtworkImageNode>;
};

/**
 * This node operates on the artwork serializer that pulls data from the artwork
 * model and applies transformations to make it easier to use on the client
 * self in the resolvers corresponds to the serializer
 */
export type ArtworkInfoNode = Node & {
  __typename?: 'ArtworkInfoNode';
  additionalInfo?: Maybe<Array<Maybe<ArtworkAdditionalInfoNode>>>;
  artistProof?: Maybe<Scalars['String']>;
  artistsInfo?: Maybe<Array<Maybe<ArtistInfoNode>>>;
  bidCount?: Maybe<Scalars['Int']>;
  buyersPremiumMultiplier?: Maybe<Scalars['Float']>;
  buyersPremiumPercent?: Maybe<Scalars['Int']>;
  creationDate?: Maybe<Scalars['String']>;
  currentBid?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  dimensionNotes?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Scalars['String']>;
  displayAddress?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['String']>;
  earliestDateForShipmentTimestamp?: Maybe<Scalars['Int']>;
  edition?: Maybe<Scalars['String']>;
  electronicDelivery?: Maybe<Scalars['Boolean']>;
  endTimestamp?: Maybe<Scalars['Int']>;
  estimate?: Maybe<Scalars['String']>;
  eventStartDate?: Maybe<Scalars['DateTime']>;
  framedDimensions?: Maybe<Scalars['String']>;
  hasBuyersPremium?: Maybe<Scalars['Boolean']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isBeforeStart?: Maybe<Scalars['Boolean']>;
  isClosed?: Maybe<Scalars['Boolean']>;
  literature?: Maybe<Scalars['String']>;
  lotNumber?: Maybe<Scalars['String']>;
  measurementUnits?: Maybe<Scalars['String']>;
  nextBid?: Maybe<Scalars['Float']>;
  purchaseOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  purchaseStatus?: Maybe<PurchaseStatus>;
  purchaseType?: Maybe<PurchaseType>;
  shippingFromAddress?: Maybe<GalleryAddressNode>;
  signatureInfo?: Maybe<Scalars['String']>;
  stamp?: Maybe<Scalars['String']>;
  startTimestamp?: Maybe<Scalars['Int']>;
  startingBid?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  transfersToLive?: Maybe<Scalars['Boolean']>;
};

export type ArtworkNode = Node & {
  __typename?: 'ArtworkNode';
  a8Id?: Maybe<Scalars['Int']>;
  additionalInfo?: Maybe<Scalars['String']>;
  addresses?: Maybe<GalleryAddressNodeConnection>;
  announceDate?: Maybe<Scalars['DateTime']>;
  artistFullName?: Maybe<Scalars['String']>;
  artistName: Scalars['String'];
  artistProof?: Maybe<Scalars['String']>;
  artistProofs?: Maybe<Scalars['String']>;
  artistSet?: Maybe<ArtistNodeConnection>;
  artistSlug?: Maybe<Scalars['String']>;
  artists?: Maybe<ArtistNodeConnection>;
  artworkInfo?: Maybe<ArtworkInfoNode>;
  artworkOrTourOrArtistImage?: Maybe<ArtworkImageNode>;
  auctionHighlight: Scalars['Boolean'];
  auctionSet?: Maybe<AuctionNodeConnection>;
  auctionataVcNumber?: Maybe<Scalars['String']>;
  auctions?: Maybe<AuctionNodeConnection>;
  autochargepreferenceSet?: Maybe<AutoChargePreferenceNodeConnection>;
  bidCount: Scalars['Int'];
  bidStatus?: Maybe<BidStatusNode>;
  bidlogSet?: Maybe<BidLogNodeConnection>;
  buyNow?: Maybe<Scalars['Float']>;
  cartitemSet?: Maybe<CartItemNodeConnection>;
  categories?: Maybe<StarCategoryNodeConnection>;
  category: ArtworkCategory;
  collectionSet?: Maybe<CollectionNodeConnection>;
  /** multiply this by the selling price to calculate the commission the vendor will receive */
  commissionMultiplier: Scalars['Float'];
  consigningOffice?: Maybe<Scalars['String']>;
  consignmentSignedAt?: Maybe<Scalars['DateTime']>;
  consignmentSource?: Maybe<UserNode>;
  consignmentType?: Maybe<Scalars['String']>;
  consignor?: Maybe<UserNode>;
  consignorAddress?: Maybe<GalleryAddressNode>;
  consignorEmail?: Maybe<Scalars['String']>;
  consignorName?: Maybe<Scalars['String']>;
  copy?: Maybe<Scalars['String']>;
  countryOfOrigin?: Maybe<ArtworkCountryOfOrigin>;
  countrySource?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  /** a string representing when the Artwork was created */
  creationDate?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  currentBid?: Maybe<Scalars['Float']>;
  deliveryNotes?: Maybe<Scalars['String']>;
  deliveryOptions?: Maybe<DeliveryOptionNodeConnection>;
  depth?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  dimensionNotes: Scalars['String'];
  dimensionsNa: Scalars['Boolean'];
  disablePromocodes?: Maybe<Scalars['Boolean']>;
  displayInAllArtworks: Scalars['Boolean'];
  /** used for media artwork like music and films */
  duration?: Maybe<Scalars['String']>;
  earliestAvailableDate?: Maybe<Scalars['Date']>;
  edition?: Maybe<Scalars['String']>;
  editionUnnumbered: Scalars['Boolean'];
  editions?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  entrySet?: Maybe<EntryNodeConnection>;
  estimatedValue?: Maybe<Scalars['Float']>;
  estimatedValueHigh: Scalars['Int'];
  estimatedValueLow: Scalars['Int'];
  eventExtendedStatus?: Maybe<Scalars['String']>;
  eventStartDate?: Maybe<Scalars['DateTime']>;
  eventStartDateLocal?: Maybe<Scalars['DateTime']>;
  eventStatus: ArtworkEventStatus;
  externalLink?: Maybe<Scalars['String']>;
  externalVipLink?: Maybe<Scalars['String']>;
  factSheet?: Maybe<FileNode>;
  featuredDate?: Maybe<Scalars['DateTime']>;
  featuringArtists?: Maybe<Array<Maybe<ArtistNode>>>;
  frameGlazing?: Maybe<Scalars['String']>;
  framed: Scalars['Boolean'];
  framedDepth?: Maybe<Scalars['Float']>;
  framedHeight?: Maybe<Scalars['Float']>;
  framedUnits?: Maybe<Scalars['String']>;
  framedWidth?: Maybe<Scalars['Float']>;
  gallery: GalleryNode;
  hasPackages?: Maybe<Scalars['Boolean']>;
  height?: Maybe<Scalars['Float']>;
  highestTicketsPrice?: Maybe<Scalars['Float']>;
  hsCode?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  images?: Maybe<ArtworkImageNodeConnection>;
  importStatus?: Maybe<Scalars['String']>;
  insuranceOptions: Scalars['String'];
  ipadOnly: Scalars['Boolean'];
  isAdultContent: Scalars['Boolean'];
  isBulkImported: Scalars['Boolean'];
  isEnded?: Maybe<Scalars['Boolean']>;
  isFeatured: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isPriceless: Scalars['Boolean'];
  isUnique: Scalars['Boolean'];
  lastAuction?: Maybe<AuctionNode>;
  lineItems?: Maybe<Scalars['String']>;
  listPrice?: Maybe<Scalars['Float']>;
  literature?: Maybe<Scalars['String']>;
  logisticsDepth?: Maybe<Scalars['Float']>;
  logisticsHeight?: Maybe<Scalars['Float']>;
  logisticsUnits?: Maybe<Scalars['String']>;
  logisticsWidth?: Maybe<Scalars['Float']>;
  lotNumber?: Maybe<Scalars['String']>;
  lowestTicketsPrice?: Maybe<Scalars['Float']>;
  mainArtist?: Maybe<ArtistNode>;
  marketingeventSet?: Maybe<MarketingEventNodeConnection>;
  mediumSet?: Maybe<MediumNodeConnection>;
  mediums?: Maybe<MediumNodeConnection>;
  meta?: Maybe<Scalars['String']>;
  moreArtworksByArtist?: Maybe<ArtworkNodeConnection>;
  moreArtworksFromAuction?: Maybe<ArtworkNodeConnection>;
  nextArtworkPk?: Maybe<Scalars['ID']>;
  nextBid?: Maybe<Scalars['Float']>;
  offerSet?: Maybe<OfferNodeConnection>;
  offers?: Maybe<OfferNodeConnection>;
  openEdition: Scalars['Boolean'];
  orderitemSet?: Maybe<OrderItemNodeConnection>;
  orders?: Maybe<Array<Maybe<OrderNode>>>;
  origin: Scalars['String'];
  packageInfo?: Maybe<Array<Maybe<PackageNode>>>;
  packageSet?: Maybe<PackageNodeConnection>;
  packages?: Maybe<PackageNodeConnection>;
  pieceCount?: Maybe<Scalars['Int']>;
  pk?: Maybe<Scalars['String']>;
  /** multiply this by the selling price for an additional premium that the buyer must pay */
  premiumMultiplier: Scalars['Float'];
  prevArtworkPk?: Maybe<Scalars['ID']>;
  primaryImage?: Maybe<ArtworkImageNode>;
  purchaseOptions: Scalars['String'];
  purchaseStatus?: Maybe<Scalars['String']>;
  pusherChannel?: Maybe<Scalars['String']>;
  relatedStories?: Maybe<EntryNodeConnection>;
  remainingMultiples?: Maybe<Scalars['Int']>;
  reservePrice?: Maybe<Scalars['Float']>;
  salesAs: ArtworkSalesAs;
  salesOffDateLocal?: Maybe<Scalars['DateTime']>;
  salesOnDateLocal?: Maybe<Scalars['DateTime']>;
  sharing?: Maybe<SharingNode>;
  shipOptions: Scalars['String'];
  shippingClass?: Maybe<Scalars['String']>;
  shippingCode?: Maybe<Scalars['String']>;
  shippingEnabled: Scalars['Boolean'];
  showArtistBio: Scalars['Boolean'];
  signature?: Maybe<Scalars['Boolean']>;
  signatureDescription?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  specialTerms?: Maybe<Scalars['String']>;
  specialist?: Maybe<Scalars['String']>;
  specialistSecondary?: Maybe<UserNode>;
  sponsoredBy?: Maybe<Scalars['String']>;
  sponsoredByLink?: Maybe<Scalars['String']>;
  stamped: Scalars['Boolean'];
  startDate?: Maybe<Scalars['DateTime']>;
  startingBid?: Maybe<Scalars['Float']>;
  status?: Maybe<ArtworkStatus>;
  subTitle: Scalars['String'];
  suppressDisplay: Scalars['Boolean'];
  taxExempt: Scalars['Boolean'];
  tevoId?: Maybe<Scalars['Int']>;
  tevoSeatingChartConfiguration?: Maybe<TevoEventConfigurationNode>;
  tevoTicketGroups?: Maybe<Array<Maybe<TevoTicketNode>>>;
  title: Scalars['String'];
  totalMultiples?: Maybe<Scalars['Int']>;
  tour?: Maybe<TourNode>;
  uniqueEdition: Scalars['Boolean'];
  units?: Maybe<Scalars['String']>;
  unsigned: Scalars['Boolean'];
  updated: Scalars['DateTime'];
  user?: Maybe<UserNode>;
  uuid?: Maybe<Scalars['String']>;
  /** If the artwork is not one solid piece,if has variable dimensions */
  variableDimensions: Scalars['Boolean'];
  vendorSku?: Maybe<Scalars['String']>;
  venue?: Maybe<VenueNode>;
  views: Scalars['Int'];
  watcherCount?: Maybe<Scalars['Int']>;
  watchers?: Maybe<UserNodeConnection>;
  weight?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};


export type ArtworkNodeAddressesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArtworkNodeArtistSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories_Contains?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  firstName_Istartswith?: InputMaybe<Scalars['String']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastName_Istartswith?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
};


export type ArtworkNodeArtistsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories_Contains?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  firstName_Istartswith?: InputMaybe<Scalars['String']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastName_Istartswith?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
};


export type ArtworkNodeAuctionSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  end_Gt?: InputMaybe<Scalars['DateTime']>;
  end_Gte?: InputMaybe<Scalars['DateTime']>;
  end_Lt?: InputMaybe<Scalars['DateTime']>;
  end_Lte?: InputMaybe<Scalars['DateTime']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  isLiveAuction?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  showOnAuctionIndex?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  start_Gt?: InputMaybe<Scalars['DateTime']>;
  start_Gte?: InputMaybe<Scalars['DateTime']>;
  start_Lt?: InputMaybe<Scalars['DateTime']>;
  start_Lte?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
};


export type ArtworkNodeAuctionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  end_Gt?: InputMaybe<Scalars['DateTime']>;
  end_Gte?: InputMaybe<Scalars['DateTime']>;
  end_Lt?: InputMaybe<Scalars['DateTime']>;
  end_Lte?: InputMaybe<Scalars['DateTime']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  isLiveAuction?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  showOnAuctionIndex?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  start_Gt?: InputMaybe<Scalars['DateTime']>;
  start_Gte?: InputMaybe<Scalars['DateTime']>;
  start_Lt?: InputMaybe<Scalars['DateTime']>;
  start_Lte?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
};


export type ArtworkNodeAutochargepreferenceSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Scalars['ID']>;
};


export type ArtworkNodeBidlogSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork_Id?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArtworkNodeCartitemSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArtworkNodeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isSearchable?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  parent_Name?: InputMaybe<Scalars['String']>;
};


export type ArtworkNodeCollectionSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['DateTime']>;
  created_Gt?: InputMaybe<Scalars['DateTime']>;
  created_Gte?: InputMaybe<Scalars['DateTime']>;
  created_Lt?: InputMaybe<Scalars['DateTime']>;
  created_Lte?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['DateTime']>;
  updated_Gt?: InputMaybe<Scalars['DateTime']>;
  updated_Gte?: InputMaybe<Scalars['DateTime']>;
  updated_Lt?: InputMaybe<Scalars['DateTime']>;
  updated_Lte?: InputMaybe<Scalars['DateTime']>;
};


export type ArtworkNodeDeliveryOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArtworkNodeEntrySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArtworkNodeImagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArtworkNodeMarketingeventSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
};


export type ArtworkNodeMediumSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArtworkNodeMediumsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArtworkNodeMoreArtworksByArtistArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  categoryWithChild_Exact?: InputMaybe<Scalars['String']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isEnded?: InputMaybe<Scalars['Boolean']>;
  isEventAnnounced?: InputMaybe<Scalars['Boolean']>;
  isEventStared?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isTransfersToLive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  purchaseType?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venueCoordinates?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type ArtworkNodeMoreArtworksFromAuctionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArtworkNodeOfferSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArtworkNodeOffersArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork?: InputMaybe<Scalars['ID']>;
  auction?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['DateTime']>;
  created_Gt?: InputMaybe<Scalars['DateTime']>;
  created_Gte?: InputMaybe<Scalars['DateTime']>;
  created_Lt?: InputMaybe<Scalars['DateTime']>;
  created_Lte?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  price_Gt?: InputMaybe<Scalars['Float']>;
  price_Gte?: InputMaybe<Scalars['Float']>;
  price_Lt?: InputMaybe<Scalars['Float']>;
  price_Lte?: InputMaybe<Scalars['Float']>;
};


export type ArtworkNodeOrderitemSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArtworkNodePackageInfoArgs = {
  status?: InputMaybe<Scalars['String']>;
};


export type ArtworkNodePackageSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArtworkNodePackagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArtworkNodeRelatedStoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ArtworkNodeTevoTicketGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type ArtworkNodeWatchersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email_Icontains?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  followedArtists_Slug?: InputMaybe<Scalars['String']>;
  followedArtists_Slug_In?: InputMaybe<Scalars['String']>;
  grantedorder_Orderitem_Artwork_Id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  registrationSource?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  type_In?: InputMaybe<Scalars['String']>;
};

export type ArtworkNodeConnection = {
  __typename?: 'ArtworkNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ArtworkNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type ArtworkNodeCountingConnection = {
  __typename?: 'ArtworkNodeCountingConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ArtworkNodeCountingEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ArtworkNodeCounting` and its cursor. */
export type ArtworkNodeCountingEdge = {
  __typename?: 'ArtworkNodeCountingEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ArtworkNode>;
};

/** A Relay edge containing a `ArtworkNode` and its cursor. */
export type ArtworkNodeEdge = {
  __typename?: 'ArtworkNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ArtworkNode>;
};

export enum ArtworkSalesAs {
  /** auction */
  Auction = 'AUCTION',
  /** buy_it_now_option */
  BuyItNowOption = 'BUY_IT_NOW_OPTION',
  /** giveaway */
  Giveaway = 'GIVEAWAY'
}

export type ArtworkSearchConnection = {
  __typename?: 'ArtworkSearchConnection';
  count?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ArtworkSearchEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  spellingSuggestions?: Maybe<Array<Maybe<SpellingSuggestionNode>>>;
};

/** A Relay edge containing a `ArtworkSearch` and its cursor. */
export type ArtworkSearchEdge = {
  __typename?: 'ArtworkSearchEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ArtworkSearchNode>;
};

export type ArtworkSearchInterface = {
  artists?: Maybe<Scalars['String']>;
  auctionPk?: Maybe<Scalars['Int']>;
  imageUrl?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  pk?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  tokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  url?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ArtworkSearchNode = ArtworkSearchInterface & Node & {
  __typename?: 'ArtworkSearchNode';
  artists?: Maybe<Scalars['String']>;
  artwork?: Maybe<ArtworkNode>;
  auctionPk?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  pk?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  tokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  url?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum ArtworkStatus {
  Deleted = 'deleted',
  Draft = 'draft',
  Private = 'private',
  Public = 'public'
}

export type AuctionArtworksNode = Node & {
  __typename?: 'AuctionArtworksNode';
  acceptsDonations: Scalars['Boolean'];
  allowColspans: Scalars['Boolean'];
  allowedCarriers?: Maybe<Scalars['String']>;
  artistsInfo?: Maybe<ArtistInfoNodeConnection>;
  artworksCount?: Maybe<Scalars['Int']>;
  benefitDescription: Scalars['String'];
  biddingIncrements?: Maybe<Scalars['String']>;
  briefDescription: Scalars['String'];
  catalog?: Maybe<FileNode>;
  checkoutOptions?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  copy?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  currency: Scalars['String'];
  customTaxLocale?: Maybe<Scalars['String']>;
  customTaxRate?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  donationInfo?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['DateTime']>;
  endTimestamp?: Maybe<Scalars['Int']>;
  eventCity?: Maybe<Scalars['String']>;
  eventContactEmail: Scalars['String'];
  eventContactPhone?: Maybe<Scalars['String']>;
  eventCountry?: Maybe<Scalars['String']>;
  eventEnd?: Maybe<Scalars['DateTime']>;
  eventInfo?: Maybe<EventNode>;
  eventState?: Maybe<Scalars['String']>;
  eventStreet?: Maybe<Scalars['String']>;
  eventTime?: Maybe<Scalars['DateTime']>;
  eventZipcode?: Maybe<Scalars['String']>;
  featured: Scalars['Int'];
  featuredDate?: Maybe<Scalars['DateTime']>;
  features?: Maybe<Scalars['String']>;
  formattedTitle?: Maybe<Scalars['String']>;
  gallery?: Maybe<GalleryNode>;
  hasHighlights: Scalars['Boolean'];
  hasLotNumbers: Scalars['Boolean'];
  hasReserves: Scalars['Boolean'];
  hasStaggeredEndTimes?: Maybe<Scalars['Boolean']>;
  hasValueRanges: Scalars['Boolean'];
  highlightCount: Scalars['Int'];
  houseSale: Scalars['Boolean'];
  /** The ID of the object. */
  id: Scalars['ID'];
  images?: Maybe<AuctionImageNodeConnection>;
  isLiveAuction: Scalars['Boolean'];
  isP8passEligible: Scalars['Boolean'];
  isPerpetual: Scalars['Boolean'];
  isThemedAuction: Scalars['Boolean'];
  manager?: Maybe<Scalars['String']>;
  paddleNumberLength: Scalars['Int'];
  pk?: Maybe<Scalars['String']>;
  posterCaption?: Maybe<Scalars['String']>;
  posterImageAttribution?: Maybe<Scalars['String']>;
  posterPreTitle?: Maybe<Scalars['String']>;
  primaryImageUrl?: Maybe<Scalars['String']>;
  pusherChannel?: Maybe<Scalars['String']>;
  redirectSlug: Scalars['String'];
  shippingManagers?: Maybe<Scalars['String']>;
  shippingPickupTerms?: Maybe<Scalars['String']>;
  showOnAuctionIndex: Scalars['Boolean'];
  slug: Scalars['String'];
  specialTerms?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  startTimestamp?: Maybe<Scalars['Int']>;
  status?: Maybe<AuctionStatus>;
  subNoticeStatus?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  suppressCheckoutLink: Scalars['Boolean'];
  ticketLink?: Maybe<Scalars['String']>;
  tileData?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
  venue: Scalars['String'];
  vignetteData?: Maybe<Scalars['String']>;
};


export type AuctionArtworksNodeArtistsInfoArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  pk?: InputMaybe<Scalars['Int']>;
};


export type AuctionArtworksNodeImagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type AuctionArtworksNodeCountingConnection = {
  __typename?: 'AuctionArtworksNodeCountingConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AuctionArtworksNodeCountingEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `AuctionArtworksNodeCounting` and its cursor. */
export type AuctionArtworksNodeCountingEdge = {
  __typename?: 'AuctionArtworksNodeCountingEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AuctionArtworksNode>;
};

export type AuctionImageNode = Node & {
  __typename?: 'AuctionImageNode';
  auctionSet?: Maybe<AuctionNodeConnection>;
  bucket: Scalars['String'];
  caption: Scalars['String'];
  created: Scalars['DateTime'];
  dominantColor?: Maybe<Scalars['String']>;
  dominantColors?: Maybe<Scalars['String']>;
  extension: Scalars['String'];
  height: Scalars['Int'];
  /** The ID of the object. */
  id: Scalars['ID'];
  inS3: Scalars['Boolean'];
  kind: Scalars['String'];
  mime: Scalars['String'];
  path: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  size: Scalars['Int'];
  slug: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  submitter: UserNode;
  title: Scalars['String'];
  updated: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  width: Scalars['Int'];
  zoomable: Scalars['Boolean'];
};


export type AuctionImageNodeAuctionSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  end_Gt?: InputMaybe<Scalars['DateTime']>;
  end_Gte?: InputMaybe<Scalars['DateTime']>;
  end_Lt?: InputMaybe<Scalars['DateTime']>;
  end_Lte?: InputMaybe<Scalars['DateTime']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  isLiveAuction?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  showOnAuctionIndex?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  start_Gt?: InputMaybe<Scalars['DateTime']>;
  start_Gte?: InputMaybe<Scalars['DateTime']>;
  start_Lt?: InputMaybe<Scalars['DateTime']>;
  start_Lte?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
};

export type AuctionImageNodeConnection = {
  __typename?: 'AuctionImageNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AuctionImageNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AuctionImageNode` and its cursor. */
export type AuctionImageNodeEdge = {
  __typename?: 'AuctionImageNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AuctionImageNode>;
};

export type AuctionNode = EntityWithArtworks & Node & {
  __typename?: 'AuctionNode';
  acceptsDonations: Scalars['Boolean'];
  allowColspans: Scalars['Boolean'];
  allowedCarriers?: Maybe<Scalars['String']>;
  artistsInfo?: Maybe<ArtistInfoNodeConnection>;
  artworkSet?: Maybe<ArtworkNodeConnection>;
  artworks?: Maybe<ArtworkNodeConnection>;
  benefitDescription: Scalars['String'];
  biddingIncrements?: Maybe<Scalars['String']>;
  briefDescription: Scalars['String'];
  catalog?: Maybe<FileNode>;
  checkoutOptions?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  copy?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  currency: Scalars['String'];
  customTaxLocale?: Maybe<Scalars['String']>;
  customTaxRate?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  donationInfo?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['DateTime']>;
  endTimestamp?: Maybe<Scalars['Int']>;
  entrySet?: Maybe<EntryNodeConnection>;
  eventCity?: Maybe<Scalars['String']>;
  eventContactEmail: Scalars['String'];
  eventContactPhone?: Maybe<Scalars['String']>;
  eventCountry?: Maybe<Scalars['String']>;
  eventEnd?: Maybe<Scalars['DateTime']>;
  eventInfo?: Maybe<EventNode>;
  eventState?: Maybe<Scalars['String']>;
  eventStreet?: Maybe<Scalars['String']>;
  eventTime?: Maybe<Scalars['DateTime']>;
  eventZipcode?: Maybe<Scalars['String']>;
  featured: Scalars['Int'];
  featuredDate?: Maybe<Scalars['DateTime']>;
  features?: Maybe<Scalars['String']>;
  formattedTitle?: Maybe<Scalars['String']>;
  gallery?: Maybe<GalleryNode>;
  hasHighlights: Scalars['Boolean'];
  hasLotNumbers: Scalars['Boolean'];
  hasReserves: Scalars['Boolean'];
  hasStaggeredEndTimes?: Maybe<Scalars['Boolean']>;
  hasValueRanges: Scalars['Boolean'];
  highlightCount: Scalars['Int'];
  houseSale: Scalars['Boolean'];
  /** The ID of the object. */
  id: Scalars['ID'];
  images?: Maybe<AuctionImageNodeConnection>;
  isLiveAuction: Scalars['Boolean'];
  isP8passEligible: Scalars['Boolean'];
  isPerpetual: Scalars['Boolean'];
  isThemedAuction: Scalars['Boolean'];
  manager?: Maybe<Scalars['String']>;
  offerSet?: Maybe<OfferNodeConnection>;
  paddleNumberLength: Scalars['Int'];
  pk?: Maybe<Scalars['String']>;
  posterCaption?: Maybe<Scalars['String']>;
  posterImageAttribution?: Maybe<Scalars['String']>;
  posterPreTitle?: Maybe<Scalars['String']>;
  primaryImageUrl?: Maybe<Scalars['String']>;
  pusherChannel?: Maybe<Scalars['String']>;
  redirectSlug: Scalars['String'];
  shippingManagers?: Maybe<Scalars['String']>;
  shippingPickupTerms?: Maybe<Scalars['String']>;
  showOnAuctionIndex: Scalars['Boolean'];
  slug: Scalars['String'];
  specialTerms?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['DateTime']>;
  startTimestamp?: Maybe<Scalars['Int']>;
  status?: Maybe<AuctionStatus>;
  subNoticeStatus?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  suppressCheckoutLink: Scalars['Boolean'];
  ticketLink?: Maybe<Scalars['String']>;
  tileData?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
  userSet?: Maybe<UserNodeConnection>;
  vignetteData?: Maybe<Scalars['String']>;
};


export type AuctionNodeArtistsInfoArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  pk?: InputMaybe<Scalars['Int']>;
};


export type AuctionNodeArtworkSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type AuctionNodeArtworksArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  categoryWithChild_Exact?: InputMaybe<Scalars['String']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isEnded?: InputMaybe<Scalars['Boolean']>;
  isEventAnnounced?: InputMaybe<Scalars['Boolean']>;
  isEventStared?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isTransfersToLive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  purchaseType?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venueCoordinates?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type AuctionNodeEntrySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type AuctionNodeImagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type AuctionNodeOfferSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork?: InputMaybe<Scalars['ID']>;
  auction?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['DateTime']>;
  created_Gt?: InputMaybe<Scalars['DateTime']>;
  created_Gte?: InputMaybe<Scalars['DateTime']>;
  created_Lt?: InputMaybe<Scalars['DateTime']>;
  created_Lte?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  price_Gt?: InputMaybe<Scalars['Float']>;
  price_Gte?: InputMaybe<Scalars['Float']>;
  price_Lt?: InputMaybe<Scalars['Float']>;
  price_Lte?: InputMaybe<Scalars['Float']>;
};


export type AuctionNodeUserSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email_Icontains?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  followedArtists_Slug?: InputMaybe<Scalars['String']>;
  followedArtists_Slug_In?: InputMaybe<Scalars['String']>;
  grantedorder_Orderitem_Artwork_Id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  registrationSource?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  type_In?: InputMaybe<Scalars['String']>;
};

export type AuctionNodeConnection = {
  __typename?: 'AuctionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AuctionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AuctionNode` and its cursor. */
export type AuctionNodeEdge = {
  __typename?: 'AuctionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AuctionNode>;
};

export type AuctionSearchConnection = {
  __typename?: 'AuctionSearchConnection';
  count?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AuctionSearchEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  spellingSuggestions?: Maybe<Array<Maybe<SpellingSuggestionNode>>>;
};

/** A Relay edge containing a `AuctionSearch` and its cursor. */
export type AuctionSearchEdge = {
  __typename?: 'AuctionSearchEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AuctionSearchNode>;
};

export type AuctionSearchInterface = {
  briefDescription?: Maybe<Scalars['String']>;
  endUtc?: Maybe<Scalars['Int']>;
  hasLotNumbers?: Maybe<Scalars['String']>;
  houseSale?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  isP8passEligible?: Maybe<Scalars['String']>;
  isThemedAuction?: Maybe<Scalars['Boolean']>;
  onAuctionIndex?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  posterImageAttribution?: Maybe<Scalars['String']>;
  posterImageUrl?: Maybe<Scalars['String']>;
  posterLogo?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  startUtc?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  tokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  url?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type AuctionSearchNode = AuctionSearchInterface & Node & {
  __typename?: 'AuctionSearchNode';
  auction?: Maybe<AuctionNode>;
  briefDescription?: Maybe<Scalars['String']>;
  endUtc?: Maybe<Scalars['Int']>;
  hasLotNumbers?: Maybe<Scalars['String']>;
  houseSale?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  isP8passEligible?: Maybe<Scalars['String']>;
  isThemedAuction?: Maybe<Scalars['Boolean']>;
  onAuctionIndex?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  posterImageAttribution?: Maybe<Scalars['String']>;
  posterImageUrl?: Maybe<Scalars['String']>;
  posterLogo?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  startUtc?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  tokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  url?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum AuctionStatus {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type AutoChargePreferenceNode = Node & {
  __typename?: 'AutoChargePreferenceNode';
  address?: Maybe<DestinationNode>;
  artwork: ArtworkNode;
  created: Scalars['DateTime'];
  creditCard?: Maybe<CreditCardNode>;
  /** The ID of the object. */
  id: Scalars['ID'];
  paymentSource: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  status: AutoChargePreferenceStatus;
  user: UserNode;
  userAddress: UserAddressNode;
};

export type AutoChargePreferenceNodeConnection = {
  __typename?: 'AutoChargePreferenceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AutoChargePreferenceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AutoChargePreferenceNode` and its cursor. */
export type AutoChargePreferenceNodeEdge = {
  __typename?: 'AutoChargePreferenceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AutoChargePreferenceNode>;
};

export enum AutoChargePreferenceStatus {
  /** Active */
  Active = 'ACTIVE',
  /** Deleted */
  Deleted = 'DELETED'
}

export type BidLogNode = Node & {
  __typename?: 'BidLogNode';
  amount: Scalars['Float'];
  artwork: ArtworkNode;
  created: Scalars['DateTime'];
  fromNauman?: Maybe<Scalars['Boolean']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  ipAddress?: Maybe<Scalars['String']>;
  ipadDescription?: Maybe<Scalars['String']>;
  ipadUuid?: Maybe<Scalars['String']>;
  offerSet?: Maybe<OfferNodeConnection>;
  pk?: Maybe<Scalars['String']>;
  shipping?: Maybe<ShippingNode>;
  source?: Maybe<BidLogSource>;
  sourceId?: Maybe<Scalars['String']>;
  user: UserNode;
};


export type BidLogNodeOfferSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork?: InputMaybe<Scalars['ID']>;
  auction?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['DateTime']>;
  created_Gt?: InputMaybe<Scalars['DateTime']>;
  created_Gte?: InputMaybe<Scalars['DateTime']>;
  created_Lt?: InputMaybe<Scalars['DateTime']>;
  created_Lte?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  price_Gt?: InputMaybe<Scalars['Float']>;
  price_Gte?: InputMaybe<Scalars['Float']>;
  price_Lt?: InputMaybe<Scalars['Float']>;
  price_Lte?: InputMaybe<Scalars['Float']>;
};

export type BidLogNodeConnection = {
  __typename?: 'BidLogNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BidLogNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `BidLogNode` and its cursor. */
export type BidLogNodeEdge = {
  __typename?: 'BidLogNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<BidLogNode>;
};

export enum BidLogSource {
  /** Iphone App */
  IphoneApp = 'IPHONE_APP',
  /** Kiosk */
  Kiosk = 'KIOSK',
  /** Mobile Web */
  MobileWeb = 'MOBILE_WEB',
  /** Web */
  Web = 'WEB'
}

export enum BidSources {
  IphoneApp = 'iphone_app',
  Kiosk = 'kiosk',
  MobileWeb = 'mobile_web',
  Web = 'web'
}

export type BidStatusInterface = {
  auctionCurrency?: Maybe<Scalars['String']>;
  bidCount?: Maybe<Scalars['Int']>;
  buyNowPrice?: Maybe<Scalars['String']>;
  buyNowPriceRaw?: Maybe<Scalars['Float']>;
  canBid?: Maybe<Scalars['Boolean']>;
  canBuyNow?: Maybe<Scalars['Boolean']>;
  currentBidDisplay?: Maybe<Scalars['String']>;
  currentBidRaw?: Maybe<Scalars['Float']>;
  hammerPrice?: Maybe<Scalars['String']>;
  hammerPriceRaw?: Maybe<Scalars['Float']>;
  minNextBid?: Maybe<Scalars['String']>;
  minNextBidRaw?: Maybe<Scalars['Float']>;
  pk?: Maybe<Scalars['Int']>;
  pusherChannel?: Maybe<Scalars['String']>;
  remainingMultiples?: Maybe<Scalars['Int']>;
  reserveCopy?: Maybe<Scalars['String']>;
  sortablePrice?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  suppressCheckoutLink?: Maybe<Scalars['Boolean']>;
  userBidIsLeadingBid?: Maybe<Scalars['Boolean']>;
  userHasPaid?: Maybe<Scalars['Boolean']>;
  userHighBid?: Maybe<Scalars['String']>;
  userHighBidRaw?: Maybe<Scalars['Float']>;
  userIsWinner?: Maybe<Scalars['Boolean']>;
};

export type BidStatusNode = BidStatusInterface & Node & {
  __typename?: 'BidStatusNode';
  auctionCurrency?: Maybe<Scalars['String']>;
  bidCount?: Maybe<Scalars['Int']>;
  buyNowPrice?: Maybe<Scalars['String']>;
  buyNowPriceRaw?: Maybe<Scalars['Float']>;
  canBid?: Maybe<Scalars['Boolean']>;
  canBuyNow?: Maybe<Scalars['Boolean']>;
  currentBidDisplay?: Maybe<Scalars['String']>;
  currentBidRaw?: Maybe<Scalars['Float']>;
  hammerPrice?: Maybe<Scalars['String']>;
  hammerPriceRaw?: Maybe<Scalars['Float']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  minNextBid?: Maybe<Scalars['String']>;
  minNextBidRaw?: Maybe<Scalars['Float']>;
  pk?: Maybe<Scalars['Int']>;
  pusherChannel?: Maybe<Scalars['String']>;
  remainingMultiples?: Maybe<Scalars['Int']>;
  reserveCopy?: Maybe<Scalars['String']>;
  sortablePrice?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  suppressCheckoutLink?: Maybe<Scalars['Boolean']>;
  userBidIsLeadingBid?: Maybe<Scalars['Boolean']>;
  userHasPaid?: Maybe<Scalars['Boolean']>;
  userHighBid?: Maybe<Scalars['String']>;
  userHighBidRaw?: Maybe<Scalars['Float']>;
  userIsWinner?: Maybe<Scalars['Boolean']>;
};

/** An error occurred while buying. Please try again. */
export type BuyNowFailure = {
  __typename?: 'BuyNowFailure';
  data?: Maybe<BuyNowResponseNode>;
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type BuyNowInput = {
  artworkId?: InputMaybe<Scalars['ID']>;
  bidSource: BidSources;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type BuyNowResponseInterface = {
  artworkId?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  offerId?: Maybe<Scalars['Int']>;
  remainingMultiples?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
};

export type BuyNowResponseNode = BuyNowResponseInterface & {
  __typename?: 'BuyNowResponseNode';
  artworkId?: Maybe<Scalars['Int']>;
  message?: Maybe<Scalars['String']>;
  offerId?: Maybe<Scalars['Int']>;
  remainingMultiples?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
};

export type BuyNowResult = BuyNowFailure | BuyNowSuccess;

export type BuyNowSuccess = {
  __typename?: 'BuyNowSuccess';
  artwork?: Maybe<ArtworkNode>;
  data?: Maybe<BuyNowResponseNode>;
  offer?: Maybe<OfferNode>;
};

export type CalculateTotalCostFailure = {
  __typename?: 'CalculateTotalCostFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type CalculateTotalCostResult = CalculateTotalCostFailure | CalculateTotalCostSuccess;

export type CalculateTotalCostSuccess = {
  __typename?: 'CalculateTotalCostSuccess';
  totalCost?: Maybe<TotalCostNode>;
};

export type CancelCartInput = {
  cartId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** There was an error canceling Setup Intent. Please try again. */
export type CancelSetupIntentFailure = {
  __typename?: 'CancelSetupIntentFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type CancelSetupIntentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type CancelSetupIntentResult = CancelSetupIntentFailure | CancelSetupIntentSuccess;

export type CancelSetupIntentSuccess = {
  __typename?: 'CancelSetupIntentSuccess';
  setupIntentId?: Maybe<Scalars['String']>;
};

export type CartItemNode = Node & {
  __typename?: 'CartItemNode';
  artwork: ArtworkNode;
  cart: CartNode;
  createdAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  localPrice?: Maybe<LocalPriceNode>;
  package?: Maybe<PackageNode>;
  pk?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  quantity: Scalars['Int'];
  removed: Scalars['Boolean'];
  tevoTicketGroup?: Maybe<TevoTicketNode>;
  tevoTicketGroupId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type CartItemNodeLocalPriceArgs = {
  currency?: InputMaybe<Scalars['String']>;
};

export type CartItemNodeConnection = {
  __typename?: 'CartItemNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CartItemNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CartItemNode` and its cursor. */
export type CartItemNodeEdge = {
  __typename?: 'CartItemNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CartItemNode>;
};

export type CartMutationFailure = {
  __typename?: 'CartMutationFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type CartMutationResult = CartMutationFailure | CartMutationSuccess;

export type CartMutationSuccess = {
  __typename?: 'CartMutationSuccess';
  cart?: Maybe<CartNode>;
};

export type CartNode = Node & {
  __typename?: 'CartNode';
  cartitemSet?: Maybe<CartItemNodeConnection>;
  createdAt: Scalars['DateTime'];
  deliveryOption?: Maybe<Scalars['String']>;
  grantedorderSet?: Maybe<GrantedOrderNodeConnection>;
  /** The ID of the object. */
  id: Scalars['ID'];
  items?: Maybe<Array<Maybe<CartItemNode>>>;
  pk?: Maybe<Scalars['String']>;
  retargetCount: Scalars['Int'];
  status: CartStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId: Scalars['Int'];
};


export type CartNodeCartitemSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type CartNodeGrantedorderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']>;
  deliveryOption_Type?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderitem_Artwork_Id?: InputMaybe<Scalars['ID']>;
  orderitem_Package_Isnull?: InputMaybe<Scalars['Boolean']>;
  shipping_Email?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  user_Email?: InputMaybe<Scalars['String']>;
};

export enum CartStatus {
  /** active */
  Active = 'ACTIVE',
  /** canceled */
  Canceled = 'CANCELED',
  /** expired */
  Expired = 'EXPIRED',
  /** used_for_order */
  UsedForOrder = 'USED_FOR_ORDER'
}

export type CategoryInput = {
  id: Scalars['ID'];
  imageId?: InputMaybe<Scalars['ID']>;
  isSearchable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
};

export type CheckVerificationCodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  optIn?: InputMaybe<Scalars['Boolean']>;
  phoneNumber: Scalars['String'];
};

export type CityNode = Node & {
  __typename?: 'CityNode';
  country: Scalars['String'];
  county?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  lat: Scalars['Float'];
  lon: Scalars['Float'];
  name: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  population?: Maybe<Scalars['Int']>;
  state: Scalars['String'];
  stateCode?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type CityNodeConnection = {
  __typename?: 'CityNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CityNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CityNode` and its cursor. */
export type CityNodeEdge = {
  __typename?: 'CityNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CityNode>;
};

export type CollectionNode = Node & {
  __typename?: 'CollectionNode';
  artworks?: Maybe<ArtworkNodeConnection>;
  created: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  name: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  status: CollectionStatus;
  updated: Scalars['DateTime'];
  user: UserNode;
};


export type CollectionNodeArtworksArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};

export type CollectionNodeConnection = {
  __typename?: 'CollectionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CollectionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CollectionNode` and its cursor. */
export type CollectionNodeEdge = {
  __typename?: 'CollectionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CollectionNode>;
};

export enum CollectionNodeStatus {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum CollectionStatus {
  /** deleted */
  Deleted = 'DELETED',
  /** private */
  Private = 'PRIVATE',
  /** public */
  Public = 'PUBLIC'
}

export type CompanyAddress = {
  address: Scalars['String'];
  city: Scalars['String'];
  country: Countries;
  name: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  zipcode: Scalars['String'];
};

export type ConsignArtworkFailure = {
  __typename?: 'ConsignArtworkFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type ConsignArtworkInput = {
  artist: Scalars['String'];
  category: Scalars['String'];
  city: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  considerForSale: Scalars['Boolean'];
  country: Scalars['String'];
  depth?: InputMaybe<Scalars['Int']>;
  edition?: InputMaybe<Scalars['String']>;
  height: Scalars['Int'];
  medium?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  ownsWork: Scalars['Boolean'];
  provenance?: InputMaybe<Scalars['String']>;
  signed: Scalars['Boolean'];
  state?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  units: Scalars['String'];
  width: Scalars['Int'];
  year?: InputMaybe<Scalars['String']>;
};

export type ConsignArtworkResult = ConsignArtworkFailure | ConsignArtworkSuccess;

export type ConsignArtworkSuccess = {
  __typename?: 'ConsignArtworkSuccess';
  artwork?: Maybe<ArtworkNode>;
};

export type ContactData = {
  city?: InputMaybe<Scalars['String']>;
  customFields?: InputMaybe<CustomFields>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  stateProvinceRegion?: InputMaybe<Scalars['String']>;
};

export type ContactMutationFailure = {
  __typename?: 'ContactMutationFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type ContactMutationResult = ContactMutationFailure | ContactMutationSuccess;

export type ContactMutationSuccess = {
  __typename?: 'ContactMutationSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export enum Countries {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export enum Country {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export type CreateAuctionInput = {
  announceDate?: InputMaybe<Scalars['DateTime']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryNotes?: InputMaybe<Scalars['String']>;
  deliveryOption: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  eventStartDate?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal?: InputMaybe<Scalars['DateTime']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  meta?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  starId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['DateTime'];
  startingBid: Scalars['Int'];
  status?: InputMaybe<Scalars['String']>;
  subTitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  tourId?: InputMaybe<Scalars['ID']>;
  venueId: Scalars['ID'];
};

export type CreateCartInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  packageId?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
  tevoTicketGroupId?: InputMaybe<Scalars['ID']>;
};

export type CreateCheckoutOrderInput = {
  cartId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  credit?: InputMaybe<Scalars['Float']>;
  marketingData?: InputMaybe<Scalars['GenericScalar']>;
  promocode?: InputMaybe<Scalars['String']>;
  protechtQuoteToken?: InputMaybe<Scalars['String']>;
  shipping: Shipping;
  withOptIn?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCollectionInput = {
  artworks?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  status: CollectionNodeStatus;
};

export type CreateCollectionPayload = {
  __typename?: 'CreateCollectionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  collection?: Maybe<CollectionNode>;
};

export type CreateCreditActionTypeInput = {
  amount?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type CreateEventInput = {
  announceDate?: InputMaybe<Scalars['DateTime']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventStartDate?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal: Scalars['DateTime'];
  externalLink?: InputMaybe<Scalars['String']>;
  externalVipLink?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuringStarIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  meta?: InputMaybe<Scalars['String']>;
  salesOffDateLocal?: InputMaybe<Scalars['DateTime']>;
  salesOnDateLocal?: InputMaybe<Scalars['DateTime']>;
  starId: Scalars['ID'];
  status?: InputMaybe<Scalars['String']>;
  subTitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  tourId?: InputMaybe<Scalars['ID']>;
  venueId: Scalars['ID'];
};

/** An error occurred while creating the artwork */
export type CreateGalleryArtworkFailure = {
  __typename?: 'CreateGalleryArtworkFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type CreateGalleryArtworkInput = {
  additionalInfoText?: InputMaybe<Scalars['String']>;
  artistBiography?: InputMaybe<Scalars['String']>;
  artistId?: InputMaybe<Scalars['ID']>;
  artistProof?: InputMaybe<Scalars['String']>;
  artistProofs?: InputMaybe<Scalars['String']>;
  auctionId?: InputMaybe<Scalars['ID']>;
  buyNow?: InputMaybe<Scalars['Float']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  creationDate?: InputMaybe<Scalars['String']>;
  depth?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  dimensionNotes?: InputMaybe<Scalars['String']>;
  dimensionsType?: InputMaybe<DimensionType>;
  displayAddress?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  earliestDateForShipmentTimestamp?: InputMaybe<Scalars['Int']>;
  edition?: InputMaybe<Scalars['String']>;
  editionUnnumbered?: InputMaybe<Scalars['Boolean']>;
  editions?: InputMaybe<Scalars['String']>;
  electronicDelivery?: InputMaybe<Scalars['Boolean']>;
  endType?: InputMaybe<EndType>;
  estimatedValue?: InputMaybe<Scalars['Float']>;
  factSheetPk?: InputMaybe<Scalars['Int']>;
  framed?: InputMaybe<Scalars['Boolean']>;
  framedDepth?: InputMaybe<Scalars['Float']>;
  framedHeight?: InputMaybe<Scalars['Float']>;
  framedUnits?: InputMaybe<DimensionUnit>;
  framedWidth?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  imagePks?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isAdultContent?: InputMaybe<Scalars['Boolean']>;
  isSigned?: InputMaybe<Scalars['Boolean']>;
  isUnique?: InputMaybe<Scalars['Boolean']>;
  literature?: InputMaybe<Scalars['String']>;
  mediumId?: InputMaybe<Scalars['ID']>;
  openEdition?: InputMaybe<Scalars['Boolean']>;
  priceless?: InputMaybe<Scalars['Boolean']>;
  primaryImagePk?: InputMaybe<Scalars['Int']>;
  purchaseStatus?: InputMaybe<PurchaseStatus>;
  purchaseType?: InputMaybe<PurchaseType>;
  shippingFromAddressId?: InputMaybe<Scalars['ID']>;
  signatureDescription?: InputMaybe<Scalars['String']>;
  sponsoredBy?: InputMaybe<Scalars['String']>;
  sponsoredByLink?: InputMaybe<Scalars['String']>;
  startingBid?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<ArtworkStatus>;
  title: Scalars['String'];
  units?: InputMaybe<DimensionUnit>;
  weight?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type CreateGalleryArtworkResult = CreateGalleryArtworkFailure | CreateGalleryArtworkSuccess;

export type CreateGalleryArtworkSuccess = {
  __typename?: 'CreateGalleryArtworkSuccess';
  artwork?: Maybe<ArtworkNode>;
};

export type CreateGrantedWebSectionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type CreateGrantedWebSettingsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreateMarketingEventFailure = {
  __typename?: 'CreateMarketingEventFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type CreateMarketingEventInput = {
  artworkIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  template: Scalars['String'];
  title: Scalars['String'];
};

export type CreateMarketingEventResult = CreateMarketingEventFailure | CreateMarketingEventSuccess;

export type CreateMarketingEventSuccess = {
  __typename?: 'CreateMarketingEventSuccess';
  marketingEvent?: Maybe<MarketingEventNode>;
};

export type CreateOfferFromBidLogInput = {
  bidLogId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateOrderFromOfferInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  offerId: Scalars['ID'];
  shipping?: InputMaybe<Shipping>;
  source: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type CreatePackageInput = {
  artworkId?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryNotes?: InputMaybe<Scalars['String']>;
  deliveryOption: Scalars['ID'];
  forTour?: InputMaybe<Scalars['Boolean']>;
  imageId?: InputMaybe<Scalars['Int']>;
  isTicket?: InputMaybe<Scalars['Boolean']>;
  longDescription?: InputMaybe<Scalars['String']>;
  manyArtworks?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  maxSplit: Scalars['Int'];
  minSplit: Scalars['Int'];
  name: Scalars['String'];
  price: Scalars['Int'];
  quantity: Scalars['Int'];
  shortDescription: Scalars['String'];
};

export type CreatePackageResult = CreatePackageSuccess | UpdatePackageFailure;

export type CreatePackageSuccess = {
  __typename?: 'CreatePackageSuccess';
  package?: Maybe<Array<Maybe<PackageNode>>>;
};

export type CreatePromocodeInput = {
  amount: Scalars['Int'];
  automaticApply?: InputMaybe<Scalars['Boolean']>;
  channels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  type: Scalars['String'];
  uses: Scalars['Int'];
};

export type CreateRefundInput = {
  amountCents?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
};

export type CreateRefundResult = CreateRefundSuccess | MutationError;

export type CreateRefundSuccess = {
  __typename?: 'CreateRefundSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

/** There was an error creating Setup Intent. Please try again. */
export type CreateSetupIntentFailure = {
  __typename?: 'CreateSetupIntentFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type CreateSetupIntentInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type CreateSetupIntentResult = CreateSetupIntentFailure | CreateSetupIntentSuccess;

export type CreateSetupIntentSuccess = {
  __typename?: 'CreateSetupIntentSuccess';
  setupIntentClientSecret?: Maybe<Scalars['String']>;
  setupIntentId?: Maybe<Scalars['String']>;
};

export type CreateStarCategoryFailure = {
  __typename?: 'CreateStarCategoryFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type CreateStarCategoryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  imageId?: InputMaybe<Scalars['ID']>;
  isSearchable?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['ID']>;
  position?: InputMaybe<Scalars['Int']>;
};

export type CreateStarCategoryResult = CreateStarCategoryFailure | CreateStarCategorySuccess;

export type CreateStarCategorySuccess = {
  __typename?: 'CreateStarCategorySuccess';
  starCategory?: Maybe<StarCategoryNode>;
};

export type CreateStarInput = {
  bio?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  fileId?: InputMaybe<Scalars['ID']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  meta?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type CreateTourFailure = {
  __typename?: 'CreateTourFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type CreateTourInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  tourPhotoId?: InputMaybe<Scalars['ID']>;
};

export type CreateTourResult = CreateTourFailure | CreateTourSuccess;

export type CreateTourSuccess = {
  __typename?: 'CreateTourSuccess';
  tour?: Maybe<TourNode>;
};

export type CreateVenueFailure = {
  __typename?: 'CreateVenueFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type CreateVenueInput = {
  city: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  lat: Scalars['String'];
  lon: Scalars['String'];
  name: Scalars['String'];
  state: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  streetAddress: Scalars['String'];
  timeZone: Scalars['String'];
  venuePhotoId?: InputMaybe<Scalars['ID']>;
  zip: Scalars['String'];
};

export type CreateVenueResult = CreateVenueFailure | CreateVenueSuccess;

export type CreateVenueSuccess = {
  __typename?: 'CreateVenueSuccess';
  venue?: Maybe<VenueNode>;
};

export type CreditActionTypeCreateResult = CreditActionTypeNode | MutationError;

export type CreditActionTypeNode = Node & {
  __typename?: 'CreditActionTypeNode';
  amount?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  credithistorySet?: Maybe<CreditHistoryNodeConnection>;
  description: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  isDisabled: Scalars['Boolean'];
  pk?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type CreditActionTypeNodeCredithistorySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type CreditActionTypeNodeConnection = {
  __typename?: 'CreditActionTypeNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CreditActionTypeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CreditActionTypeNode` and its cursor. */
export type CreditActionTypeNodeEdge = {
  __typename?: 'CreditActionTypeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CreditActionTypeNode>;
};

export type CreditCardNode = Node & {
  __typename?: 'CreditCardNode';
  brand?: Maybe<Scalars['String']>;
  cardId?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['Int']>;
  expYear?: Maybe<Scalars['Int']>;
  funding?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  last4?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CreditHistoryAdditionalData = ArtistNode | GrantedOrderNode | VenueNode;

export type CreditHistoryNode = Node & {
  __typename?: 'CreditHistoryNode';
  actionType: CreditActionTypeNode;
  amount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  data?: Maybe<CreditHistoryAdditionalData>;
  /** The ID of the object. */
  id: Scalars['ID'];
  pk?: Maybe<Scalars['String']>;
  summedAmount: Scalars['Float'];
  uid?: Maybe<Scalars['Int']>;
  user: UserNode;
};

export type CreditHistoryNodeConnection = {
  __typename?: 'CreditHistoryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CreditHistoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type CreditHistoryNodeCountingConnection = {
  __typename?: 'CreditHistoryNodeCountingConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CreditHistoryNodeCountingEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CreditHistoryNodeCounting` and its cursor. */
export type CreditHistoryNodeCountingEdge = {
  __typename?: 'CreditHistoryNodeCountingEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CreditHistoryNode>;
};

/** A Relay edge containing a `CreditHistoryNode` and its cursor. */
export type CreditHistoryNodeEdge = {
  __typename?: 'CreditHistoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CreditHistoryNode>;
};

export enum Currency {
  Aud = 'AUD',
  Brl = 'BRL',
  Cad = 'CAD',
  Chf = 'CHF',
  Cny = 'CNY',
  Eur = 'EUR',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Inr = 'INR',
  Jpy = 'JPY',
  Nok = 'NOK',
  Sgd = 'SGD',
  Usd = 'USD',
  Zar = 'ZAR'
}

export type CustomFields = {
  e8T?: InputMaybe<Scalars['String']>;
  e10T?: InputMaybe<Scalars['String']>;
};

export type DeleteAuctionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type DeleteCollectionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['ID']>;
};

export type DeleteCollectionPayload = {
  __typename?: 'DeleteCollectionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  collection?: Maybe<CollectionNode>;
};

export type DeleteEventInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** There was an error deleting your featured_storefront. Please try again. */
export type DeleteFeaturedStorefrontFailure = {
  __typename?: 'DeleteFeaturedStorefrontFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type DeleteFeaturedStorefrontInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  pk: Scalars['Int'];
};

export type DeleteFeaturedStorefrontResult = DeleteFeaturedStorefrontFailure | DeleteFeaturedStorefrontSuccess;

export type DeleteFeaturedStorefrontSuccess = {
  __typename?: 'DeleteFeaturedStorefrontSuccess';
  featuredStorefront?: Maybe<FeaturedStorefrontNode>;
};

export type DeleteGrantedWebSectionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type DeleteGrantedWebSettingsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type DeleteMarketingEventFailure = {
  __typename?: 'DeleteMarketingEventFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type DeleteMarketingEventInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type DeleteMarketingEventResult = DeleteMarketingEventFailure | DeleteMarketingEventSuccess;

export type DeleteMarketingEventSuccess = {
  __typename?: 'DeleteMarketingEventSuccess';
  marketingEvent?: Maybe<MarketingEventNode>;
};

export type DeletePackageInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type DeleteStarInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type DeleteTourInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type DeleteVenueInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type DeliveryOptionNode = Node & {
  __typename?: 'DeliveryOptionNode';
  artworkSet?: Maybe<ArtworkNodeConnection>;
  grantedorderSet?: Maybe<GrantedOrderNodeConnection>;
  /** The ID of the object. */
  id: Scalars['ID'];
  packageSet?: Maybe<PackageNodeConnection>;
  pk?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};


export type DeliveryOptionNodeArtworkSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type DeliveryOptionNodeGrantedorderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']>;
  deliveryOption_Type?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderitem_Artwork_Id?: InputMaybe<Scalars['ID']>;
  orderitem_Package_Isnull?: InputMaybe<Scalars['Boolean']>;
  shipping_Email?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  user_Email?: InputMaybe<Scalars['String']>;
};


export type DeliveryOptionNodePackageSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type DeliveryOptionNodeConnection = {
  __typename?: 'DeliveryOptionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DeliveryOptionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DeliveryOptionNode` and its cursor. */
export type DeliveryOptionNodeEdge = {
  __typename?: 'DeliveryOptionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DeliveryOptionNode>;
};

export type DestinationNode = Node & {
  __typename?: 'DestinationNode';
  autochargepreferenceSet?: Maybe<AutoChargePreferenceNodeConnection>;
  city: Scalars['String'];
  country: AddressCountry;
  created: Scalars['DateTime'];
  createdByUser?: Maybe<UserNode>;
  default: Scalars['Boolean'];
  deleted: Scalars['Boolean'];
  /** The ID of the object. */
  id: Scalars['ID'];
  kind: AddressKind;
  label?: Maybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  offerSet?: Maybe<OfferNodeConnection>;
  orderSet?: Maybe<OrderNodeConnection>;
  ownerId: Scalars['Int'];
  ownerType: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status: AddressStatus;
  updated: Scalars['DateTime'];
  visibleInAddressbook: Scalars['Boolean'];
};


export type DestinationNodeAutochargepreferenceSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Scalars['ID']>;
};


export type DestinationNodeOfferSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork?: InputMaybe<Scalars['ID']>;
  auction?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['DateTime']>;
  created_Gt?: InputMaybe<Scalars['DateTime']>;
  created_Gte?: InputMaybe<Scalars['DateTime']>;
  created_Lt?: InputMaybe<Scalars['DateTime']>;
  created_Lte?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  price_Gt?: InputMaybe<Scalars['Float']>;
  price_Gte?: InputMaybe<Scalars['Float']>;
  price_Lt?: InputMaybe<Scalars['Float']>;
  price_Lte?: InputMaybe<Scalars['Float']>;
};


export type DestinationNodeOrderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  shippingJobStatus?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ID']>;
};

export enum DeviceType {
  Android = 'android',
  Ios = 'ios',
  Web = 'web'
}

export enum DimensionType {
  DimensionsNa = 'dimensionsNa',
  StandardDimensions = 'standardDimensions',
  VariableDimensions = 'variableDimensions'
}

export enum DimensionUnit {
  Cm = 'cm',
  In = 'in',
  Mm = 'mm'
}

export type DjangoDebug = {
  __typename?: 'DjangoDebug';
  sql?: Maybe<Array<Maybe<DjangoDebugSql>>>;
};

export type DjangoDebugSql = {
  __typename?: 'DjangoDebugSQL';
  alias?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Float']>;
  encoding?: Maybe<Scalars['String']>;
  isSelect?: Maybe<Scalars['Boolean']>;
  isSlow?: Maybe<Scalars['Boolean']>;
  isoLevel?: Maybe<Scalars['String']>;
  params?: Maybe<Scalars['String']>;
  rawSql?: Maybe<Scalars['String']>;
  sql?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['Float']>;
  stopTime?: Maybe<Scalars['Float']>;
  transId?: Maybe<Scalars['String']>;
  transStatus?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
};

export enum EndType {
  EndsOnline = 'endsOnline',
  TransfersToLive = 'transfersToLive'
}

/** There was an error submitting your entry. Please try again. */
export type EnterSweepstakesFailure = {
  __typename?: 'EnterSweepstakesFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type EnterSweepstakesInput = {
  addressPk: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type EnterSweepstakesResult = EnterSweepstakesFailure | EnterSweepstakesSuccess;

export type EnterSweepstakesSuccess = {
  __typename?: 'EnterSweepstakesSuccess';
  result?: Maybe<Scalars['Boolean']>;
};

export type EntityWithArtworks = {
  artworks?: Maybe<ArtworkNodeConnection>;
};


export type EntityWithArtworksArtworksArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  categoryWithChild_Exact?: InputMaybe<Scalars['String']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isEnded?: InputMaybe<Scalars['Boolean']>;
  isEventAnnounced?: InputMaybe<Scalars['Boolean']>;
  isEventStared?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isTransfersToLive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  purchaseType?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venueCoordinates?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};

export enum EntryCategory {
  /** Pull Quote */
  PullQuote = 'PULL_QUOTE',
  /** Story */
  Story = 'STORY'
}

export type EntryImageNode = Node & {
  __typename?: 'EntryImageNode';
  bucket: Scalars['String'];
  caption: Scalars['String'];
  created: Scalars['DateTime'];
  dominantColor?: Maybe<Scalars['String']>;
  dominantColors?: Maybe<Scalars['String']>;
  entrySet?: Maybe<EntryNodeConnection>;
  extension: Scalars['String'];
  height: Scalars['Int'];
  /** The ID of the object. */
  id: Scalars['ID'];
  inS3: Scalars['Boolean'];
  kind: Scalars['String'];
  mime: Scalars['String'];
  path: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  processStatus: ImageProcessStatus;
  size: Scalars['Int'];
  slug: Scalars['String'];
  status: FileStatus;
  submitter: UserNode;
  title: Scalars['String'];
  updated: Scalars['DateTime'];
  width: Scalars['Int'];
  zoomable: Scalars['Boolean'];
};


export type EntryImageNodeEntrySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type EntryImageNodeConnection = {
  __typename?: 'EntryImageNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EntryImageNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EntryImageNode` and its cursor. */
export type EntryImageNodeEdge = {
  __typename?: 'EntryImageNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EntryImageNode>;
};

export type EntryNode = Node & {
  __typename?: 'EntryNode';
  artists?: Maybe<ArtistNodeConnection>;
  artworks?: Maybe<ArtworkNodeConnection>;
  auction?: Maybe<AuctionNode>;
  /** URL to an image to appear in the auction grid */
  auctionGridImage?: Maybe<Scalars['String']>;
  author: Scalars['String'];
  category: EntryCategory;
  created: Scalars['DateTime'];
  date: Scalars['Date'];
  heroTitle: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  images?: Maybe<EntryImageNodeConnection>;
  includeOnIndex: Scalars['Boolean'];
  indexHero?: Maybe<Scalars['Int']>;
  /** URL to either an image for editorial index */
  indexImage?: Maybe<Scalars['String']>;
  indexImageAttribution?: Maybe<Scalars['String']>;
  isEvergreen: Scalars['Boolean'];
  isFeatured: Scalars['Boolean'];
  /** Type of post; interview, video, story, etc. */
  kind: Scalars['String'];
  legacySlug?: Maybe<Scalars['String']>;
  medium?: Maybe<MediumNode>;
  pk?: Maybe<Scalars['String']>;
  /** Use the markdown syntax for formatting. Reference this <a href="http://blog.lib.umn.edu/crosb002/leadership/Markdown_Cheat_Sheet.pdf">cheatsheet</a> for examples. */
  primaryContent: Scalars['String'];
  /** URL for an image or vimeo video (e.g. https://vimeo.com/VID_ID) */
  primaryMedia?: Maybe<Scalars['String']>;
  pullQuoteAuthorTitle?: Maybe<Scalars['String']>;
  /** Use the markdown syntax for formatting. Reference this <a href="http://blog.lib.umn.edu/crosb002/leadership/Markdown_Cheat_Sheet.pdf">cheatsheet</a> for examples. */
  secondaryContent: Scalars['String'];
  slug: Scalars['String'];
  status: EntryStatus;
  title: Scalars['String'];
  updated: Scalars['DateTime'];
};


export type EntryNodeArtistsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories_Contains?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  firstName_Istartswith?: InputMaybe<Scalars['String']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastName_Istartswith?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
};


export type EntryNodeArtworksArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type EntryNodeImagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type EntryNodeConnection = {
  __typename?: 'EntryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EntryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EntryNode` and its cursor. */
export type EntryNodeEdge = {
  __typename?: 'EntryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EntryNode>;
};

export enum EntryStatus {
  /** Deleted */
  Deleted = 'DELETED',
  /** Private */
  Private = 'PRIVATE',
  /** Public */
  Public = 'PUBLIC'
}

export type EventAddressNode = {
  __typename?: 'EventAddressNode';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type EventNode = {
  __typename?: 'EventNode';
  address?: Maybe<EventAddressNode>;
  contactEmail?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  endTimestamp?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['String']>;
  startTimestamp?: Maybe<Scalars['Int']>;
  ticketLink?: Maybe<Scalars['String']>;
  venueName?: Maybe<Scalars['String']>;
};

export type EventSearchResultNode = {
  __typename?: 'EventSearchResultNode';
  city?: Maybe<Scalars['String']>;
  eventStartDateLocal?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type FacebookTokenNode = Node & {
  __typename?: 'FacebookTokenNode';
  accessToken: Scalars['String'];
  created?: Maybe<Scalars['DateTime']>;
  expiresIn?: Maybe<Scalars['DateTime']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isSuccess: Scalars['Boolean'];
  responseBody?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['DateTime']>;
};

export type Failure = {
  __typename?: 'Failure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type FeaturedStorefrontNode = Node & {
  __typename?: 'FeaturedStorefrontNode';
  created: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  page: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  storefront?: Maybe<StorefrontNode>;
  storefrontId: Scalars['Int'];
  updated: Scalars['DateTime'];
};

export type FeaturedStorefrontNodeConnection = {
  __typename?: 'FeaturedStorefrontNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FeaturedStorefrontNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FeaturedStorefrontNode` and its cursor. */
export type FeaturedStorefrontNodeEdge = {
  __typename?: 'FeaturedStorefrontNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<FeaturedStorefrontNode>;
};

export type FieldErrors = {
  __typename?: 'FieldErrors';
  field?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FileNode = Node & {
  __typename?: 'FileNode';
  artist?: Maybe<ArtistNode>;
  artworkSet?: Maybe<ArtworkNodeConnection>;
  bucket: Scalars['String'];
  caption: Scalars['String'];
  created: Scalars['DateTime'];
  extension: Scalars['String'];
  file: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  inS3: Scalars['Boolean'];
  kind: Scalars['String'];
  mime: Scalars['String'];
  package?: Maybe<PackageNode>;
  path: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  starcategorySet?: Maybe<StarCategoryNodeConnection>;
  status?: Maybe<Scalars['String']>;
  submitter: UserNode;
  tour?: Maybe<TourNode>;
  updated: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  venue?: Maybe<VenueNode>;
  width?: Maybe<Scalars['Int']>;
  zoomable: Scalars['Boolean'];
};


export type FileNodeArtworkSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type FileNodeStarcategorySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isSearchable?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  parent_Name?: InputMaybe<Scalars['String']>;
};

export type FileNodeConnection = {
  __typename?: 'FileNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FileNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FileNode` and its cursor. */
export type FileNodeEdge = {
  __typename?: 'FileNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<FileNode>;
};

export enum FileStatus {
  /** Deleted */
  Deleted = 'DELETED',
  /** Private */
  Private = 'PRIVATE',
  /** Public */
  Public = 'PUBLIC'
}

export type FinishGuestAccountInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  password: Scalars['String'];
};

export type FirebaseNotificationsDeviceNode = Node & {
  __typename?: 'FirebaseNotificationsDeviceNode';
  created: Scalars['DateTime'];
  deviceType?: Maybe<DeviceType>;
  /** The ID of the object. */
  id: Scalars['ID'];
  pk?: Maybe<Scalars['String']>;
  registrationToken: Scalars['String'];
  updated: Scalars['DateTime'];
  user: UserNode;
};

export type FirebaseNotificationsDeviceNodeConnection = {
  __typename?: 'FirebaseNotificationsDeviceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FirebaseNotificationsDeviceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FirebaseNotificationsDeviceNode` and its cursor. */
export type FirebaseNotificationsDeviceNodeEdge = {
  __typename?: 'FirebaseNotificationsDeviceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<FirebaseNotificationsDeviceNode>;
};

/** An error occured while following / unfollowing artists */
export type FollowArtistBulkFailure = {
  __typename?: 'FollowArtistBulkFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type FollowArtistBulkInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  withCredit?: InputMaybe<Scalars['Boolean']>;
};

export type FollowArtistBulkResult = FollowArtistBulkFailure | FollowArtistBulkSuccess;

export type FollowArtistBulkSuccess = {
  __typename?: 'FollowArtistBulkSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

/** An error occured while following / unfollowing artist */
export type FollowArtistFailure = {
  __typename?: 'FollowArtistFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type FollowArtistInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  withCredit?: InputMaybe<Scalars['Boolean']>;
};

export type FollowArtistResult = FollowArtistFailure | FollowArtistSuccess;

export type FollowArtistSuccess = {
  __typename?: 'FollowArtistSuccess';
  artist?: Maybe<ArtistNode>;
};

export type FollowAuctionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type FollowAuctionPayload = {
  __typename?: 'FollowAuctionPayload';
  auction?: Maybe<AuctionNode>;
  clientMutationId?: Maybe<Scalars['String']>;
};

/** An error occured while following / unfollowing venue */
export type FollowVenueFailure = {
  __typename?: 'FollowVenueFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type FollowVenueInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type FollowVenueResult = FollowVenueFailure | FollowVenueSuccess;

export type FollowVenueSuccess = {
  __typename?: 'FollowVenueSuccess';
  venue?: Maybe<VenueNode>;
};

export enum GalleryAddressKind {
  Deleted = 'deleted',
  Profile = 'profile',
  Shipping = 'shipping',
  Showroom = 'showroom'
}

export type GalleryAddressNode = Node & {
  __typename?: 'GalleryAddressNode';
  artworkSet?: Maybe<ArtworkNodeConnection>;
  city?: Maybe<Scalars['String']>;
  consignorAddressSet?: Maybe<ArtworkNodeConnection>;
  country?: Maybe<Country>;
  created: Scalars['DateTime'];
  gallery: GalleryNode;
  /** The ID of the object. */
  id: Scalars['ID'];
  kind?: Maybe<GalleryAddressKind>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
};


export type GalleryAddressNodeArtworkSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type GalleryAddressNodeConsignorAddressSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};

export type GalleryAddressNodeConnection = {
  __typename?: 'GalleryAddressNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GalleryAddressNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GalleryAddressNode` and its cursor. */
export type GalleryAddressNodeEdge = {
  __typename?: 'GalleryAddressNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GalleryAddressNode>;
};

export type GalleryImageNode = Node & {
  __typename?: 'GalleryImageNode';
  bucket: Scalars['String'];
  caption: Scalars['String'];
  created: Scalars['DateTime'];
  dominantColor?: Maybe<Scalars['String']>;
  dominantColors?: Maybe<Scalars['String']>;
  extension: Scalars['String'];
  gallerySet?: Maybe<GalleryNodeConnection>;
  height: Scalars['Int'];
  /** The ID of the object. */
  id: Scalars['ID'];
  inS3: Scalars['Boolean'];
  kind: Scalars['String'];
  mime: Scalars['String'];
  path: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  size: Scalars['Int'];
  slug: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  submitter: UserNode;
  title: Scalars['String'];
  updated: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  width: Scalars['Int'];
  zoomable: Scalars['Boolean'];
};


export type GalleryImageNodeGallerySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type GalleryImageNodeConnection = {
  __typename?: 'GalleryImageNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GalleryImageNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GalleryImageNode` and its cursor. */
export type GalleryImageNodeEdge = {
  __typename?: 'GalleryImageNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GalleryImageNode>;
};

export enum GalleryKind {
  /** Charity */
  Charity = 'CHARITY',
  /** Gallery */
  Gallery = 'GALLERY'
}

export type GalleryNode = Node & {
  __typename?: 'GalleryNode';
  addresses?: Maybe<GalleryAddressNodeConnection>;
  artworkSet?: Maybe<ArtworkNodeConnection>;
  auctions?: Maybe<AuctionNodeConnection>;
  created: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  images?: Maybe<GalleryImageNodeConnection>;
  kind: GalleryKind;
  logoImage?: Maybe<GalleryImageNode>;
  offerSet?: Maybe<OfferNodeConnection>;
  owner: UserNode;
  pk?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  /** how the gallery can be viewed/searched on the site */
  status: GalleryStatus;
  title: Scalars['String'];
  updated: Scalars['DateTime'];
};


export type GalleryNodeAddressesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type GalleryNodeArtworkSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type GalleryNodeAuctionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  end_Gt?: InputMaybe<Scalars['DateTime']>;
  end_Gte?: InputMaybe<Scalars['DateTime']>;
  end_Lt?: InputMaybe<Scalars['DateTime']>;
  end_Lte?: InputMaybe<Scalars['DateTime']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  isLiveAuction?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  showOnAuctionIndex?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  start_Gt?: InputMaybe<Scalars['DateTime']>;
  start_Gte?: InputMaybe<Scalars['DateTime']>;
  start_Lt?: InputMaybe<Scalars['DateTime']>;
  start_Lte?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
};


export type GalleryNodeImagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type GalleryNodeOfferSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork?: InputMaybe<Scalars['ID']>;
  auction?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['DateTime']>;
  created_Gt?: InputMaybe<Scalars['DateTime']>;
  created_Gte?: InputMaybe<Scalars['DateTime']>;
  created_Lt?: InputMaybe<Scalars['DateTime']>;
  created_Lte?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  price_Gt?: InputMaybe<Scalars['Float']>;
  price_Gte?: InputMaybe<Scalars['Float']>;
  price_Lt?: InputMaybe<Scalars['Float']>;
  price_Lte?: InputMaybe<Scalars['Float']>;
};

export type GalleryNodeConnection = {
  __typename?: 'GalleryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GalleryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GalleryNode` and its cursor. */
export type GalleryNodeEdge = {
  __typename?: 'GalleryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GalleryNode>;
};

export enum GalleryStatus {
  /** Deleted */
  Deleted = 'DELETED',
  /** Private */
  Private = 'PRIVATE',
  /** Public */
  Public = 'PUBLIC'
}

export type GenerateReferralCodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type GenerateReferralCodeOutput = MutationError | UserReferralNode;

export type GiveawaySubmissionData = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type GrantedOrderNode = Node & {
  __typename?: 'GrantedOrderNode';
  artwork?: Maybe<ArtworkNode>;
  cart?: Maybe<CartNode>;
  createdAt: Scalars['DateTime'];
  credit: Scalars['Float'];
  deliveryOption: DeliveryOptionNode;
  discount: Scalars['Float'];
  /** The ID of the object. */
  id: Scalars['ID'];
  insurance?: Maybe<InsuranceNode>;
  ipAddress?: Maybe<Scalars['String']>;
  localTotalPrice?: Maybe<LocalPriceNode>;
  offer?: Maybe<OfferNode>;
  orderType: GrantedOrderOrderType;
  ordereventlogSet?: Maybe<OrderEventLogNodeConnection>;
  orderinfoSet?: Maybe<OrderInfoNodeConnection>;
  orderitemSet?: Maybe<OrderItemNodeConnection>;
  pay?: Maybe<PaymentNode>;
  pk?: Maybe<Scalars['String']>;
  promocode?: Maybe<PromocodeNode>;
  purchaseorderinfoSet?: Maybe<PurchaseOrderInfoNodeConnection>;
  serviceFee: Scalars['Float'];
  shipping?: Maybe<ShippingNode>;
  shippingPrice: Scalars['Float'];
  status: GrantedOrderStatus;
  tax: Scalars['Float'];
  tevoOrder?: Maybe<TevoOrderNode>;
  tevoOrderId?: Maybe<Scalars['Int']>;
  totalPrice: Scalars['Float'];
  totalRefunded?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: UserNode;
  version: Scalars['Int'];
};


export type GrantedOrderNodeOrdereventlogSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type GrantedOrderNodeOrderinfoSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type GrantedOrderNodeOrderitemSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type GrantedOrderNodePurchaseorderinfoSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type GrantedOrderNodeConnection = {
  __typename?: 'GrantedOrderNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GrantedOrderNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GrantedOrderNode` and its cursor. */
export type GrantedOrderNodeEdge = {
  __typename?: 'GrantedOrderNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GrantedOrderNode>;
};

export enum GrantedOrderOrderType {
  /** auction */
  Auction = 'AUCTION',
  /** buy_now */
  BuyNow = 'BUY_NOW',
  /** tevo */
  Tevo = 'TEVO'
}

export enum GrantedOrderStatus {
  /** canceled */
  Canceled = 'CANCELED',
  /** contact_customer_support */
  ContactCustomerSupport = 'CONTACT_CUSTOMER_SUPPORT',
  /** delivered */
  Delivered = 'DELIVERED',
  /** failed */
  Failed = 'FAILED',
  /** in_moderation */
  InModeration = 'IN_MODERATION',
  /** moderation_failed */
  ModerationFailed = 'MODERATION_FAILED',
  /** new_order */
  NewOrder = 'NEW_ORDER',
  /** paid */
  Paid = 'PAID',
  /** payment_failed */
  PaymentFailed = 'PAYMENT_FAILED',
  /** payment_processing */
  PaymentProcessing = 'PAYMENT_PROCESSING',
  /** refunded */
  Refunded = 'REFUNDED',
  /** requires_action */
  RequiresAction = 'REQUIRES_ACTION',
  /** requires_payment_method */
  RequiresPaymentMethod = 'REQUIRES_PAYMENT_METHOD',
  /** seller_rejected */
  SellerRejected = 'SELLER_REJECTED'
}

export type GrantedSearchResultsNode = {
  __typename?: 'GrantedSearchResultsNode';
  events?: Maybe<Array<Maybe<EventSearchResultNode>>>;
  stars?: Maybe<Array<Maybe<StarSearchResultNode>>>;
  tours?: Maybe<Array<Maybe<TourSearchResultNode>>>;
  venues?: Maybe<Array<Maybe<VenueSearchResultNode>>>;
};

export type GrantedWebSectionFailure = {
  __typename?: 'GrantedWebSectionFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type GrantedWebSectionNode = Node & {
  __typename?: 'GrantedWebSectionNode';
  /** The ID of the object. */
  id: Scalars['ID'];
  name: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type GrantedWebSectionNodeConnection = {
  __typename?: 'GrantedWebSectionNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GrantedWebSectionNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GrantedWebSectionNode` and its cursor. */
export type GrantedWebSectionNodeEdge = {
  __typename?: 'GrantedWebSectionNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GrantedWebSectionNode>;
};

export type GrantedWebSectionResult = GrantedWebSectionFailure | GrantedWebSectionSuccess;

export type GrantedWebSectionSuccess = {
  __typename?: 'GrantedWebSectionSuccess';
  section?: Maybe<GrantedWebSectionNode>;
};

export type GrantedWebSettingsFailure = {
  __typename?: 'GrantedWebSettingsFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type GrantedWebSettingsNode = Node & {
  __typename?: 'GrantedWebSettingsNode';
  /** The ID of the object. */
  id: Scalars['ID'];
  name: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<GrantedWebSectionNode>>>;
  settings?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type GrantedWebSettingsNodeConnection = {
  __typename?: 'GrantedWebSettingsNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GrantedWebSettingsNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GrantedWebSettingsNode` and its cursor. */
export type GrantedWebSettingsNodeEdge = {
  __typename?: 'GrantedWebSettingsNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GrantedWebSettingsNode>;
};

export type GrantedWebSettingsResult = GrantedWebSettingsFailure | GrantedWebSettingsSuccess;

export type GrantedWebSettingsSuccess = {
  __typename?: 'GrantedWebSettingsSuccess';
  settings?: Maybe<GrantedWebSettingsNode>;
};

export type HeroNode = {
  __typename?: 'HeroNode';
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  mobileImageUrl?: Maybe<Scalars['String']>;
  sendGridListId?: Maybe<Scalars['String']>;
  showSubscriptionModal?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export enum ImageProcessStatus {
  /** do not process */
  A_0 = 'A_0',
  /** process */
  A_1 = 'A_1',
  /** processing */
  A_2 = 'A_2',
  /** processed */
  A_3 = 'A_3',
  /** failed */
  A_400 = 'A_400'
}

export type ImportStarEventsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ImportStarEventsResult = ImportStarEventsSuccess | MutationError;

export type ImportStarEventsSuccess = {
  __typename?: 'ImportStarEventsSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export type InstagramPostNode = {
  __typename?: 'InstagramPostNode';
  caption?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  mediaType?: Maybe<Scalars['String']>;
  mediaUrl?: Maybe<Scalars['String']>;
  permalink?: Maybe<Scalars['String']>;
  shortcode?: Maybe<Scalars['String']>;
  thumbnailUrl?: Maybe<Scalars['String']>;
};

export type InsuranceNode = Node & {
  __typename?: 'InsuranceNode';
  grantedorderSet?: Maybe<GrantedOrderNodeConnection>;
  /** The ID of the object. */
  id: Scalars['ID'];
  insurancepolicySet?: Maybe<InsurancePolicyNodeConnection>;
  pay?: Maybe<PaymentNode>;
  pk?: Maybe<Scalars['String']>;
  policies?: Maybe<Array<Maybe<InsurancePolicyNode>>>;
  protechtOrderId?: Maybe<Scalars['String']>;
  quote: Scalars['String'];
  status: InsuranceStatus;
  totalPrice?: Maybe<Scalars['Float']>;
};


export type InsuranceNodeGrantedorderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']>;
  deliveryOption_Type?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderitem_Artwork_Id?: InputMaybe<Scalars['ID']>;
  orderitem_Package_Isnull?: InputMaybe<Scalars['Boolean']>;
  shipping_Email?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  user_Email?: InputMaybe<Scalars['String']>;
};


export type InsuranceNodeInsurancepolicySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type InsuranceNodeConnection = {
  __typename?: 'InsuranceNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InsuranceNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `InsuranceNode` and its cursor. */
export type InsuranceNodeEdge = {
  __typename?: 'InsuranceNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<InsuranceNode>;
};

export type InsurancePolicyNode = Node & {
  __typename?: 'InsurancePolicyNode';
  canceledAt?: Maybe<Scalars['DateTime']>;
  cost: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  insurance: InsuranceNode;
  pk?: Maybe<Scalars['String']>;
  policyId?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  status: InsurancePolicyStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InsurancePolicyNodeConnection = {
  __typename?: 'InsurancePolicyNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InsurancePolicyNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `InsurancePolicyNode` and its cursor. */
export type InsurancePolicyNodeEdge = {
  __typename?: 'InsurancePolicyNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<InsurancePolicyNode>;
};

export enum InsurancePolicyStatus {
  /** created */
  Created = 'CREATED',
  /** failed */
  Failed = 'FAILED',
  /** issued */
  Issued = 'ISSUED',
  /** paid */
  Paid = 'PAID',
  /** pending */
  Pending = 'PENDING',
  /** refunded */
  Refunded = 'REFUNDED',
  /** voided */
  Voided = 'VOIDED'
}

export enum InsuranceStatus {
  /** created */
  Created = 'CREATED',
  /** failed */
  Failed = 'FAILED',
  /** paid */
  Paid = 'PAID',
  /** pending */
  Pending = 'PENDING'
}

export type LocalPriceNode = {
  __typename?: 'LocalPriceNode';
  currency?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
};

export type LoginFailure = {
  __typename?: 'LoginFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

/** An error occurred while logging in for the auction. Please try again. */
export type LoginForAuctionFailure = {
  __typename?: 'LoginForAuctionFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type LoginForAuctionInput = {
  auctionPk: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  paddleNumber: Scalars['Int'];
};

export type LoginForAuctionResult = LoginForAuctionFailure | LoginForAuctionSuccess;

export type LoginForAuctionSuccess = {
  __typename?: 'LoginForAuctionSuccess';
  token?: Maybe<Scalars['String']>;
  user?: Maybe<UserNode>;
};

export type LoginInput = {
  cartId?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
};

export type LoginResult = LoginFailure | LoginSuccess;

export type LoginSuccess = {
  __typename?: 'LoginSuccess';
  token?: Maybe<Scalars['String']>;
  user?: Maybe<UserNode>;
};

/** An error occurred while logout. Please try again. */
export type LogoutFailure = {
  __typename?: 'LogoutFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type LogoutInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type LogoutResult = LogoutFailure | LogoutSuccess;

export type LogoutSuccess = {
  __typename?: 'LogoutSuccess';
  result?: Maybe<Scalars['Boolean']>;
};

export type MarkWinningBidFailure = {
  __typename?: 'MarkWinningBidFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type MarkWinningBidResult = MarkWinningBidFailure | MarkWinningBidSuccess;

export type MarkWinningBidSuccess = {
  __typename?: 'MarkWinningBidSuccess';
  artwork?: Maybe<ArtworkNode>;
};

export type MarkWinnningBidInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  offerId: Scalars['ID'];
};

export type MarketingEventNode = Node & {
  __typename?: 'MarketingEventNode';
  artworks?: Maybe<ArtworkNodeConnection>;
  createdAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  slug: Scalars['String'];
  status: MarketingEventStatus;
  template?: Maybe<TemplateNode>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type MarketingEventNodeArtworksArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  categoryWithChild_Exact?: InputMaybe<Scalars['String']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isEnded?: InputMaybe<Scalars['Boolean']>;
  isEventAnnounced?: InputMaybe<Scalars['Boolean']>;
  isEventStared?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isTransfersToLive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  purchaseType?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venueCoordinates?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};

export type MarketingEventNodeConnection = {
  __typename?: 'MarketingEventNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MarketingEventNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MarketingEventNode` and its cursor. */
export type MarketingEventNodeEdge = {
  __typename?: 'MarketingEventNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MarketingEventNode>;
};

export enum MarketingEventStatus {
  /** deleted */
  Deleted = 'DELETED',
  /** private */
  Private = 'PRIVATE',
  /** public */
  Public = 'PUBLIC'
}

export type MediumNode = Node & {
  __typename?: 'MediumNode';
  artworkSet?: Maybe<ArtworkNodeConnection>;
  artworks?: Maybe<ArtworkNodeConnection>;
  created: Scalars['DateTime'];
  description: Scalars['String'];
  displayTitle: Scalars['String'];
  entrySet?: Maybe<EntryNodeConnection>;
  featuredArtists?: Maybe<ArtistNodeConnection>;
  /** The ID of the object. */
  id: Scalars['ID'];
  introCopy: Scalars['String'];
  objectTerm: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  showClosedLots: Scalars['Boolean'];
  title: Scalars['String'];
  updated: Scalars['DateTime'];
  urlSlug: Scalars['String'];
};


export type MediumNodeArtworkSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type MediumNodeArtworksArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type MediumNodeEntrySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MediumNodeFeaturedArtistsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories_Contains?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  firstName_Istartswith?: InputMaybe<Scalars['String']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastName_Istartswith?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
};

export type MediumNodeConnection = {
  __typename?: 'MediumNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MediumNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MediumNode` and its cursor. */
export type MediumNodeEdge = {
  __typename?: 'MediumNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MediumNode>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addArtworksToCollection?: Maybe<AddArtworksToCollectionPayload>;
  addCreditCard?: Maybe<AddCreditCardResult>;
  addFeaturedStorefront?: Maybe<AddFeaturedStorefrontResult>;
  addFirebaseNotificationsRegisteredDevice?: Maybe<AddRegisteredDeviceResult>;
  addGalleryAddress?: Maybe<AddGalleryAddressResult>;
  addOrUpdateContactList?: Maybe<ContactMutationResult>;
  addTevoCreditCard?: Maybe<AddTevoCreditCardResult>;
  addUserAddress?: Maybe<AddUserAddressResult>;
  buyNow?: Maybe<BuyNowResult>;
  cancelCart?: Maybe<CartMutationResult>;
  cancelSetupIntent?: Maybe<CancelSetupIntentResult>;
  checkVerificationCode?: Maybe<PhoneVerificationOutput>;
  consignArtwork?: Maybe<ConsignArtworkResult>;
  createAuction?: Maybe<UpdateAuctionResult>;
  createCart?: Maybe<CartMutationResult>;
  createCheckoutOrder?: Maybe<OrderMutationResult>;
  createCollection?: Maybe<CreateCollectionPayload>;
  createCreditActionType?: Maybe<CreditActionTypeCreateResult>;
  createEvent?: Maybe<UpdateEventResult>;
  createGalleryArtwork?: Maybe<CreateGalleryArtworkResult>;
  createGrantedWebSection?: Maybe<GrantedWebSectionResult>;
  createGrantedWebSettings?: Maybe<GrantedWebSettingsResult>;
  createMarketingEvent?: Maybe<CreateMarketingEventResult>;
  createOfferFromBidLog?: Maybe<Result>;
  createOrderFromWinningLot?: Maybe<OrderMutationResult>;
  createPackage?: Maybe<CreatePackageResult>;
  createPromocode?: Maybe<UpdatePromocodeResult>;
  createRefund?: Maybe<CreateRefundResult>;
  createSetupIntent?: Maybe<CreateSetupIntentResult>;
  createStar?: Maybe<UpdateStarResult>;
  createStarCategory?: Maybe<CreateStarCategoryResult>;
  createTour?: Maybe<CreateTourResult>;
  createVenue?: Maybe<CreateVenueResult>;
  deleteAuction?: Maybe<UpdateAuctionResult>;
  deleteCollection?: Maybe<DeleteCollectionPayload>;
  deleteFeaturedStorefront?: Maybe<DeleteFeaturedStorefrontResult>;
  deleteGrantedWebSection?: Maybe<GrantedWebSectionResult>;
  deleteGrantedWebSettings?: Maybe<GrantedWebSettingsResult>;
  deleteMarketingEvent?: Maybe<DeleteMarketingEventResult>;
  deletePackage?: Maybe<UpdatePackageResult>;
  deleteStar?: Maybe<UpdateStarResult>;
  deleteTour?: Maybe<UpdateTourResult>;
  deleteVenue?: Maybe<UpdateVenueResult>;
  deletedEvent?: Maybe<UpdateEventResult>;
  enterSweepstakes?: Maybe<EnterSweepstakesResult>;
  finishGuestAccount?: Maybe<SignupResult>;
  followArtist?: Maybe<FollowArtistResult>;
  followArtistBulk?: Maybe<FollowArtistBulkResult>;
  followAuction?: Maybe<FollowAuctionPayload>;
  followVenue?: Maybe<FollowVenueResult>;
  generateReferralCode?: Maybe<GenerateReferralCodeOutput>;
  importStarEvents?: Maybe<ImportStarEventsResult>;
  login?: Maybe<LoginResult>;
  loginForAuction?: Maybe<LoginForAuctionResult>;
  logout?: Maybe<LogoutResult>;
  markWinningBid?: Maybe<MarkWinningBidResult>;
  placeBid?: Maybe<PlaceBidResult>;
  recoverPassword?: Maybe<RecoverPasswordResult>;
  refreshFbToken?: Maybe<UpdateFbTokenResult>;
  removeArtworksFromCollection?: Maybe<RemoveArtworksFromCollectionPayload>;
  removeAutoChargePreference?: Maybe<RemoveAutoChargePreferencePayload>;
  removeCreditCard?: Maybe<RemoveCreditCardPayload>;
  removeFirebaseNotificationsRegisteredDevice?: Maybe<RemoveRegisteredDeviceResult>;
  removeGalleryAddress?: Maybe<RemoveGalleryAddressResult>;
  removePaymentMethod?: Maybe<RemovePaymentMethodPayload>;
  removeTevoCreditCard?: Maybe<RemoveTevoCreditCardResult>;
  removeUserAddress?: Maybe<RemoveUserAddressPayload>;
  requestShippingQuote?: Maybe<RequestShippingQuoteResult>;
  resetPassword?: Maybe<ResetPasswordResult>;
  runScript?: Maybe<RunScriptResult>;
  saveCartCurrentShippingEmail?: Maybe<SaveCartCurrentShippingEmailResult>;
  sendVerificationCode?: Maybe<PhoneVerificationOutput>;
  setAccountType?: Maybe<SetAccountTypeResult>;
  setCompanyAddress?: Maybe<SetCompanyAddressResult>;
  setDateOfBirth?: Maybe<SetDateOfBirthResult>;
  setFbToken?: Maybe<UpdateFbTokenResult>;
  setPrimaryResidentialAddress?: Maybe<SetPrimaryResidentialAddressResult>;
  signup?: Maybe<SignupResult>;
  signupForAuction?: Maybe<SignupForAuctionResult>;
  signupGuest?: Maybe<SignupResult>;
  submitAuctionDonation?: Maybe<SubmitAuctionDonationResult>;
  submitDonation?: Maybe<SubmitDonationResult>;
  submitForGiveaway?: Maybe<SubmitForGiveawayResult>;
  trackArtworkTrend?: Maybe<TrackArtworkTrendPayload>;
  unfollowArtist?: Maybe<FollowArtistResult>;
  unfollowAuction?: Maybe<UnfollowAuctionPayload>;
  unfollowVenue?: Maybe<FollowVenueResult>;
  unwatchArtwork?: Maybe<UnwatchArtworkPayload>;
  updateArtworkLots?: Maybe<UpdateArtworkLotsResult>;
  updateAuction?: Maybe<UpdateAuctionResult>;
  updateAutoChargePreference?: Maybe<UpdateAutoChargePreferencePayload>;
  updateCreditActionType?: Maybe<CreditActionTypeCreateResult>;
  updateEvent?: Maybe<UpdateEventResult>;
  updateFeaturedStorefronts?: Maybe<UpdateFeaturedStorefrontsResult>;
  updateGallery?: Maybe<UpdateGalleryResult>;
  updateGalleryAddress?: Maybe<UpdateGalleryAddressResult>;
  updateGalleryArtwork?: Maybe<UpdateGalleryArtworkResult>;
  updateGalleryArtworkStatus?: Maybe<UpdateGalleryArtworkStatusResult>;
  updateGalleryArtworksStatus?: Maybe<UpdateGalleryArtworksStatusResult>;
  updateGalleryAuction?: Maybe<UpdateGalleryAuctionResult>;
  updateGalleryAuctionEvent?: Maybe<UpdateGalleryAuctionEventResult>;
  updateGalleryAuctionEventAddress?: Maybe<UpdateGalleryAuctionEventAddressResult>;
  updateGrantedWebSection?: Maybe<GrantedWebSectionResult>;
  updateGrantedWebSettings?: Maybe<GrantedWebSettingsResult>;
  updateMarketingEvent?: Maybe<UpdateMarketingEventResult>;
  updateOrderAddress?: Maybe<UpdateOrderAddressResult>;
  updateOrderShipping?: Maybe<OrderMutationResult>;
  updatePackage?: Maybe<UpdatePackageResult>;
  updatePackageBulk?: Maybe<UpdatePackageBulkResult>;
  updatePromocode?: Maybe<UpdatePromocodeResult>;
  updateStar?: Maybe<UpdateStarResult>;
  updateStarCategory?: Maybe<UpdateStarCategoryResult>;
  updateStarCategoryBulk?: Maybe<UpdateStarCategoryBulkResult>;
  updateTour?: Maybe<UpdateTourResult>;
  updateUserAddress?: Maybe<UpdateUserAddressResult>;
  updateUserInformation?: Maybe<UpdateUserResult>;
  updateUserNotifications?: Maybe<UpdateUserNotificationsPayload>;
  updateVenue?: Maybe<UpdateVenueResult>;
  uploadFile?: Maybe<UploadFileResult>;
  uploadFileByUrl?: Maybe<UploadFileResult>;
  watchArtwork?: Maybe<WatchArtworkPayload>;
};


export type MutationAddArtworksToCollectionArgs = {
  input: AddArtworksToCollectionInput;
};


export type MutationAddCreditCardArgs = {
  input: AddCreditCardInput;
};


export type MutationAddFeaturedStorefrontArgs = {
  input: AddFeaturedStorefrontInput;
};


export type MutationAddFirebaseNotificationsRegisteredDeviceArgs = {
  input: AddRegisteredDeviceInput;
};


export type MutationAddGalleryAddressArgs = {
  input: AddGalleryAddressInput;
};


export type MutationAddOrUpdateContactListArgs = {
  input: AddOrUpdateContactListInput;
};


export type MutationAddTevoCreditCardArgs = {
  input: AddTevoCreditCardInput;
};


export type MutationAddUserAddressArgs = {
  input: AddUserAddressInput;
};


export type MutationBuyNowArgs = {
  input: BuyNowInput;
};


export type MutationCancelCartArgs = {
  input: CancelCartInput;
};


export type MutationCancelSetupIntentArgs = {
  input: CancelSetupIntentInput;
};


export type MutationCheckVerificationCodeArgs = {
  input: CheckVerificationCodeInput;
};


export type MutationConsignArtworkArgs = {
  input: ConsignArtworkInput;
};


export type MutationCreateAuctionArgs = {
  input: CreateAuctionInput;
};


export type MutationCreateCartArgs = {
  input: CreateCartInput;
};


export type MutationCreateCheckoutOrderArgs = {
  input: CreateCheckoutOrderInput;
};


export type MutationCreateCollectionArgs = {
  input: CreateCollectionInput;
};


export type MutationCreateCreditActionTypeArgs = {
  input: CreateCreditActionTypeInput;
};


export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


export type MutationCreateGalleryArtworkArgs = {
  input: CreateGalleryArtworkInput;
};


export type MutationCreateGrantedWebSectionArgs = {
  input: CreateGrantedWebSectionInput;
};


export type MutationCreateGrantedWebSettingsArgs = {
  input: CreateGrantedWebSettingsInput;
};


export type MutationCreateMarketingEventArgs = {
  input: CreateMarketingEventInput;
};


export type MutationCreateOfferFromBidLogArgs = {
  input: CreateOfferFromBidLogInput;
};


export type MutationCreateOrderFromWinningLotArgs = {
  input: CreateOrderFromOfferInput;
};


export type MutationCreatePackageArgs = {
  input: CreatePackageInput;
};


export type MutationCreatePromocodeArgs = {
  input: CreatePromocodeInput;
};


export type MutationCreateRefundArgs = {
  input: CreateRefundInput;
};


export type MutationCreateSetupIntentArgs = {
  input: CreateSetupIntentInput;
};


export type MutationCreateStarArgs = {
  input: CreateStarInput;
};


export type MutationCreateStarCategoryArgs = {
  input: CreateStarCategoryInput;
};


export type MutationCreateTourArgs = {
  input: CreateTourInput;
};


export type MutationCreateVenueArgs = {
  input: CreateVenueInput;
};


export type MutationDeleteAuctionArgs = {
  input: DeleteAuctionInput;
};


export type MutationDeleteCollectionArgs = {
  input: DeleteCollectionInput;
};


export type MutationDeleteFeaturedStorefrontArgs = {
  input: DeleteFeaturedStorefrontInput;
};


export type MutationDeleteGrantedWebSectionArgs = {
  input: DeleteGrantedWebSectionInput;
};


export type MutationDeleteGrantedWebSettingsArgs = {
  input: DeleteGrantedWebSettingsInput;
};


export type MutationDeleteMarketingEventArgs = {
  input: DeleteMarketingEventInput;
};


export type MutationDeletePackageArgs = {
  input: DeletePackageInput;
};


export type MutationDeleteStarArgs = {
  input: DeleteStarInput;
};


export type MutationDeleteTourArgs = {
  input: DeleteTourInput;
};


export type MutationDeleteVenueArgs = {
  input: DeleteVenueInput;
};


export type MutationDeletedEventArgs = {
  input: DeleteEventInput;
};


export type MutationEnterSweepstakesArgs = {
  input: EnterSweepstakesInput;
};


export type MutationFinishGuestAccountArgs = {
  input: FinishGuestAccountInput;
};


export type MutationFollowArtistArgs = {
  input: FollowArtistInput;
};


export type MutationFollowArtistBulkArgs = {
  input: FollowArtistBulkInput;
};


export type MutationFollowAuctionArgs = {
  input: FollowAuctionInput;
};


export type MutationFollowVenueArgs = {
  input: FollowVenueInput;
};


export type MutationGenerateReferralCodeArgs = {
  input: GenerateReferralCodeInput;
};


export type MutationImportStarEventsArgs = {
  input: ImportStarEventsInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationLoginForAuctionArgs = {
  input: LoginForAuctionInput;
};


export type MutationLogoutArgs = {
  input: LogoutInput;
};


export type MutationMarkWinningBidArgs = {
  input: MarkWinnningBidInput;
};


export type MutationPlaceBidArgs = {
  input: PlaceBidInput;
};


export type MutationRecoverPasswordArgs = {
  input: RecoverPasswordInput;
};


export type MutationRefreshFbTokenArgs = {
  input: RefreshFbTokenInput;
};


export type MutationRemoveArtworksFromCollectionArgs = {
  input: RemoveArtworksFromCollectionInput;
};


export type MutationRemoveAutoChargePreferenceArgs = {
  input: RemoveAutoChargePreferenceInput;
};


export type MutationRemoveCreditCardArgs = {
  input: RemoveCreditCardInput;
};


export type MutationRemoveFirebaseNotificationsRegisteredDeviceArgs = {
  input: RemoveRegisteredDeviceInput;
};


export type MutationRemoveGalleryAddressArgs = {
  input: RemoveGalleryAddressInput;
};


export type MutationRemovePaymentMethodArgs = {
  input: RemovePaymentMethodInput;
};


export type MutationRemoveTevoCreditCardArgs = {
  input: RemoveTevoCreditCardInput;
};


export type MutationRemoveUserAddressArgs = {
  input: RemoveUserAddressInput;
};


export type MutationRequestShippingQuoteArgs = {
  input: RequestShippingQuoteInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationRunScriptArgs = {
  input: RunScriptInput;
};


export type MutationSaveCartCurrentShippingEmailArgs = {
  input: SaveCartCurrentShippingEmailInput;
};


export type MutationSendVerificationCodeArgs = {
  input: SendVerificationCodeInput;
};


export type MutationSetAccountTypeArgs = {
  input: SetAccountTypeInput;
};


export type MutationSetCompanyAddressArgs = {
  input: SetCompanyAddressInput;
};


export type MutationSetDateOfBirthArgs = {
  input: SetDateOfBirthInput;
};


export type MutationSetFbTokenArgs = {
  input: SetFbTokenInput;
};


export type MutationSetPrimaryResidentialAddressArgs = {
  input: SetPrimaryResidentialAddressInput;
};


export type MutationSignupArgs = {
  input: SignupInput;
};


export type MutationSignupForAuctionArgs = {
  input: SignupForAuctionInput;
};


export type MutationSignupGuestArgs = {
  input: SignupGuestInput;
};


export type MutationSubmitAuctionDonationArgs = {
  input: SubmitAuctionDonationInput;
};


export type MutationSubmitDonationArgs = {
  input: SubmitDonationInput;
};


export type MutationSubmitForGiveawayArgs = {
  input: SubmitForGiveawayInput;
};


export type MutationTrackArtworkTrendArgs = {
  input: TrackArtworkTrendInput;
};


export type MutationUnfollowArtistArgs = {
  input: UnfollowArtistInput;
};


export type MutationUnfollowAuctionArgs = {
  input: UnfollowAuctionInput;
};


export type MutationUnfollowVenueArgs = {
  input: UnfollowVenueInput;
};


export type MutationUnwatchArtworkArgs = {
  input: UnwatchArtworkInput;
};


export type MutationUpdateArtworkLotsArgs = {
  input: UpdateArtworkLotsInput;
};


export type MutationUpdateAuctionArgs = {
  input: UpdateAuctionInput;
};


export type MutationUpdateAutoChargePreferenceArgs = {
  input: UpdateAutoChargePreferenceInput;
};


export type MutationUpdateCreditActionTypeArgs = {
  input: UpdateCreditActionTypeInput;
};


export type MutationUpdateEventArgs = {
  input: UpdateEventInput;
};


export type MutationUpdateFeaturedStorefrontsArgs = {
  input: UpdateFeaturedStorefrontsInput;
};


export type MutationUpdateGalleryArgs = {
  input: UpdateGalleryInput;
};


export type MutationUpdateGalleryAddressArgs = {
  input: UpdateGalleryAddressInput;
};


export type MutationUpdateGalleryArtworkArgs = {
  input: UpdateGalleryArtworkInput;
};


export type MutationUpdateGalleryArtworkStatusArgs = {
  input: UpdateGalleryArtworkStatusInput;
};


export type MutationUpdateGalleryArtworksStatusArgs = {
  input: UpdateGalleryArtworksStatusInput;
};


export type MutationUpdateGalleryAuctionArgs = {
  input: UpdateGalleryAuctionInput;
};


export type MutationUpdateGalleryAuctionEventArgs = {
  input: UpdateGalleryAuctionEventInput;
};


export type MutationUpdateGalleryAuctionEventAddressArgs = {
  input: UpdateGalleryAuctionEventAddressInput;
};


export type MutationUpdateGrantedWebSectionArgs = {
  input: UpdateGrantedWebSectionInput;
};


export type MutationUpdateGrantedWebSettingsArgs = {
  input: UpdateGrantedWebSettingsInput;
};


export type MutationUpdateMarketingEventArgs = {
  input: UpdateMarketingEventInput;
};


export type MutationUpdateOrderAddressArgs = {
  input: UpdateOrderAddressInput;
};


export type MutationUpdateOrderShippingArgs = {
  input: UpdateOrderShippingInput;
};


export type MutationUpdatePackageArgs = {
  input: UpdatePackageInput;
};


export type MutationUpdatePackageBulkArgs = {
  input: UpdatePackageBulkInput;
};


export type MutationUpdatePromocodeArgs = {
  input: UpdatePromocodeInput;
};


export type MutationUpdateStarArgs = {
  input: UpdateStarInput;
};


export type MutationUpdateStarCategoryArgs = {
  input: UpdateStarCategoryInput;
};


export type MutationUpdateStarCategoryBulkArgs = {
  input: UpdateStarCategoryBulkInput;
};


export type MutationUpdateTourArgs = {
  input: UpdateTourInput;
};


export type MutationUpdateUserAddressArgs = {
  input: UpdateUserAddressInput;
};


export type MutationUpdateUserInformationArgs = {
  input: UpdateUserInformationInput;
};


export type MutationUpdateUserNotificationsArgs = {
  input: UpdateUserNotificationsInput;
};


export type MutationUpdateVenueArgs = {
  input: UpdateVenueInput;
};


export type MutationUploadFileArgs = {
  input: UploadFileInput;
};


export type MutationUploadFileByUrlArgs = {
  input: UploadFileByUrlInput;
};


export type MutationWatchArtworkArgs = {
  input: WatchArtworkInput;
};

export type MutationError = {
  __typename?: 'MutationError';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object. */
  id: Scalars['ID'];
};

export enum OfferBidType {
  /** Bid */
  Bid = 'BID',
  /** Canceled Bid */
  BidCanceled = 'BID_CANCELED',
  /** Buy Now */
  BuyNow = 'BUY_NOW',
  /** Donation */
  Donation = 'DONATION',
  /** Force Buy Now */
  ForceBuyNow = 'FORCE_BUY_NOW',
  /** Offer */
  Offer = 'OFFER'
}

export enum OfferConsignorSettlementStatus {
  /** Settlement completed */
  Completed = 'COMPLETED',
  /** Do Not Release */
  DoNotRelease = 'DO_NOT_RELEASE',
  /** Settlement Initiated */
  Initiated = 'INITIATED',
  /** Release for Payment */
  ReleaseForPayment = 'RELEASE_FOR_PAYMENT'
}

export type OfferNode = Node & {
  __typename?: 'OfferNode';
  approvedToShip: Scalars['Boolean'];
  artwork?: Maybe<ArtworkNode>;
  artworkMultipleNumber?: Maybe<Scalars['Int']>;
  auction: AuctionNode;
  bidLog?: Maybe<BidLogNode>;
  bidType: OfferBidType;
  buyer: UserNode;
  buyerNotes: Scalars['String'];
  comments: Scalars['String'];
  consignorPaymentInfo?: Maybe<Scalars['String']>;
  consignorSettlementDate?: Maybe<Scalars['Date']>;
  /** status of paying the consignor */
  consignorSettlementStatus?: Maybe<OfferConsignorSettlementStatus>;
  created: Scalars['DateTime'];
  deliveryOption?: Maybe<Scalars['String']>;
  destination?: Maybe<DestinationNode>;
  discountCost?: Maybe<Scalars['Float']>;
  donationCost?: Maybe<Scalars['Int']>;
  gallery: GalleryNode;
  giftAid: Scalars['Boolean'];
  grantedorderSet?: Maybe<GrantedOrderNodeConnection>;
  /** The ID of the object. */
  id: Scalars['ID'];
  installationCost?: Maybe<Scalars['Float']>;
  installationOption?: Maybe<Scalars['String']>;
  insuranceCost?: Maybe<Scalars['Float']>;
  insuranceOption?: Maybe<Scalars['Int']>;
  isWinningBid: Scalars['Boolean'];
  maxBidAmount?: Maybe<Scalars['Float']>;
  orderSet?: Maybe<OrderNodeConnection>;
  /** who/what created this offer */
  origin: OfferOrigin;
  paidToOrg: Scalars['Boolean'];
  paymentCardUid?: Maybe<Scalars['String']>;
  paymentCompletionStatus?: Maybe<OfferPaymentCompletionStatus>;
  paymentStatus: OfferPaymentStatus;
  pk?: Maybe<Scalars['String']>;
  premiumCost?: Maybe<Scalars['Float']>;
  /** the amount the buyer is willing to pay */
  price: Scalars['Float'];
  qboInvoiceId?: Maybe<Scalars['String']>;
  quotedShippingCost?: Maybe<Scalars['Float']>;
  sellerNotes: Scalars['String'];
  serviceLevel?: Maybe<Scalars['String']>;
  shippingAddress?: Maybe<UserAddressNode>;
  shippingCost?: Maybe<Scalars['Float']>;
  shippingNotes: Scalars['String'];
  shippingOption?: Maybe<Scalars['String']>;
  source?: Maybe<OfferSource>;
  suppressCheckoutLink?: Maybe<Scalars['Boolean']>;
  taxCost?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  transferResolved: Scalars['Boolean'];
  updated: Scalars['DateTime'];
  userTookHome: Scalars['Boolean'];
};


export type OfferNodeGrantedorderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']>;
  deliveryOption_Type?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderitem_Artwork_Id?: InputMaybe<Scalars['ID']>;
  orderitem_Package_Isnull?: InputMaybe<Scalars['Boolean']>;
  shipping_Email?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  user_Email?: InputMaybe<Scalars['String']>;
};


export type OfferNodeOrderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  shippingJobStatus?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type OfferNodeConnection = {
  __typename?: 'OfferNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OfferNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OfferNode` and its cursor. */
export type OfferNodeEdge = {
  __typename?: 'OfferNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OfferNode>;
};

export enum OfferOrigin {
  /** Automatic */
  Automatic = 'AUTOMATIC',
  /** Post Auction Force */
  PostAuctionForce = 'POST_AUCTION_FORCE',
  /** User */
  User = 'USER'
}

export enum OfferPaymentCompletionStatus {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Paid */
  Paid = 'PAID'
}

export enum OfferPaymentStatus {
  /** Accepted */
  Accepted = 'ACCEPTED',
  /** Canceled */
  Canceled = 'CANCELED',
  /** Declined */
  Declined = 'DECLINED',
  /** Payment Pending */
  PaymentPending = 'PAYMENT_PENDING'
}

export enum OfferSource {
  IphoneApp = 'iphoneApp',
  Kiosk = 'kiosk',
  MobileWeb = 'mobileWeb',
  Web = 'web'
}

export type OrderEventLogNode = Node & {
  __typename?: 'OrderEventLogNode';
  createdAt: Scalars['DateTime'];
  eventType: Scalars['String'];
  /** The ID of the object. */
  id: Scalars['ID'];
  order?: Maybe<GrantedOrderNode>;
  payload?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrderEventLogNodeConnection = {
  __typename?: 'OrderEventLogNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderEventLogNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OrderEventLogNode` and its cursor. */
export type OrderEventLogNodeEdge = {
  __typename?: 'OrderEventLogNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OrderEventLogNode>;
};

export type OrderInfoNode = Node & {
  __typename?: 'OrderInfoNode';
  distributorShipping: Scalars['Float'];
  distributorSubtotal: Scalars['Float'];
  distributorTax: Scalars['Float'];
  distributorTotal: Scalars['Float'];
  /** The ID of the object. */
  id: Scalars['ID'];
  meta?: Maybe<Scalars['String']>;
  order: GrantedOrderNode;
  pk?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
  withOptIn: Scalars['Boolean'];
};

export type OrderInfoNodeConnection = {
  __typename?: 'OrderInfoNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderInfoNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OrderInfoNode` and its cursor. */
export type OrderInfoNodeEdge = {
  __typename?: 'OrderInfoNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OrderInfoNode>;
};

export type OrderItemCombinedNode = {
  __typename?: 'OrderItemCombinedNode';
  artwork?: Maybe<ArtworkNode>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  order?: Maybe<GrantedOrderNode>;
  orderId?: Maybe<Scalars['Int']>;
  package?: Maybe<PackageNode>;
  pk?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  tevoOrderId?: Maybe<Scalars['Int']>;
  tevoTicketGroup?: Maybe<TevoTicketNode>;
  tevoTicketGroupId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type OrderItemNode = Node & {
  __typename?: 'OrderItemNode';
  artwork: ArtworkNode;
  createdAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  order: GrantedOrderNode;
  package?: Maybe<PackageNode>;
  pk?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  tevoTicketGroup?: Maybe<TevoTicketNode>;
  tevoTicketGroupId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrderItemNodeConnection = {
  __typename?: 'OrderItemNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderItemNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OrderItemNode` and its cursor. */
export type OrderItemNodeEdge = {
  __typename?: 'OrderItemNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OrderItemNode>;
};

export type OrderMutationFailure = {
  __typename?: 'OrderMutationFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type OrderMutationResult = OrderMutationFailure | OrderMutationSuccess;

export type OrderMutationSuccess = {
  __typename?: 'OrderMutationSuccess';
  order?: Maybe<GrantedOrderNode>;
  paymentIntentClientSecret?: Maybe<Scalars['String']>;
  paymentIntentId?: Maybe<Scalars['String']>;
};

export type OrderNode = Node & {
  __typename?: 'OrderNode';
  carrier?: Maybe<Scalars['String']>;
  carrierNotes?: Maybe<Scalars['String']>;
  checkNumber?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  currency: Scalars['String'];
  destination?: Maybe<UserAddressNode>;
  donation?: Maybe<Scalars['Float']>;
  gatewayType?: Maybe<Scalars['String']>;
  giftAid: Scalars['Boolean'];
  /** The ID of the object. */
  id: Scalars['ID'];
  installationCost?: Maybe<Scalars['Float']>;
  insuranceCost?: Maybe<Scalars['Float']>;
  lineItems?: Maybe<Scalars['String']>;
  offer: OfferNode;
  p8Destination?: Maybe<DestinationNode>;
  packingCost?: Maybe<Scalars['Float']>;
  paidInFullDate?: Maybe<Scalars['DateTime']>;
  /** A unique identifier used to reference the payment transaction */
  paymentTransactionUid?: Maybe<Scalars['String']>;
  paymentType: OrderPaymentType;
  pickupCost?: Maybe<Scalars['Float']>;
  pk?: Maybe<Scalars['String']>;
  quotedShippingCost?: Maybe<Scalars['Float']>;
  serviceLevel?: Maybe<Scalars['String']>;
  shippingCost?: Maybe<Scalars['Float']>;
  shippingDelayNoticeSent?: Maybe<Scalars['DateTime']>;
  shippingJobId?: Maybe<Scalars['String']>;
  shippingJobStatus: OrderShippingJobStatus;
  shippingRateId?: Maybe<Scalars['String']>;
  status: OrderStatus;
  tax?: Maybe<Scalars['Float']>;
  trackingInfo?: Maybe<Scalars['String']>;
  trackingNumber?: Maybe<Scalars['String']>;
  transitCost?: Maybe<Scalars['Float']>;
  updated: Scalars['DateTime'];
  user: UserNode;
};

export type OrderNodeConnection = {
  __typename?: 'OrderNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OrderNode` and its cursor. */
export type OrderNodeEdge = {
  __typename?: 'OrderNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<OrderNode>;
};

export enum OrderPaymentType {
  /** ACH */
  Ach = 'ACH',
  /** Pay by Check */
  Check = 'CHECK',
  /** Credit Card */
  CreditCard = 'CREDIT_CARD',
  /** N/A */
  Na = 'NA',
  /** Offline transaction */
  Offline = 'OFFLINE',
  /** Wire Transfer */
  Wire = 'WIRE'
}

export type OrderPricingNode = {
  __typename?: 'OrderPricingNode';
  cartItemPrice?: Maybe<Scalars['Float']>;
  cartPrice?: Maybe<Scalars['Float']>;
  cartPriceWithoutDiscount?: Maybe<Scalars['Float']>;
  credit?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  discountError?: Maybe<Scalars['String']>;
  insuranceCostsOfItems?: Maybe<Array<Maybe<Scalars['Float']>>>;
  mode?: Maybe<Scalars['String']>;
  orderTax?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  serviceFee?: Maybe<Scalars['Float']>;
  shippingPrice?: Maybe<Scalars['Float']>;
  totalPrice?: Maybe<Scalars['Float']>;
  totalPriceWithPromocode?: Maybe<Scalars['Float']>;
  totalPriceWithoutDiscount?: Maybe<Scalars['Float']>;
};

export enum OrderShippingJobStatus {
  /** Cancelled - The shipment has been cancelled  */
  Cancelled = 'CANCELLED',
  /** Confirmed - The shipment details have been confirmed (older status, often skipped). */
  Confirmed = 'CONFIRMED',
  /** Delivered - The shipment has been delivered to the destination location */
  Delivered = 'DELIVERED',
  /** Exception - There is an exception with the shipment that requires manual intervention. */
  Exception = 'EXCEPTION',
  /** In Transit - The shipment is now in transit with the designated carrier */
  InTransit = 'IN_TRANSIT',
  /** In Prep - The shipment items are being prepared for transit by the Network Location */
  NlPrep = 'NL_PREP',
  /** No Status - shipment process has not started */
  NA = 'N_A',
  /** Ordered - The shipment has been received by ShipHawk. */
  Ordered = 'ORDERED',
  /** Ready for Carrier pickup */
  ReadyForCarrierPickup = 'READY_FOR_CARRIER_PICKUP',
  /** Scheduled for Pickup - The shipment has been scheduled for pickup by the Network Location */
  ScheduledForPickup = 'SCHEDULED_FOR_PICKUP'
}

export enum OrderStatus {
  /** Confirmed */
  Confirmed = 'CONFIRMED',
  /** Started */
  Started = 'STARTED'
}

export type PackageNode = Node & {
  __typename?: 'PackageNode';
  artworkSet?: Maybe<ArtworkNodeConnection>;
  artworks?: Maybe<ArtworkNodeConnection>;
  availableQuantity: Scalars['Int'];
  cartitemSet?: Maybe<CartItemNodeConnection>;
  createdAt: Scalars['DateTime'];
  deliveryNotes?: Maybe<Scalars['String']>;
  deliveryOptions?: Maybe<DeliveryOptionNodeConnection>;
  /** The ID of the object. */
  id: Scalars['ID'];
  image?: Maybe<FileNode>;
  imageOriginal?: Maybe<Scalars['String']>;
  isTicket: Scalars['Boolean'];
  localPrice?: Maybe<LocalPriceNode>;
  longDescription?: Maybe<Scalars['String']>;
  maxSplit: Scalars['Int'];
  minSplit: Scalars['Int'];
  name: Scalars['String'];
  orderitemSet?: Maybe<OrderItemNodeConnection>;
  pk?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  shortDescription: Scalars['String'];
  status: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type PackageNodeArtworkSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type PackageNodeArtworksArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type PackageNodeCartitemSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PackageNodeDeliveryOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type PackageNodeLocalPriceArgs = {
  currency?: InputMaybe<Scalars['String']>;
};


export type PackageNodeOrderitemSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type PackageNodeConnection = {
  __typename?: 'PackageNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PackageNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PackageNode` and its cursor. */
export type PackageNodeEdge = {
  __typename?: 'PackageNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PackageNode>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PaymentIntentMetadataNode = {
  __typename?: 'PaymentIntentMetadataNode';
  grantedOrderId?: Maybe<Scalars['Int']>;
};

export type PaymentIntentNode = {
  __typename?: 'PaymentIntentNode';
  id?: Maybe<Scalars['ID']>;
  metadata?: Maybe<PaymentIntentMetadataNode>;
  paymentMethodName?: Maybe<Scalars['String']>;
  review?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  wallet?: Maybe<Scalars['String']>;
};

export type PaymentNode = Node & {
  __typename?: 'PaymentNode';
  amount: Scalars['Float'];
  charge?: Maybe<PaymentIntentNode>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  gateway: Scalars['String'];
  grantedorderSet?: Maybe<GrantedOrderNodeConnection>;
  /** The ID of the object. */
  id: Scalars['ID'];
  insuranceSet?: Maybe<InsuranceNodeConnection>;
  metadata?: Maybe<Scalars['String']>;
  paymentIntent?: Maybe<PaymentIntentNode>;
  paymentMethod?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['String']>;
  status: PaymentStatus;
  transactionUid: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: UserNode;
};


export type PaymentNodeGrantedorderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']>;
  deliveryOption_Type?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderitem_Artwork_Id?: InputMaybe<Scalars['ID']>;
  orderitem_Package_Isnull?: InputMaybe<Scalars['Boolean']>;
  shipping_Email?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  user_Email?: InputMaybe<Scalars['String']>;
};


export type PaymentNodeInsuranceSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type PaymentNodeConnection = {
  __typename?: 'PaymentNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PaymentNode` and its cursor. */
export type PaymentNodeEdge = {
  __typename?: 'PaymentNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PaymentNode>;
};

export enum PaymentStatus {
  /** failed */
  Failed = 'FAILED',
  /** pending */
  Pending = 'PENDING',
  /** requires_action */
  RequiresAction = 'REQUIRES_ACTION',
  /** requires_capture */
  RequiresCapture = 'REQUIRES_CAPTURE',
  /** succeeded */
  Succeeded = 'SUCCEEDED'
}

export type PhoneVerificationFailure = {
  __typename?: 'PhoneVerificationFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type PhoneVerificationOutput = PhoneVerificationFailure | PhoneVerificationSuccess;

export type PhoneVerificationSuccess = {
  __typename?: 'PhoneVerificationSuccess';
  ok?: Maybe<Scalars['Boolean']>;
};

/** An error occurred while placing a bid. Please try again. */
export type PlaceBidFailure = {
  __typename?: 'PlaceBidFailure';
  data?: Maybe<PlaceBidResponseNode>;
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type PlaceBidInput = {
  artworkId: Scalars['ID'];
  bidAmount: Scalars['Int'];
  bidSource: BidSources;
  clientMutationId?: InputMaybe<Scalars['String']>;
  shipping: Shipping;
  source: Scalars['ID'];
};

export type PlaceBidResponseInterface = {
  artworkId?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  currentPrice?: Maybe<Scalars['Float']>;
  offerId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
};

export type PlaceBidResponseNode = PlaceBidResponseInterface & {
  __typename?: 'PlaceBidResponseNode';
  artworkId?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  currentPrice?: Maybe<Scalars['Float']>;
  offerId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
};

export type PlaceBidResult = PlaceBidFailure | PlaceBidSuccess;

export type PlaceBidSuccess = {
  __typename?: 'PlaceBidSuccess';
  artwork?: Maybe<ArtworkNode>;
  data?: Maybe<PlaceBidResponseNode>;
  offer?: Maybe<OfferNode>;
};

export enum PromocodeChannelName {
  /** affiliate_marketing */
  AffiliateMarketing = 'AFFILIATE_MARKETING',
  /** email_marketing */
  EmailMarketing = 'EMAIL_MARKETING',
  /** live */
  Live = 'LIVE',
  /** organic_social */
  OrganicSocial = 'ORGANIC_SOCIAL',
  /** paid_social */
  PaidSocial = 'PAID_SOCIAL'
}

export type PromocodeChannelNode = Node & {
  __typename?: 'PromocodeChannelNode';
  /** The ID of the object. */
  id: Scalars['ID'];
  name: PromocodeChannelName;
  pk?: Maybe<Scalars['String']>;
  promocode?: Maybe<PromocodeNode>;
};

export type PromocodeChannelNodeConnection = {
  __typename?: 'PromocodeChannelNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PromocodeChannelNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PromocodeChannelNode` and its cursor. */
export type PromocodeChannelNodeEdge = {
  __typename?: 'PromocodeChannelNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PromocodeChannelNode>;
};

export type PromocodeNode = Node & {
  __typename?: 'PromocodeNode';
  amount: Scalars['Float'];
  automaticApply: Scalars['Boolean'];
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  grantedorderSet?: Maybe<GrantedOrderNodeConnection>;
  /** The ID of the object. */
  id: Scalars['ID'];
  pk?: Maybe<Scalars['String']>;
  promocodechannelSet?: Maybe<PromocodeChannelNodeConnection>;
  status: PromocodeStatus;
  type: PromocodeType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uses: Scalars['Int'];
};


export type PromocodeNodeGrantedorderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']>;
  deliveryOption_Type?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderitem_Artwork_Id?: InputMaybe<Scalars['ID']>;
  orderitem_Package_Isnull?: InputMaybe<Scalars['Boolean']>;
  shipping_Email?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  user_Email?: InputMaybe<Scalars['String']>;
};


export type PromocodeNodePromocodechannelSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type PromocodeNodeConnection = {
  __typename?: 'PromocodeNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PromocodeNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PromocodeNode` and its cursor. */
export type PromocodeNodeEdge = {
  __typename?: 'PromocodeNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PromocodeNode>;
};

export enum PromocodeStatus {
  /** active */
  Active = 'ACTIVE',
  /** inactive */
  Inactive = 'INACTIVE'
}

export enum PromocodeType {
  /** flat */
  Flat = 'FLAT',
  /** percent */
  Percent = 'PERCENT'
}

export type PurchaseOrderInfoNode = Node & {
  __typename?: 'PurchaseOrderInfoNode';
  /** The ID of the object. */
  id: Scalars['ID'];
  order: GrantedOrderNode;
  pk?: Maybe<Scalars['String']>;
  poId?: Maybe<Scalars['Int']>;
  poShipping: Scalars['Float'];
  poSubtotal: Scalars['Float'];
  poTax: Scalars['Float'];
  poTotal: Scalars['Float'];
};

export type PurchaseOrderInfoNodeConnection = {
  __typename?: 'PurchaseOrderInfoNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PurchaseOrderInfoNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PurchaseOrderInfoNode` and its cursor. */
export type PurchaseOrderInfoNodeEdge = {
  __typename?: 'PurchaseOrderInfoNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PurchaseOrderInfoNode>;
};

export enum PurchaseStatus {
  Available = 'available',
  BuyNowPending = 'buyNowPending',
  Notforsale = 'notforsale',
  Sold = 'sold'
}

export enum PurchaseType {
  BidOrBuyNow = 'bidOrBuyNow',
  BiddingOnly = 'biddingOnly',
  BuyNowOnly = 'buyNowOnly',
  InquiryOnly = 'inquiryOnly'
}

export type Query = {
  __typename?: 'Query';
  _debug?: Maybe<DjangoDebug>;
  allArtists?: Maybe<ArtistNodeConnection>;
  allArtworks?: Maybe<ArtworkNodeCountingConnection>;
  allArtworksWithCount?: Maybe<AllArtworksWithCountCountingConnection>;
  allAuctions?: Maybe<AuctionNodeConnection>;
  allCategories?: Maybe<StarCategoryNodeConnection>;
  allCities?: Maybe<CityNodeConnection>;
  allCollections?: Maybe<CollectionNodeConnection>;
  allMediums?: Maybe<MediumNodeConnection>;
  allOffers?: Maybe<OfferNodeConnection>;
  allOrders?: Maybe<GrantedOrderNodeConnection>;
  allPackages?: Maybe<PackageNodeConnection>;
  allPromocodes?: Maybe<PromocodeNodeConnection>;
  allStorefronts?: Maybe<Array<Maybe<StorefrontNode>>>;
  allTours?: Maybe<TourNodeConnection>;
  allUsers?: Maybe<UserNodeConnection>;
  allVenues?: Maybe<VenueNodeConnection>;
  artist?: Maybe<ArtistNode>;
  artistArtworks?: Maybe<ArtistArtworksNodeCountingConnection>;
  artwork?: Maybe<ArtworkNode>;
  auction?: Maybe<AuctionNode>;
  auctionArtworks?: Maybe<AuctionArtworksNodeCountingConnection>;
  automaticApplyPromocode?: Maybe<PromocodeNode>;
  bannerAuctions?: Maybe<Array<Maybe<AuctionNode>>>;
  calculateTotalCost?: Maybe<CalculateTotalCostResult>;
  category?: Maybe<StarCategoryNode>;
  childCategoriesWithRelations?: Maybe<StarCategoryNodeConnection>;
  collection?: Maybe<CollectionNode>;
  creditActionTypes?: Maybe<CreditActionTypeNodeConnection>;
  creditHistory?: Maybe<CreditHistoryNodeCountingConnection>;
  currentUser?: Maybe<UserNode>;
  deliveryOptions?: Maybe<Array<Maybe<DeliveryOptionNode>>>;
  facebookToken?: Maybe<FacebookTokenNode>;
  featuredArtists?: Maybe<Array<Maybe<ArtistNode>>>;
  featuredArtworks?: Maybe<Array<Maybe<ArtworkNode>>>;
  featuredAuctions?: Maybe<Array<Maybe<AuctionNode>>>;
  featuredStorefronts?: Maybe<FeaturedStorefrontNodeConnection>;
  files?: Maybe<FileNodeConnection>;
  findArtwork?: Maybe<ArtworkNode>;
  findCart?: Maybe<CartNode>;
  findOffer?: Maybe<OfferNode>;
  findUser?: Maybe<UserNode>;
  findUserReferral?: Maybe<UserReferralNode>;
  gallery?: Maybe<GalleryNode>;
  getAuction?: Maybe<AuctionNode>;
  getOrderByEmailAndId?: Maybe<OrderItemNode>;
  getOrderEventsLog?: Maybe<Array<Maybe<OrderEventLogNode>>>;
  grantedSearch?: Maybe<GrantedSearchResultsNode>;
  grantedWebSection?: Maybe<GrantedWebSectionNode>;
  grantedWebSections?: Maybe<GrantedWebSectionNodeConnection>;
  grantedWebSettings?: Maybe<GrantedWebSettingsNodeConnection>;
  instagramPosts?: Maybe<Array<Maybe<InstagramPostNode>>>;
  isUserExists?: Maybe<Scalars['Boolean']>;
  localPrice?: Maybe<LocalPriceNode>;
  marketingEvent?: Maybe<MarketingEventNode>;
  marketingEvents?: Maybe<MarketingEventNodeConnection>;
  mostBidsArtworks?: Maybe<ArtworkNodeConnection>;
  node?: Maybe<Node>;
  offer?: Maybe<OfferNode>;
  order?: Maybe<GrantedOrderNode>;
  orderItem?: Maybe<OrderItemCombinedNode>;
  orderPricing?: Maybe<OrderPricingNode>;
  package?: Maybe<PackageNode>;
  promocode?: Maybe<PromocodeNode>;
  protechtTermsAndConditions?: Maybe<Scalars['String']>;
  reviewStatus?: Maybe<StripeReviewNode>;
  searchArtists?: Maybe<ArtistSearchConnection>;
  searchArtworks?: Maybe<ArtworkSearchConnection>;
  searchAuctions?: Maybe<AuctionSearchConnection>;
  searchImages?: Maybe<ArtworkSearchConnection>;
  searchLots?: Maybe<ArtworkConnection>;
  searchStarV2?: Maybe<StarConnection>;
  searchStorefronts?: Maybe<StorefrontSearchConnection>;
  searchUserOrders?: Maybe<Array<Maybe<GrantedOrderNode>>>;
  shipmentsSuggestion?: Maybe<TevoShipmentsSuggestionNode>;
  storefront?: Maybe<StorefrontNode>;
  tevoShipmentsSuggestion?: Maybe<TevoShipmentsSuggestionNode>;
  tevoTicketGroup?: Maybe<TevoTicketNode>;
  tour?: Maybe<TourNode>;
  trendingArtworks?: Maybe<ArtworkNodeConnection>;
  user?: Maybe<UserNode>;
  venue?: Maybe<VenueNode>;
};


export type QueryAllArtistsArgs = {
  activeArtworks?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  annotateArtworkMinStartDate?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  categories_Contains?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  categoryWithChild_Exact?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  firstName_Istartswith?: InputMaybe<Scalars['String']>;
  firstOrLastName_Istartswith?: InputMaybe<Scalars['String']>;
  hasPackages?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Scalars['String']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastName_Istartswith?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  pk?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  venueCoordinates?: InputMaybe<Scalars['String']>;
};


export type QueryAllArtworksArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  categoryWithChild_Exact?: InputMaybe<Scalars['String']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isEnded?: InputMaybe<Scalars['Boolean']>;
  isEventAnnounced?: InputMaybe<Scalars['Boolean']>;
  isEventStared?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isTransfersToLive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  purchaseType?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venueCoordinates?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type QueryAllArtworksWithCountArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  categoryWithChild_Exact?: InputMaybe<Scalars['String']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isEnded?: InputMaybe<Scalars['Boolean']>;
  isEventAnnounced?: InputMaybe<Scalars['Boolean']>;
  isEventStared?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isTransfersToLive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  purchaseType?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venueCoordinates?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type QueryAllAuctionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  end_Gt?: InputMaybe<Scalars['DateTime']>;
  end_Gte?: InputMaybe<Scalars['DateTime']>;
  end_Lt?: InputMaybe<Scalars['DateTime']>;
  end_Lte?: InputMaybe<Scalars['DateTime']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  isLiveAuction?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  pk?: InputMaybe<Scalars['Int']>;
  showOnAuctionIndex?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  start_Gt?: InputMaybe<Scalars['DateTime']>;
  start_Gte?: InputMaybe<Scalars['DateTime']>;
  start_Lt?: InputMaybe<Scalars['DateTime']>;
  start_Lte?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryAllCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isArtistSet?: InputMaybe<Scalars['Boolean']>;
  isArtworkSet?: InputMaybe<Scalars['Boolean']>;
  isSearchable?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  parent_Name?: InputMaybe<Scalars['String']>;
};


export type QueryAllCitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['String']>;
  coordinatesSort?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  id_In?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
};


export type QueryAllCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['DateTime']>;
  created_Gt?: InputMaybe<Scalars['DateTime']>;
  created_Gte?: InputMaybe<Scalars['DateTime']>;
  created_Lt?: InputMaybe<Scalars['DateTime']>;
  created_Lte?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['DateTime']>;
  updated_Gt?: InputMaybe<Scalars['DateTime']>;
  updated_Gte?: InputMaybe<Scalars['DateTime']>;
  updated_Lt?: InputMaybe<Scalars['DateTime']>;
  updated_Lte?: InputMaybe<Scalars['DateTime']>;
};


export type QueryAllMediumsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllOffersArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork?: InputMaybe<Scalars['ID']>;
  artworkPk?: InputMaybe<Scalars['Int']>;
  auction?: InputMaybe<Scalars['ID']>;
  auctionPk?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['DateTime']>;
  created_Gt?: InputMaybe<Scalars['DateTime']>;
  created_Gte?: InputMaybe<Scalars['DateTime']>;
  created_Lt?: InputMaybe<Scalars['DateTime']>;
  created_Lte?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  price_Gt?: InputMaybe<Scalars['Float']>;
  price_Gte?: InputMaybe<Scalars['Float']>;
  price_Lt?: InputMaybe<Scalars['Float']>;
  price_Lte?: InputMaybe<Scalars['Float']>;
};


export type QueryAllOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  artworkPk?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']>;
  deliveryOption_Type?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderitem_Artwork_Id?: InputMaybe<Scalars['ID']>;
  orderitem_Package_Isnull?: InputMaybe<Scalars['Boolean']>;
  packagePk?: InputMaybe<Scalars['Int']>;
  pk?: InputMaybe<Scalars['Int']>;
  shipping_Email?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  tevoTicketGroupId?: InputMaybe<Scalars['Int']>;
  userFullName?: InputMaybe<Scalars['String']>;
  userOrShippingEmail?: InputMaybe<Scalars['String']>;
  user_Email?: InputMaybe<Scalars['String']>;
};


export type QueryAllPackagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  artworks_Artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artworks_EventStartDate_Date?: InputMaybe<Scalars['Date']>;
  artworks_Slug?: InputMaybe<Scalars['String']>;
  artworks_Title_Icontains?: InputMaybe<Scalars['String']>;
  artworks_Venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isTicket?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryAllPromocodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  promocodechannel_Name?: InputMaybe<Scalars['String']>;
  promocodechannel_Name_In?: InputMaybe<Scalars['String']>;
};


export type QueryAllStorefrontsArgs = {
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryAllToursArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  slug_Icontains?: InputMaybe<Scalars['String']>;
  slug_Istartswith?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Istartswith?: InputMaybe<Scalars['String']>;
};


export type QueryAllUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email_Icontains?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  followedArtists_Slug?: InputMaybe<Scalars['String']>;
  followedArtists_Slug_In?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  grantedorder_Orderitem_Artwork_Id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  pk?: InputMaybe<Scalars['Int']>;
  registrationSource?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  type_In?: InputMaybe<Scalars['String']>;
};


export type QueryAllVenuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  country_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  id_In?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  state_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
};


export type QueryArtistArgs = {
  id: Scalars['ID'];
};


export type QueryArtistArtworksArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork_AuctionSlug?: InputMaybe<Scalars['String']>;
  artwork_IsActive?: InputMaybe<Scalars['Boolean']>;
  artwork_IsHidden?: InputMaybe<Scalars['Boolean']>;
  artwork_IsIpad?: InputMaybe<Scalars['Boolean']>;
  artwork_IsSuppressDisplay?: InputMaybe<Scalars['Boolean']>;
  artwork_Status?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


export type QueryArtworkArgs = {
  id: Scalars['ID'];
};


export type QueryAuctionArgs = {
  id: Scalars['ID'];
};


export type QueryAuctionArtworksArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork_AuctionSlug?: InputMaybe<Scalars['String']>;
  artwork_IsActive?: InputMaybe<Scalars['Boolean']>;
  artwork_IsHidden?: InputMaybe<Scalars['Boolean']>;
  artwork_IsIpad?: InputMaybe<Scalars['Boolean']>;
  artwork_IsSuppressDisplay?: InputMaybe<Scalars['Boolean']>;
  artwork_Status?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


export type QueryCalculateTotalCostArgs = {
  addressId: Scalars['ID'];
  artworkId: Scalars['ID'];
  currencyCode: Currency;
  price: Scalars['Int'];
};


export type QueryCategoryArgs = {
  categoryId?: InputMaybe<Scalars['String']>;
};


export type QueryChildCategoriesWithRelationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categoryId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  isSearchable?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  parent_Name?: InputMaybe<Scalars['String']>;
  relationWith?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryCollectionArgs = {
  id: Scalars['ID'];
};


export type QueryCreditActionTypesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryCreditHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


export type QueryFeaturedStorefrontsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['String']>;
};


export type QueryFilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  slug_Icontains?: InputMaybe<Scalars['String']>;
};


export type QueryFindArtworkArgs = {
  pk: Scalars['Int'];
};


export type QueryFindCartArgs = {
  pk?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};


export type QueryFindOfferArgs = {
  pk?: InputMaybe<Scalars['Int']>;
};


export type QueryFindUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  pk?: InputMaybe<Scalars['Int']>;
};


export type QueryFindUserReferralArgs = {
  code: Scalars['String'];
};


export type QueryGalleryArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryGetAuctionArgs = {
  artworkId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetOrderByEmailAndIdArgs = {
  email: Scalars['String'];
  orderId: Scalars['Int'];
};


export type QueryGetOrderEventsLogArgs = {
  orderId: Scalars['ID'];
};


export type QueryGrantedSearchArgs = {
  query: Scalars['String'];
  types: Array<InputMaybe<Scalars['String']>>;
};


export type QueryGrantedWebSectionArgs = {
  name: Scalars['String'];
};


export type QueryGrantedWebSectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_In?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  type_In?: InputMaybe<Scalars['String']>;
};


export type QueryGrantedWebSettingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  id_In?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_In?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  type_In?: InputMaybe<Scalars['String']>;
};


export type QueryIsUserExistsArgs = {
  email: Scalars['String'];
};


export type QueryLocalPriceArgs = {
  currency?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
};


export type QueryMarketingEventArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
};


export type QueryMarketingEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
};


export type QueryMostBidsArtworksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
};


export type QueryOfferArgs = {
  id: Scalars['ID'];
};


export type QueryOrderArgs = {
  id: Scalars['ID'];
};


export type QueryOrderItemArgs = {
  orderId: Scalars['ID'];
};


export type QueryOrderPricingArgs = {
  addressAttributes: Shipping;
  cartId: Scalars['ID'];
  credit?: InputMaybe<Scalars['Float']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  promocode?: InputMaybe<Scalars['String']>;
};


export type QueryPackageArgs = {
  id: Scalars['ID'];
};


export type QueryPromocodeArgs = {
  id: Scalars['ID'];
};


export type QueryReviewStatusArgs = {
  reviewId: Scalars['String'];
};


export type QuerySearchArtistsArgs = {
  after?: InputMaybe<Scalars['String']>;
  autocomplete?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QuerySearchArtworksArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  auctionPk?: InputMaybe<Scalars['Int']>;
  autocomplete?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QuerySearchAuctionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  autocomplete?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QuerySearchImagesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  auctionPk?: InputMaybe<Scalars['Int']>;
  autocomplete?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QuerySearchLotsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchStarV2Args = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchStorefrontsArgs = {
  after?: InputMaybe<Scalars['String']>;
  autocomplete?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QuerySearchUserOrdersArgs = {
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};


export type QueryShipmentsSuggestionArgs = {
  addressAttributes: Shipping;
  cartId: Scalars['ID'];
};


export type QueryStorefrontArgs = {
  id: Scalars['Int'];
};


export type QueryTevoShipmentsSuggestionArgs = {
  addressAttributes: Shipping;
  ticketGroupId: Scalars['ID'];
};


export type QueryTevoTicketGroupArgs = {
  ticketGroupId: Scalars['ID'];
};


export type QueryTourArgs = {
  id: Scalars['ID'];
};


export type QueryTrendingArtworksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryVenueArgs = {
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** An error occurred while recovering the password. Please check the email address and try again. */
export type RecoverPasswordFailure = {
  __typename?: 'RecoverPasswordFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type RecoverPasswordInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

export type RecoverPasswordResult = RecoverPasswordFailure | RecoverPasswordSuccess;

export type RecoverPasswordSuccess = {
  __typename?: 'RecoverPasswordSuccess';
  result?: Maybe<Scalars['Boolean']>;
};

export type RefreshFbTokenInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type RemoveArtworksFromCollectionInput = {
  artworks?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['ID']>;
};

export type RemoveArtworksFromCollectionPayload = {
  __typename?: 'RemoveArtworksFromCollectionPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  collection?: Maybe<CollectionNode>;
};

export type RemoveAutoChargePreferenceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type RemoveAutoChargePreferencePayload = {
  __typename?: 'RemoveAutoChargePreferencePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type RemoveCreditCardInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type RemoveCreditCardPayload = {
  __typename?: 'RemoveCreditCardPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

/** An error occurred while removing the gallery address */
export type RemoveGalleryAddressFailure = {
  __typename?: 'RemoveGalleryAddressFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type RemoveGalleryAddressInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type RemoveGalleryAddressResult = RemoveGalleryAddressFailure | RemoveGalleryAddressSuccess;

export type RemoveGalleryAddressSuccess = {
  __typename?: 'RemoveGalleryAddressSuccess';
  result?: Maybe<Scalars['Boolean']>;
};

export type RemovePaymentMethodInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type RemovePaymentMethodPayload = {
  __typename?: 'RemovePaymentMethodPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type RemoveRegisteredDeviceFailure = {
  __typename?: 'RemoveRegisteredDeviceFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type RemoveRegisteredDeviceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  registrationToken: Scalars['String'];
};

export type RemoveRegisteredDeviceResult = RemoveRegisteredDeviceFailure | RemoveRegisteredDeviceSuccess;

export type RemoveRegisteredDeviceSuccess = {
  __typename?: 'RemoveRegisteredDeviceSuccess';
  registrationToken?: Maybe<Scalars['String']>;
};

export type RemoveTevoCreditCardFailure = {
  __typename?: 'RemoveTevoCreditCardFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type RemoveTevoCreditCardInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  creditCardId: Scalars['ID'];
};

export type RemoveTevoCreditCardResult = RemoveTevoCreditCardFailure | RemoveTevoCreditCardSuccess;

export type RemoveTevoCreditCardSuccess = {
  __typename?: 'RemoveTevoCreditCardSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export type RemoveUserAddressInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type RemoveUserAddressPayload = {
  __typename?: 'RemoveUserAddressPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type RequestShippingQuoteFailure = {
  __typename?: 'RequestShippingQuoteFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type RequestShippingQuoteInput = {
  addressId: Scalars['ID'];
  artworkId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  currency: Currency;
  price: Scalars['Int'];
};

export type RequestShippingQuoteResult = RequestShippingQuoteFailure | RequestShippingQuoteSuccess;

export type RequestShippingQuoteSuccess = {
  __typename?: 'RequestShippingQuoteSuccess';
  result?: Maybe<Scalars['Boolean']>;
};

/** An error occurred while resetting the password. Please try again. */
export type ResetPasswordFailure = {
  __typename?: 'ResetPasswordFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type ResetPasswordInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  confirmPassword: Scalars['String'];
  password: Scalars['String'];
  resetToken: Scalars['String'];
  userId: Scalars['Int'];
};

export type ResetPasswordResult = ResetPasswordFailure | ResetPasswordSuccess;

export type ResetPasswordSuccess = {
  __typename?: 'ResetPasswordSuccess';
  user?: Maybe<UserNode>;
};

export type ResidentialAddress = {
  address: Scalars['String'];
  city: Scalars['String'];
  country: Countries;
  phone: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  zipcode: Scalars['String'];
};

export type Result = Failure | Success;

export type RunScriptFailure = {
  __typename?: 'RunScriptFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type RunScriptInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  scriptName: Scalars['String'];
};

export type RunScriptResult = RunScriptFailure | RunScriptSuccess;

export type RunScriptSuccess = {
  __typename?: 'RunScriptSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export type SaveCartCurrentShippingEmailFailure = {
  __typename?: 'SaveCartCurrentShippingEmailFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type SaveCartCurrentShippingEmailInput = {
  cartId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

export type SaveCartCurrentShippingEmailResult = SaveCartCurrentShippingEmailFailure | SaveCartCurrentShippingEmailSuccess;

export type SaveCartCurrentShippingEmailSuccess = {
  __typename?: 'SaveCartCurrentShippingEmailSuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export type SendVerificationCodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
};

export type SetAccountTypeFailure = {
  __typename?: 'SetAccountTypeFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type SetAccountTypeInput = {
  accountType: AccountType;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SetAccountTypeResult = SetAccountTypeFailure | SetAccountTypeSuccess;

export type SetAccountTypeSuccess = {
  __typename?: 'SetAccountTypeSuccess';
  accountType?: Maybe<AccountType>;
};

export type SetCompanyAddressFailure = {
  __typename?: 'SetCompanyAddressFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type SetCompanyAddressInput = {
  address: CompanyAddress;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SetCompanyAddressResult = SetCompanyAddressFailure | SetCompanyAddressSuccess;

export type SetCompanyAddressSuccess = {
  __typename?: 'SetCompanyAddressSuccess';
  address?: Maybe<UserAddressNode>;
};

export type SetDateOfBirthFailure = {
  __typename?: 'SetDateOfBirthFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type SetDateOfBirthInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  day: Scalars['Int'];
  month: Scalars['Int'];
  year: Scalars['Int'];
};

export type SetDateOfBirthResult = SetDateOfBirthFailure | SetDateOfBirthSuccess;

export type SetDateOfBirthSuccess = {
  __typename?: 'SetDateOfBirthSuccess';
  dateOfBirth?: Maybe<Scalars['Date']>;
};

export type SetFbTokenInput = {
  accessToken: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SetPrimaryResidentialAddressFailure = {
  __typename?: 'SetPrimaryResidentialAddressFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type SetPrimaryResidentialAddressInput = {
  address: ResidentialAddress;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SetPrimaryResidentialAddressResult = SetPrimaryResidentialAddressFailure | SetPrimaryResidentialAddressSuccess;

export type SetPrimaryResidentialAddressSuccess = {
  __typename?: 'SetPrimaryResidentialAddressSuccess';
  address?: Maybe<UserAddressNode>;
};

export type SharingNode = {
  __typename?: 'SharingNode';
  facebookUrl?: Maybe<Scalars['String']>;
  pinterestUrl?: Maybe<Scalars['String']>;
  tumblrUrl?: Maybe<Scalars['String']>;
  twitterUrl?: Maybe<Scalars['String']>;
};

export type Shipping = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type ShippingNode = Node & {
  __typename?: 'ShippingNode';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  bidlogSet?: Maybe<BidLogNodeConnection>;
  city: Scalars['String'];
  country: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  grantedorderSet?: Maybe<GrantedOrderNodeConnection>;
  /** The ID of the object. */
  id: Scalars['ID'];
  phoneNumber: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  zipCode: Scalars['String'];
};


export type ShippingNodeBidlogSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork_Id?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ShippingNodeGrantedorderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']>;
  deliveryOption_Type?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderitem_Artwork_Id?: InputMaybe<Scalars['ID']>;
  orderitem_Package_Isnull?: InputMaybe<Scalars['Boolean']>;
  shipping_Email?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  user_Email?: InputMaybe<Scalars['String']>;
};

/** An error occurred while signing up. Please try again. */
export type SignupFailure = {
  __typename?: 'SignupFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

/** An error occurred while signing up for the auction. Please try again. */
export type SignupForAuctionFailure = {
  __typename?: 'SignupForAuctionFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type SignupForAuctionInput = {
  auctionPk: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  newsletter?: InputMaybe<Scalars['Boolean']>;
  phone: Scalars['String'];
  sms?: InputMaybe<Scalars['Boolean']>;
  terms?: InputMaybe<Scalars['Boolean']>;
};

export type SignupForAuctionResult = SignupForAuctionFailure | SignupForAuctionSuccess;

export type SignupForAuctionSuccess = {
  __typename?: 'SignupForAuctionSuccess';
  paddleNumber?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<UserNode>;
};

export type SignupGuestInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SignupInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  newsletter?: InputMaybe<Scalars['Boolean']>;
  password: Scalars['String'];
  recaptchaToken?: InputMaybe<Scalars['String']>;
  referralCode?: InputMaybe<Scalars['String']>;
  terms?: InputMaybe<Scalars['Boolean']>;
};

export type SignupResult = SignupFailure | SignupSuccess;

export type SignupSuccess = {
  __typename?: 'SignupSuccess';
  token?: Maybe<Scalars['String']>;
  user?: Maybe<UserNode>;
};

export type SpellingSuggestionNode = {
  __typename?: 'SpellingSuggestionNode';
  suggestion?: Maybe<Scalars['String']>;
};

export type StarCategoryNode = Node & {
  __typename?: 'StarCategoryNode';
  artistSet?: Maybe<ArtistNodeConnection>;
  artworkSet?: Maybe<ArtworkNodeConnection>;
  /** The ID of the object. */
  id: Scalars['ID'];
  image?: Maybe<FileNode>;
  isSearchable: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  parent?: Maybe<StarCategoryNode>;
  pk?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  starcategorySet?: Maybe<StarCategoryNodeConnection>;
  tevoId?: Maybe<Scalars['Int']>;
};


export type StarCategoryNodeArtistSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories_Contains?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  firstName_Istartswith?: InputMaybe<Scalars['String']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastName_Istartswith?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
};


export type StarCategoryNodeArtworkSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type StarCategoryNodeStarcategorySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isSearchable?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  parent_Name?: InputMaybe<Scalars['String']>;
};

export type StarCategoryNodeConnection = {
  __typename?: 'StarCategoryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StarCategoryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StarCategoryNode` and its cursor. */
export type StarCategoryNodeEdge = {
  __typename?: 'StarCategoryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StarCategoryNode>;
};

export type StarConnection = {
  __typename?: 'StarConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StarEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Star` and its cursor. */
export type StarEdge = {
  __typename?: 'StarEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ArtistNode>;
};

export type StarSearchResultNode = {
  __typename?: 'StarSearchResultNode';
  fullName: Scalars['String'];
  imagePath?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
};

export type StorefrontNode = {
  __typename?: 'StorefrontNode';
  description: Scalars['String'];
  featuredStorefronts?: Maybe<Array<Maybe<FeaturedStorefrontNode>>>;
  imgUrl: Scalars['String'];
  storefrontId: Scalars['ID'];
  title: Scalars['String'];
  urlSlug: Scalars['String'];
};

export type StorefrontSearchConnection = {
  __typename?: 'StorefrontSearchConnection';
  count?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StorefrontSearchEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  spellingSuggestions?: Maybe<Array<Maybe<SpellingSuggestionNode>>>;
};

/** A Relay edge containing a `StorefrontSearch` and its cursor. */
export type StorefrontSearchEdge = {
  __typename?: 'StorefrontSearchEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StorefrontSearchNode>;
};

export type StorefrontSearchInterface = {
  description?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  tokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  value?: Maybe<Scalars['String']>;
};

export type StorefrontSearchNode = Node & StorefrontSearchInterface & {
  __typename?: 'StorefrontSearchNode';
  description?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  tokens?: Maybe<Array<Maybe<Scalars['String']>>>;
  value?: Maybe<Scalars['String']>;
};

export type StripeReviewNode = {
  __typename?: 'StripeReviewNode';
  closedReason?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  open: Scalars['Boolean'];
  openedReason: Scalars['String'];
  paymentIntent: Scalars['String'];
  reason: Scalars['String'];
};

export type SubmitAuctionDonationFailure = {
  __typename?: 'SubmitAuctionDonationFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type SubmitAuctionDonationInput = {
  amount: Scalars['Float'];
  auctionPk: Scalars['Int'];
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type SubmitAuctionDonationResult = SubmitAuctionDonationFailure | SubmitAuctionDonationSuccess;

export type SubmitAuctionDonationSuccess = {
  __typename?: 'SubmitAuctionDonationSuccess';
  offer?: Maybe<OfferNode>;
};

/** There was an error submitting your donation. Please try again. */
export type SubmitDonationFailure = {
  __typename?: 'SubmitDonationFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type SubmitDonationInput = {
  amount: Scalars['Float'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['ID'];
};

export type SubmitDonationResult = SubmitDonationFailure | SubmitDonationSuccess;

export type SubmitDonationSuccess = {
  __typename?: 'SubmitDonationSuccess';
  donation?: Maybe<UserDonationNode>;
};

export type SubmitForGiveawayFailure = {
  __typename?: 'SubmitForGiveawayFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type SubmitForGiveawayInput = {
  artworkId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  data: GiveawaySubmissionData;
};

export type SubmitForGiveawayResult = SubmitForGiveawayFailure | SubmitForGiveawaySuccess;

export type SubmitForGiveawaySuccess = {
  __typename?: 'SubmitForGiveawaySuccess';
  success?: Maybe<Scalars['Boolean']>;
};

export type Success = {
  __typename?: 'Success';
  offer?: Maybe<OfferNode>;
};

export type TemplateNode = {
  __typename?: 'TemplateNode';
  about?: Maybe<AboutNode>;
  hero?: Maybe<HeroNode>;
  lots?: Maybe<Scalars['Boolean']>;
  preview?: Maybe<Scalars['Boolean']>;
};

export type TevoEventConfigurationNode = {
  __typename?: 'TevoEventConfigurationNode';
  fanvenuesKey?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  seatingChart?: Maybe<TevoSeatingChartNode>;
  ticketUtilsId?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

export type TevoOrderItemNode = {
  __typename?: 'TevoOrderItemNode';
  const?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  orderId?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  seats?: Maybe<Array<Maybe<Scalars['String']>>>;
  ticketGroup?: Maybe<TevoTicketNode>;
};

export type TevoOrderNode = {
  __typename?: 'TevoOrderNode';
  additionalExpense?: Maybe<Scalars['Float']>;
  balance?: Maybe<Scalars['Float']>;
  buyerRejectionNotes?: Maybe<Scalars['String']>;
  buyerRejectionReason?: Maybe<Scalars['String']>;
  buyerState?: Maybe<Scalars['String']>;
  completedNonRefundPaymentsTotal?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByIpAddress?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  fee?: Maybe<Scalars['Float']>;
  fraudCheckStatus?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Maybe<TevoOrderItemNode>>>;
  notes?: Maybe<Array<Maybe<Scalars['String']>>>;
  pendingBalance?: Maybe<Scalars['Float']>;
  refunded?: Maybe<Scalars['Float']>;
  sellerRejectionNotes?: Maybe<Scalars['String']>;
  sellerRejectionReason?: Maybe<Scalars['String']>;
  sellerState?: Maybe<Scalars['String']>;
  shipments?: Maybe<Array<Maybe<TevoShipmentsNode>>>;
  shipping?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TevoSeatingChartNode = {
  __typename?: 'TevoSeatingChartNode';
  large?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
};

export type TevoShipmentsNode = {
  __typename?: 'TevoShipmentsNode';
  aribill?: Maybe<Scalars['String']>;
  cost?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  serviceType?: Maybe<Scalars['String']>;
  shipToName?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tmMobileLink?: Maybe<Scalars['String']>;
  trackingUrl?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type TevoShipmentsSuggestionNode = {
  __typename?: 'TevoShipmentsSuggestionNode';
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  provider?: Maybe<Scalars['String']>;
  serviceType?: Maybe<Scalars['String']>;
};

export type TevoTicketDiscount = {
  __typename?: 'TevoTicketDiscount';
  discount?: Maybe<Scalars['Float']>;
  discountedPrice?: Maybe<Scalars['Float']>;
  expiresOn?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Scalars['String']>;
};

export type TevoTicketEventNode = {
  __typename?: 'TevoTicketEventNode';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  occursAt?: Maybe<Scalars['DateTime']>;
  venue?: Maybe<TevoTicketEventVenueNode>;
};

export type TevoTicketEventVenueNode = {
  __typename?: 'TevoTicketEventVenueNode';
  name?: Maybe<Scalars['String']>;
};

export type TevoTicketNode = {
  __typename?: 'TevoTicketNode';
  availableQuantity?: Maybe<Scalars['Int']>;
  discount?: Maybe<TevoTicketDiscount>;
  event?: Maybe<TevoTicketEventNode>;
  format?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  inHand?: Maybe<Scalars['Boolean']>;
  inHandOn?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  retailPrice?: Maybe<Scalars['Float']>;
  row?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  splits?: Maybe<Array<Maybe<Scalars['Int']>>>;
  tevoSectionName?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type TotalCostNode = TotalCostNodeInterface & {
  __typename?: 'TotalCostNode';
  buyersPremium?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  estimatedArrival?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  shippingCost?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['String']>;
  totalCost?: Maybe<Scalars['String']>;
};

export type TotalCostNodeInterface = {
  buyersPremium?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  estimatedArrival?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['String']>;
  shippingCost?: Maybe<Scalars['String']>;
  tax?: Maybe<Scalars['String']>;
  totalCost?: Maybe<Scalars['String']>;
};

export type TourNode = Node & {
  __typename?: 'TourNode';
  artistFullName?: Maybe<Scalars['String']>;
  artistSlug?: Maybe<Scalars['String']>;
  artworkSet?: Maybe<ArtworkNodeConnection>;
  artworks?: Maybe<Array<Maybe<ArtworkNode>>>;
  created: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  featuredDate?: Maybe<Scalars['DateTime']>;
  featuringArtists?: Maybe<Array<Maybe<ArtistNode>>>;
  /** The ID of the object. */
  id: Scalars['ID'];
  mainArtist?: Maybe<ArtistNode>;
  pk?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  status: Scalars['String'];
  title: Scalars['String'];
  tourPhoto?: Maybe<FileNode>;
  updated: Scalars['DateTime'];
};


export type TourNodeArtworkSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type TourNodeArtworksArgs = {
  eventStartDate_Gte?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};

export type TourNodeConnection = {
  __typename?: 'TourNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TourNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TourNode` and its cursor. */
export type TourNodeEdge = {
  __typename?: 'TourNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TourNode>;
};

export type TourSearchResultNode = {
  __typename?: 'TourSearchResultNode';
  imagePath?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type TrackArtworkTrendInput = {
  artistId?: InputMaybe<Scalars['ID']>;
  artworkId?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type TrackArtworkTrendPayload = {
  __typename?: 'TrackArtworkTrendPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Boolean']>;
};

export type UnfollowArtistInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type UnfollowAuctionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type UnfollowAuctionPayload = {
  __typename?: 'UnfollowAuctionPayload';
  auction?: Maybe<AuctionNode>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UnfollowVenueInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type UnwatchArtworkInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type UnwatchArtworkPayload = {
  __typename?: 'UnwatchArtworkPayload';
  artwork?: Maybe<ArtworkNode>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateArtworkLotInputType = {
  artworkPk: Scalars['Int'];
  lotNumber: Scalars['Int'];
};

export type UpdateArtworkLotsFailure = {
  __typename?: 'UpdateArtworkLotsFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateArtworkLotsInput = {
  auctionPk?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  updates?: InputMaybe<Array<InputMaybe<UpdateArtworkLotInputType>>>;
};

export type UpdateArtworkLotsResult = UpdateArtworkLotsFailure | UpdateArtworkLotsSuccess;

export type UpdateArtworkLotsSuccess = {
  __typename?: 'UpdateArtworkLotsSuccess';
  artworks?: Maybe<Array<Maybe<ArtworkNode>>>;
};

export type UpdateAuctionFailure = {
  __typename?: 'UpdateAuctionFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateAuctionInput = {
  announceDate?: InputMaybe<Scalars['DateTime']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryNotes?: InputMaybe<Scalars['String']>;
  deliveryOption?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  eventStartDate?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal?: InputMaybe<Scalars['DateTime']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id: Scalars['ID'];
  meta?: InputMaybe<Scalars['String']>;
  starId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startingBid?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  subTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  tourId?: InputMaybe<Scalars['ID']>;
  venueId?: InputMaybe<Scalars['ID']>;
};

export type UpdateAuctionResult = UpdateAuctionFailure | UpdateAuctionSuccess;

export type UpdateAuctionSuccess = {
  __typename?: 'UpdateAuctionSuccess';
  auction?: Maybe<ArtworkNode>;
};

export type UpdateAutoChargePreferenceInput = {
  artworkId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  creditCardId: Scalars['ID'];
  userAddressId: Scalars['ID'];
};

export type UpdateAutoChargePreferencePayload = {
  __typename?: 'UpdateAutoChargePreferencePayload';
  autoChargePreference?: Maybe<AutoChargePreferenceNode>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type UpdateCreditActionTypeInput = {
  amount?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateEventFailure = {
  __typename?: 'UpdateEventFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateEventInput = {
  announceDate?: InputMaybe<Scalars['DateTime']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  eventStartDate?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal?: InputMaybe<Scalars['DateTime']>;
  externalLink?: InputMaybe<Scalars['String']>;
  externalVipLink?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuringStarIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  id: Scalars['ID'];
  meta?: InputMaybe<Scalars['String']>;
  salesOffDateLocal?: InputMaybe<Scalars['DateTime']>;
  salesOnDateLocal?: InputMaybe<Scalars['DateTime']>;
  starId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
  subTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  tourId?: InputMaybe<Scalars['ID']>;
  venueId?: InputMaybe<Scalars['ID']>;
};

export type UpdateEventResult = UpdateEventFailure | UpdateEventSuccess;

export type UpdateEventSuccess = {
  __typename?: 'UpdateEventSuccess';
  event?: Maybe<ArtworkNode>;
};

export type UpdateFbTokenFailure = {
  __typename?: 'UpdateFBTokenFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateFbTokenResult = UpdateFbTokenFailure | UpdateFbTokenSuccess;

export type UpdateFbTokenSuccess = {
  __typename?: 'UpdateFBTokenSuccess';
  fbToken?: Maybe<FacebookTokenNode>;
};

/** There was an error updating your featured_storefront. Please try again. */
export type UpdateFeaturedStorefrontsFailure = {
  __typename?: 'UpdateFeaturedStorefrontsFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateFeaturedStorefrontsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  updates?: InputMaybe<Array<InputMaybe<UpdateFeaturedStorefrontsInputType>>>;
};

export type UpdateFeaturedStorefrontsInputType = {
  featuredStorefrontPk: Scalars['Int'];
  position: Scalars['Int'];
};

export type UpdateFeaturedStorefrontsResult = UpdateFeaturedStorefrontsFailure | UpdateFeaturedStorefrontsSuccess;

export type UpdateFeaturedStorefrontsSuccess = {
  __typename?: 'UpdateFeaturedStorefrontsSuccess';
  result?: Maybe<Scalars['Boolean']>;
};

/** An error occurred while updating the gallery address */
export type UpdateGalleryAddressFailure = {
  __typename?: 'UpdateGalleryAddressFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateGalleryAddressInput = {
  city: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  country: Country;
  id: Scalars['ID'];
  kind: GalleryAddressKind;
  name: Scalars['String'];
  phone: Scalars['String'];
  postalCode: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
};

export type UpdateGalleryAddressResult = UpdateGalleryAddressFailure | UpdateGalleryAddressSuccess;

export type UpdateGalleryAddressSuccess = {
  __typename?: 'UpdateGalleryAddressSuccess';
  address?: Maybe<GalleryAddressNode>;
};

/** An error occurred while updating the artwork */
export type UpdateGalleryArtworkFailure = {
  __typename?: 'UpdateGalleryArtworkFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateGalleryArtworkInput = {
  additionalInfoText?: InputMaybe<Scalars['String']>;
  artistBiography?: InputMaybe<Scalars['String']>;
  artistId?: InputMaybe<Scalars['ID']>;
  artistProof?: InputMaybe<Scalars['String']>;
  artistProofs?: InputMaybe<Scalars['String']>;
  artworkId?: InputMaybe<Scalars['ID']>;
  auctionId?: InputMaybe<Scalars['ID']>;
  buyNow?: InputMaybe<Scalars['Float']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  creationDate?: InputMaybe<Scalars['String']>;
  depth?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  dimensionNotes?: InputMaybe<Scalars['String']>;
  dimensionsType?: InputMaybe<DimensionType>;
  displayAddress?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  earliestDateForShipmentTimestamp?: InputMaybe<Scalars['Int']>;
  edition?: InputMaybe<Scalars['String']>;
  editionUnnumbered?: InputMaybe<Scalars['Boolean']>;
  editions?: InputMaybe<Scalars['String']>;
  electronicDelivery?: InputMaybe<Scalars['Boolean']>;
  endType?: InputMaybe<EndType>;
  estimatedValue?: InputMaybe<Scalars['Float']>;
  factSheetPk?: InputMaybe<Scalars['Int']>;
  framed?: InputMaybe<Scalars['Boolean']>;
  framedDepth?: InputMaybe<Scalars['Float']>;
  framedHeight?: InputMaybe<Scalars['Float']>;
  framedUnits?: InputMaybe<DimensionUnit>;
  framedWidth?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  imagePks?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isAdultContent?: InputMaybe<Scalars['Boolean']>;
  isSigned?: InputMaybe<Scalars['Boolean']>;
  isUnique?: InputMaybe<Scalars['Boolean']>;
  literature?: InputMaybe<Scalars['String']>;
  mediumId?: InputMaybe<Scalars['ID']>;
  openEdition?: InputMaybe<Scalars['Boolean']>;
  priceless?: InputMaybe<Scalars['Boolean']>;
  primaryImagePk?: InputMaybe<Scalars['Int']>;
  purchaseStatus?: InputMaybe<PurchaseStatus>;
  purchaseType?: InputMaybe<PurchaseType>;
  shippingFromAddressId?: InputMaybe<Scalars['ID']>;
  signatureDescription?: InputMaybe<Scalars['String']>;
  sponsoredBy?: InputMaybe<Scalars['String']>;
  sponsoredByLink?: InputMaybe<Scalars['String']>;
  startingBid?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<ArtworkStatus>;
  title: Scalars['String'];
  units?: InputMaybe<DimensionUnit>;
  weight?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type UpdateGalleryArtworkResult = UpdateGalleryArtworkFailure | UpdateGalleryArtworkSuccess;

/** An error occurred while updating the artwork status */
export type UpdateGalleryArtworkStatusFailure = {
  __typename?: 'UpdateGalleryArtworkStatusFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateGalleryArtworkStatusInput = {
  artworkId?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ArtworkStatus>;
};

export type UpdateGalleryArtworkStatusResult = UpdateGalleryArtworkStatusFailure | UpdateGalleryArtworkStatusSuccess;

export type UpdateGalleryArtworkStatusSuccess = {
  __typename?: 'UpdateGalleryArtworkStatusSuccess';
  artwork?: Maybe<ArtworkNode>;
};

export type UpdateGalleryArtworkSuccess = {
  __typename?: 'UpdateGalleryArtworkSuccess';
  artwork?: Maybe<ArtworkNode>;
};

/** An error occurred while updating the artworks statuses */
export type UpdateGalleryArtworksStatusFailure = {
  __typename?: 'UpdateGalleryArtworksStatusFailure';
  errorMessage?: Maybe<Scalars['String']>;
  failedArtworkIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateGalleryArtworksStatusInput = {
  artworkIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ArtworkStatus>;
};

export type UpdateGalleryArtworksStatusResult = UpdateGalleryArtworksStatusFailure | UpdateGalleryArtworksStatusSuccess;

export type UpdateGalleryArtworksStatusSuccess = {
  __typename?: 'UpdateGalleryArtworksStatusSuccess';
  artworks?: Maybe<Array<Maybe<ArtworkNode>>>;
};

/** An error occurred while updating the auction event address */
export type UpdateGalleryAuctionEventAddressFailure = {
  __typename?: 'UpdateGalleryAuctionEventAddressFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateGalleryAuctionEventAddressInput = {
  auctionId: Scalars['ID'];
  city: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  country: Country;
  postalCode: Scalars['String'];
  state: Scalars['String'];
  street: Scalars['String'];
};

export type UpdateGalleryAuctionEventAddressResult = UpdateGalleryAuctionEventAddressFailure | UpdateGalleryAuctionEventAddressSuccess;

export type UpdateGalleryAuctionEventAddressSuccess = {
  __typename?: 'UpdateGalleryAuctionEventAddressSuccess';
  eventInfo?: Maybe<EventNode>;
};

/** An error occurred while updating the auction event */
export type UpdateGalleryAuctionEventFailure = {
  __typename?: 'UpdateGalleryAuctionEventFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateGalleryAuctionEventInput = {
  auctionId: Scalars['ID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  startTimestamp?: InputMaybe<Scalars['Int']>;
  ticketLink?: InputMaybe<Scalars['String']>;
  venueName?: InputMaybe<Scalars['String']>;
};

export type UpdateGalleryAuctionEventResult = UpdateGalleryAuctionEventFailure | UpdateGalleryAuctionEventSuccess;

export type UpdateGalleryAuctionEventSuccess = {
  __typename?: 'UpdateGalleryAuctionEventSuccess';
  eventInfo?: Maybe<EventNode>;
};

/** An error occurred while updating the auction */
export type UpdateGalleryAuctionFailure = {
  __typename?: 'UpdateGalleryAuctionFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateGalleryAuctionInput = {
  auctionId: Scalars['ID'];
  briefDescription?: InputMaybe<Scalars['String']>;
  catalogPk?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  specialTerms?: InputMaybe<Scalars['String']>;
};

export type UpdateGalleryAuctionResult = UpdateGalleryAuctionFailure | UpdateGalleryAuctionSuccess;

export type UpdateGalleryAuctionSuccess = {
  __typename?: 'UpdateGalleryAuctionSuccess';
  auction?: Maybe<AuctionNode>;
};

/** An error occurred while updating the gallery */
export type UpdateGalleryFailure = {
  __typename?: 'UpdateGalleryFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateGalleryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  galleryId?: InputMaybe<Scalars['ID']>;
  logoImagePk?: InputMaybe<Scalars['Int']>;
};

export type UpdateGalleryResult = UpdateGalleryFailure | UpdateGallerySuccess;

export type UpdateGallerySuccess = {
  __typename?: 'UpdateGallerySuccess';
  gallery?: Maybe<GalleryNode>;
};

export type UpdateGrantedWebSectionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateGrantedWebSettingsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateMarketingEventFailure = {
  __typename?: 'UpdateMarketingEventFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateMarketingEventInput = {
  artworkIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateMarketingEventResult = UpdateMarketingEventFailure | UpdateMarketingEventSuccess;

export type UpdateMarketingEventSuccess = {
  __typename?: 'UpdateMarketingEventSuccess';
  marketingEvent?: Maybe<MarketingEventNode>;
};

export type UpdateOrderAddressFailure = {
  __typename?: 'UpdateOrderAddressFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateOrderAddressInput = {
  addressPk?: InputMaybe<Scalars['Int']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderPk?: InputMaybe<Scalars['Int']>;
};

export type UpdateOrderAddressResult = UpdateOrderAddressFailure | UpdateOrderAddressSuccess;

export type UpdateOrderAddressSuccess = {
  __typename?: 'UpdateOrderAddressSuccess';
  order?: Maybe<OrderNode>;
};

export type UpdateOrderShippingInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  shipping: Shipping;
};

export type UpdatePackageBulkFailure = {
  __typename?: 'UpdatePackageBulkFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdatePackageBulkInput = {
  bulkCopy?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryNotes?: InputMaybe<Scalars['String']>;
  deliveryOptionId?: InputMaybe<Scalars['ID']>;
  imageId?: InputMaybe<Scalars['ID']>;
  longDescription?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  newEventId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  newName?: InputMaybe<Scalars['String']>;
  newPrice?: InputMaybe<Scalars['Int']>;
  packagesIdsToReattach?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  price?: InputMaybe<Scalars['Int']>;
  shortDescription?: InputMaybe<Scalars['String']>;
  tourId?: InputMaybe<Scalars['ID']>;
};

export type UpdatePackageBulkResult = UpdatePackageBulkFailure | UpdatePackageBulkSuccess;

export type UpdatePackageBulkSuccess = {
  __typename?: 'UpdatePackageBulkSuccess';
  packages?: Maybe<Array<Maybe<PackageNode>>>;
};

export type UpdatePackageFailure = {
  __typename?: 'UpdatePackageFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdatePackageInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  deliveryNotes?: InputMaybe<Scalars['String']>;
  deliveryOption?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  imageId?: InputMaybe<Scalars['Int']>;
  isTicket?: InputMaybe<Scalars['Boolean']>;
  longDescription?: InputMaybe<Scalars['String']>;
  maxSplit?: InputMaybe<Scalars['Int']>;
  minSplit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  shortDescription?: InputMaybe<Scalars['String']>;
};

export type UpdatePackageResult = UpdatePackageFailure | UpdatePackageSuccess;

export type UpdatePackageSuccess = {
  __typename?: 'UpdatePackageSuccess';
  package?: Maybe<PackageNode>;
};

export type UpdatePromocodeFailure = {
  __typename?: 'UpdatePromocodeFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdatePromocodeInput = {
  amount?: InputMaybe<Scalars['Int']>;
  automaticApply?: InputMaybe<Scalars['Boolean']>;
  channels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  type?: InputMaybe<Scalars['String']>;
  uses?: InputMaybe<Scalars['Int']>;
};

export type UpdatePromocodeResult = UpdatePromocodeFailure | UpdatePromocodeSuccess;

export type UpdatePromocodeSuccess = {
  __typename?: 'UpdatePromocodeSuccess';
  promocode?: Maybe<PromocodeNode>;
};

export type UpdateStarCategoryBulkFailure = {
  __typename?: 'UpdateStarCategoryBulkFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateStarCategoryBulkInput = {
  categories: Array<InputMaybe<CategoryInput>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type UpdateStarCategoryBulkResult = UpdateStarCategoryBulkFailure | UpdateStarCategoryBulkSuccess;

export type UpdateStarCategoryBulkSuccess = {
  __typename?: 'UpdateStarCategoryBulkSuccess';
  starCategories?: Maybe<Array<Maybe<StarCategoryNode>>>;
};

export type UpdateStarCategoryFailure = {
  __typename?: 'UpdateStarCategoryFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateStarCategoryInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imageId?: InputMaybe<Scalars['ID']>;
  isSearchable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['ID']>;
  position?: InputMaybe<Scalars['Int']>;
};

export type UpdateStarCategoryResult = UpdateStarCategoryFailure | UpdateStarCategorySuccess;

export type UpdateStarCategorySuccess = {
  __typename?: 'UpdateStarCategorySuccess';
  starCategory?: Maybe<StarCategoryNode>;
};

export type UpdateStarFailure = {
  __typename?: 'UpdateStarFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateStarInput = {
  bio?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['String']>;
  fileId?: InputMaybe<Scalars['ID']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateStarResult = UpdateStarFailure | UpdateStarSuccess;

export type UpdateStarSuccess = {
  __typename?: 'UpdateStarSuccess';
  star?: Maybe<ArtistNode>;
};

export type UpdateTourFailure = {
  __typename?: 'UpdateTourFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateTourInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  tourPhotoId?: InputMaybe<Scalars['ID']>;
};

export type UpdateTourResult = UpdateTourFailure | UpdateTourSuccess;

export type UpdateTourSuccess = {
  __typename?: 'UpdateTourSuccess';
  tour?: Maybe<TourNode>;
};

export type UpdateUserAddressFailure = {
  __typename?: 'UpdateUserAddressFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateUserAddressInput = {
  address: Scalars['String'];
  city: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  country: Countries;
  email?: InputMaybe<Scalars['String']>;
  fullName: Scalars['String'];
  id: Scalars['ID'];
  isBilling?: InputMaybe<Scalars['Boolean']>;
  phone: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  zipcode: Scalars['String'];
};

export type UpdateUserAddressResult = UpdateUserAddressFailure | UpdateUserAddressSuccess;

export type UpdateUserAddressSuccess = {
  __typename?: 'UpdateUserAddressSuccess';
  address?: Maybe<UserAddressNode>;
};

export type UpdateUserFailure = {
  __typename?: 'UpdateUserFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateUserInformationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateUserNotificationsInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  notifyOnNewWorks: Scalars['Boolean'];
};

export type UpdateUserNotificationsPayload = {
  __typename?: 'UpdateUserNotificationsPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  user?: Maybe<UserNode>;
};

export type UpdateUserResult = UpdateUserFailure | UpdateUserSuccess;

export type UpdateUserSuccess = {
  __typename?: 'UpdateUserSuccess';
  user?: Maybe<UserNode>;
};

export type UpdateVenueFailure = {
  __typename?: 'UpdateVenueFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UpdateVenueInput = {
  city?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lat?: InputMaybe<Scalars['String']>;
  lon?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
  venuePhotoId?: InputMaybe<Scalars['ID']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateVenueResult = UpdateVenueFailure | UpdateVenueSuccess;

export type UpdateVenueSuccess = {
  __typename?: 'UpdateVenueSuccess';
  venue?: Maybe<VenueNode>;
};

export type UploadFileByUrlInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

export type UploadFileFailure = {
  __typename?: 'UploadFileFailure';
  errorMessage?: Maybe<Scalars['String']>;
  fieldsErrors?: Maybe<Array<Maybe<FieldErrors>>>;
};

export type UploadFileInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  name?: InputMaybe<Scalars['String']>;
};

export type UploadFileResult = UploadFileFailure | UploadFileSuccess;

export type UploadFileSuccess = {
  __typename?: 'UploadFileSuccess';
  file?: Maybe<FileNode>;
};

export type UserAddressNode = Node & {
  __typename?: 'UserAddressNode';
  address?: Maybe<Scalars['String']>;
  authShippingId: Scalars['String'];
  autochargepreferenceSet?: Maybe<AutoChargePreferenceNodeConnection>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Countries>;
  created: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fromShippingCalc: Scalars['Boolean'];
  fullName?: Maybe<Scalars['String']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isBilling: Scalars['Boolean'];
  isTrade: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  offerSet?: Maybe<OfferNodeConnection>;
  orderSet?: Maybe<OrderNodeConnection>;
  phone?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<UserAddressStatus>;
  sweepstakesEntries?: Maybe<UserSweepstakesEntryNodeConnection>;
  updated?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserNode>;
  zipcode?: Maybe<Scalars['String']>;
};


export type UserAddressNodeAutochargepreferenceSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Scalars['ID']>;
};


export type UserAddressNodeOfferSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork?: InputMaybe<Scalars['ID']>;
  auction?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['DateTime']>;
  created_Gt?: InputMaybe<Scalars['DateTime']>;
  created_Gte?: InputMaybe<Scalars['DateTime']>;
  created_Lt?: InputMaybe<Scalars['DateTime']>;
  created_Lte?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  price_Gt?: InputMaybe<Scalars['Float']>;
  price_Gte?: InputMaybe<Scalars['Float']>;
  price_Lt?: InputMaybe<Scalars['Float']>;
  price_Lte?: InputMaybe<Scalars['Float']>;
};


export type UserAddressNodeOrderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  shippingJobStatus?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['ID']>;
};


export type UserAddressNodeSweepstakesEntriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type UserAddressNodeConnection = {
  __typename?: 'UserAddressNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserAddressNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserAddressNode` and its cursor. */
export type UserAddressNodeEdge = {
  __typename?: 'UserAddressNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UserAddressNode>;
};

export enum UserAddressStatus {
  /** Deleted */
  Deleted = 'DELETED',
  /** Public */
  Public = 'PUBLIC'
}

export type UserDonationNode = Node & {
  __typename?: 'UserDonationNode';
  amount: Scalars['Float'];
  created: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  pk?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
  user: UserNode;
};

export type UserDonationNodeConnection = {
  __typename?: 'UserDonationNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserDonationNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserDonationNode` and its cursor. */
export type UserDonationNodeEdge = {
  __typename?: 'UserDonationNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UserDonationNode>;
};

export type UserNode = Node & {
  __typename?: 'UserNode';
  accessToken?: Maybe<Scalars['String']>;
  addresses?: Maybe<UserAddressNodeConnection>;
  artworkConsignor?: Maybe<ArtworkNodeConnection>;
  artworkSet?: Maybe<ArtworkNodeConnection>;
  assignedSpecialist?: Maybe<Scalars['String']>;
  autoChargePreferences?: Maybe<AutoChargePreferenceNodeConnection>;
  autochargepreferenceSet?: Maybe<AutoChargePreferenceNodeConnection>;
  bidlogSet?: Maybe<BidLogNodeConnection>;
  billingAddresses?: Maybe<UserAddressNodeConnection>;
  cardPaymentMethods?: Maybe<Array<Maybe<CreditCardNode>>>;
  ccAuthDate?: Maybe<Scalars['DateTime']>;
  ccAuthToken?: Maybe<Scalars['String']>;
  collectionSet?: Maybe<CollectionNodeConnection>;
  consignmentSource?: Maybe<ArtworkNodeConnection>;
  consignor: Scalars['Boolean'];
  created: Scalars['DateTime'];
  credit?: Maybe<Scalars['Int']>;
  creditCards?: Maybe<Array<Maybe<CreditCardNode>>>;
  creditHistory?: Maybe<CreditHistoryNodeConnection>;
  dateOfBirth?: Maybe<Scalars['Date']>;
  donations?: Maybe<UserDonationNodeConnection>;
  email?: Maybe<Scalars['String']>;
  fileSet?: Maybe<FileNodeConnection>;
  firebasenotificationsdeviceSet?: Maybe<FirebaseNotificationsDeviceNodeConnection>;
  firstName: Scalars['String'];
  followedArtists?: Maybe<ArtistNodeConnection>;
  followedAuctions?: Maybe<AuctionNodeConnection>;
  followedVenues?: Maybe<VenueNodeConnection>;
  forgotPassCode?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gallery?: Maybe<GalleryNode>;
  gallerySet?: Maybe<GalleryNodeConnection>;
  grantedorderSet?: Maybe<GrantedOrderNodeConnection>;
  hasCompletedAccountInfo?: Maybe<Scalars['Boolean']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  isDobToday?: Maybe<Scalars['Boolean']>;
  isPhoneNumberVerified: Scalars['Boolean'];
  isSmsEnabled: Scalars['Boolean'];
  isSpecialist: Scalars['Boolean'];
  isSubscribed?: Maybe<Scalars['Boolean']>;
  isTrade?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  locationCity?: Maybe<Scalars['String']>;
  locationCountry?: Maybe<Scalars['String']>;
  locationRegion?: Maybe<Scalars['String']>;
  notifyOnNewWorks?: Maybe<Scalars['Boolean']>;
  numArtistFollowing?: Maybe<Scalars['Int']>;
  offers?: Maybe<OfferNodeConnection>;
  orders?: Maybe<GrantedOrderNodeConnection>;
  paddleName: Scalars['String'];
  paymentSet?: Maybe<PaymentNodeConnection>;
  phoneNumber?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['String']>;
  receiveFollowNotificationsForBids: Scalars['Boolean'];
  redemptions?: Maybe<UserNodeConnection>;
  redemptionsCount?: Maybe<Scalars['Int']>;
  referral?: Maybe<UserReferralNode>;
  registrationAuction?: Maybe<AuctionNode>;
  registrationSource?: Maybe<Scalars['String']>;
  requiresAmlValidation?: Maybe<Scalars['Boolean']>;
  smsNumber?: Maybe<Scalars['String']>;
  specialistOptOut: Scalars['Boolean'];
  specialistSecondary?: Maybe<ArtworkNodeConnection>;
  /** how the user can be viewed/searched on the site */
  status: UserStatus;
  strpCustomerId?: Maybe<Scalars['String']>;
  subscribedDate?: Maybe<Scalars['DateTime']>;
  sweepstakesEntries?: Maybe<UserSweepstakesEntryNodeConnection>;
  tevoCreditCards?: Maybe<Array<Maybe<CreditCardNode>>>;
  tevoId?: Maybe<Scalars['Int']>;
  type: UserType;
  updated: Scalars['DateTime'];
  usedReferral?: Maybe<UserReferralNode>;
  watchedArtworks?: Maybe<ArtworkNodeConnection>;
  watchers?: Maybe<ArtworkNodeConnection>;
};


export type UserNodeAddressesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserNodeArtworkConsignorArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type UserNodeArtworkSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type UserNodeAutoChargePreferencesArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Scalars['ID']>;
};


export type UserNodeAutochargepreferenceSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Scalars['ID']>;
};


export type UserNodeBidlogSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork_Id?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserNodeBillingAddressesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserNodeCollectionSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['DateTime']>;
  created_Gt?: InputMaybe<Scalars['DateTime']>;
  created_Gte?: InputMaybe<Scalars['DateTime']>;
  created_Lt?: InputMaybe<Scalars['DateTime']>;
  created_Lte?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updated?: InputMaybe<Scalars['DateTime']>;
  updated_Gt?: InputMaybe<Scalars['DateTime']>;
  updated_Gte?: InputMaybe<Scalars['DateTime']>;
  updated_Lt?: InputMaybe<Scalars['DateTime']>;
  updated_Lte?: InputMaybe<Scalars['DateTime']>;
};


export type UserNodeConsignmentSourceArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type UserNodeCreditHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


export type UserNodeDonationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserNodeFileSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  slug_Icontains?: InputMaybe<Scalars['String']>;
};


export type UserNodeFirebasenotificationsdeviceSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserNodeFollowedArtistsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  categories_Contains?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  firstName_Istartswith?: InputMaybe<Scalars['String']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastName_Istartswith?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
};


export type UserNodeFollowedAuctionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  end_Gt?: InputMaybe<Scalars['DateTime']>;
  end_Gte?: InputMaybe<Scalars['DateTime']>;
  end_Lt?: InputMaybe<Scalars['DateTime']>;
  end_Lte?: InputMaybe<Scalars['DateTime']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  isLiveAuction?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  showOnAuctionIndex?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  start_Gt?: InputMaybe<Scalars['DateTime']>;
  start_Gte?: InputMaybe<Scalars['DateTime']>;
  start_Lt?: InputMaybe<Scalars['DateTime']>;
  start_Lte?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
};


export type UserNodeFollowedVenuesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  country_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  id_In?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  state_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
};


export type UserNodeGallerySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserNodeGrantedorderSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']>;
  deliveryOption_Type?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderitem_Artwork_Id?: InputMaybe<Scalars['ID']>;
  orderitem_Package_Isnull?: InputMaybe<Scalars['Boolean']>;
  shipping_Email?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  user_Email?: InputMaybe<Scalars['String']>;
};


export type UserNodeOffersArgs = {
  after?: InputMaybe<Scalars['String']>;
  artwork?: InputMaybe<Scalars['ID']>;
  artworkPk?: InputMaybe<Scalars['Int']>;
  auction?: InputMaybe<Scalars['ID']>;
  auctionPk?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  created?: InputMaybe<Scalars['DateTime']>;
  created_Gt?: InputMaybe<Scalars['DateTime']>;
  created_Gte?: InputMaybe<Scalars['DateTime']>;
  created_Lt?: InputMaybe<Scalars['DateTime']>;
  created_Lte?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  price_Gt?: InputMaybe<Scalars['Float']>;
  price_Gte?: InputMaybe<Scalars['Float']>;
  price_Lt?: InputMaybe<Scalars['Float']>;
  price_Lte?: InputMaybe<Scalars['Float']>;
};


export type UserNodeOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  artworkPk?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_Lte?: InputMaybe<Scalars['DateTime']>;
  deliveryOption_Type?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderitem_Artwork_Id?: InputMaybe<Scalars['ID']>;
  orderitem_Package_Isnull?: InputMaybe<Scalars['Boolean']>;
  packagePk?: InputMaybe<Scalars['Int']>;
  pk?: InputMaybe<Scalars['Int']>;
  shipping_Email?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  tevoTicketGroupId?: InputMaybe<Scalars['Int']>;
  userFullName?: InputMaybe<Scalars['String']>;
  userOrShippingEmail?: InputMaybe<Scalars['String']>;
  user_Email?: InputMaybe<Scalars['String']>;
};


export type UserNodePaymentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserNodeRedemptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email_Icontains?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  followedArtists_Slug?: InputMaybe<Scalars['String']>;
  followedArtists_Slug_In?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  grantedorder_Orderitem_Artwork_Id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  pk?: InputMaybe<Scalars['Int']>;
  registrationSource?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  type_In?: InputMaybe<Scalars['String']>;
};


export type UserNodeSpecialistSecondaryArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type UserNodeSweepstakesEntriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserNodeWatchedArtworksArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type UserNodeWatchersArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};

export type UserNodeConnection = {
  __typename?: 'UserNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserNode` and its cursor. */
export type UserNodeEdge = {
  __typename?: 'UserNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UserNode>;
};

export type UserReferralNode = Node & {
  __typename?: 'UserReferralNode';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  owner: UserNode;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userSet?: Maybe<UserNodeConnection>;
};


export type UserReferralNodeUserSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email_Icontains?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  followedArtists_Slug?: InputMaybe<Scalars['String']>;
  followedArtists_Slug_In?: InputMaybe<Scalars['String']>;
  grantedorder_Orderitem_Artwork_Id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  registrationSource?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  type_In?: InputMaybe<Scalars['String']>;
};

export enum UserStatus {
  /** Deleted */
  Deleted = 'DELETED',
  /** Private */
  Private = 'PRIVATE',
  /** Public */
  Public = 'PUBLIC'
}

export type UserSweepstakesEntryNode = Node & {
  __typename?: 'UserSweepstakesEntryNode';
  address: UserAddressNode;
  created: Scalars['DateTime'];
  /** The ID of the object. */
  id: Scalars['ID'];
  pk?: Maybe<Scalars['String']>;
  updated: Scalars['DateTime'];
  user: UserNode;
};

export type UserSweepstakesEntryNodeConnection = {
  __typename?: 'UserSweepstakesEntryNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserSweepstakesEntryNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserSweepstakesEntryNode` and its cursor. */
export type UserSweepstakesEntryNodeEdge = {
  __typename?: 'UserSweepstakesEntryNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UserSweepstakesEntryNode>;
};

export enum UserType {
  /** Admin */
  Admin = 'ADMIN',
  /** Gallery */
  Gallery = 'GALLERY',
  /** Guest */
  Guest = 'GUEST',
  /** User */
  User = 'USER'
}

export type VenueNode = Node & {
  __typename?: 'VenueNode';
  artworkSet?: Maybe<ArtworkNodeConnection>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  featuredDate?: Maybe<Scalars['DateTime']>;
  /** The ID of the object. */
  id: Scalars['ID'];
  imageOriginal?: Maybe<Scalars['String']>;
  isSearchable: Scalars['Boolean'];
  lat: Scalars['Float'];
  lon: Scalars['Float'];
  name: Scalars['String'];
  origin: Scalars['String'];
  pk?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  streetAddress?: Maybe<Scalars['String']>;
  tevoId?: Maybe<Scalars['Int']>;
  timeZone: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userSet?: Maybe<UserNodeConnection>;
  venuePhoto?: Maybe<FileNode>;
  zip?: Maybe<Scalars['String']>;
};


export type VenueNodeArtworkSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  announceDate_Gt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Gte?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  announceDate_Lte?: InputMaybe<Scalars['DateTime']>;
  artists_FullName?: InputMaybe<Scalars['String']>;
  artists_FullName_Contains?: InputMaybe<Scalars['String']>;
  artists_FullName_Icontains?: InputMaybe<Scalars['String']>;
  artists_FullName_Iexact?: InputMaybe<Scalars['String']>;
  artists_Slug?: InputMaybe<Scalars['String']>;
  artists_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_End_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_End_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Slug?: InputMaybe<Scalars['String']>;
  auctions_Slug_In?: InputMaybe<Scalars['String']>;
  auctions_Start_Gt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Gte?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lt?: InputMaybe<Scalars['DateTime']>;
  auctions_Start_Lte?: InputMaybe<Scalars['DateTime']>;
  auctions_Title?: InputMaybe<Scalars['String']>;
  auctions_Title_Contains?: InputMaybe<Scalars['String']>;
  auctions_Title_Icontains?: InputMaybe<Scalars['String']>;
  auctions_Title_Iexact?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bidCount_Gt?: InputMaybe<Scalars['Float']>;
  bidCount_Gte?: InputMaybe<Scalars['Float']>;
  bidCount_Lt?: InputMaybe<Scalars['Float']>;
  bidCount_Lte?: InputMaybe<Scalars['Float']>;
  currentBid_Gt?: InputMaybe<Scalars['Float']>;
  currentBid_Gte?: InputMaybe<Scalars['Float']>;
  currentBid_Lt?: InputMaybe<Scalars['Float']>;
  currentBid_Lte?: InputMaybe<Scalars['Float']>;
  eventStartDateLocal_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocal_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lt?: InputMaybe<Scalars['DateTime']>;
  eventStartDate_Lte?: InputMaybe<Scalars['DateTime']>;
  eventStatus?: InputMaybe<Scalars['String']>;
  eventStatus_In?: InputMaybe<Scalars['String']>;
  featuredDate?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Gt?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  featuredDate_Lt?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  ipadOnly?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  listPrice_Gt?: InputMaybe<Scalars['Float']>;
  listPrice_Gte?: InputMaybe<Scalars['Float']>;
  listPrice_Lt?: InputMaybe<Scalars['Float']>;
  listPrice_Lte?: InputMaybe<Scalars['Float']>;
  mediums_Title?: InputMaybe<Scalars['String']>;
  mediums_Title_Contains?: InputMaybe<Scalars['String']>;
  mediums_Title_Icontains?: InputMaybe<Scalars['String']>;
  mediums_Title_Iexact?: InputMaybe<Scalars['String']>;
  mediums_Title_In?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug?: InputMaybe<Scalars['String']>;
  mediums_UrlSlug_In?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  origin_In?: InputMaybe<Scalars['String']>;
  purchaseOptions?: InputMaybe<Scalars['String']>;
  purchaseOptions_Contains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Icontains?: InputMaybe<Scalars['String']>;
  purchaseOptions_Iexact?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  salesAs_In?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  status_In?: InputMaybe<Scalars['String']>;
  suppressDisplay?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  title_Iexact?: InputMaybe<Scalars['String']>;
  tour_Slug?: InputMaybe<Scalars['String']>;
  tour_Slug_In?: InputMaybe<Scalars['String']>;
  tour_Status?: InputMaybe<Scalars['String']>;
  venue_Name?: InputMaybe<Scalars['String']>;
  venue_Name_Contains?: InputMaybe<Scalars['String']>;
  venue_Name_Icontains?: InputMaybe<Scalars['String']>;
  venue_Slug?: InputMaybe<Scalars['String']>;
  venue_Slug_In?: InputMaybe<Scalars['String']>;
};


export type VenueNodeUserSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email_Icontains?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  followedArtists_Slug?: InputMaybe<Scalars['String']>;
  followedArtists_Slug_In?: InputMaybe<Scalars['String']>;
  grantedorder_Orderitem_Artwork_Id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  registrationSource?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  type_In?: InputMaybe<Scalars['String']>;
};

export type VenueNodeConnection = {
  __typename?: 'VenueNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VenueNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `VenueNode` and its cursor. */
export type VenueNodeEdge = {
  __typename?: 'VenueNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<VenueNode>;
};

export type VenueSearchResultNode = {
  __typename?: 'VenueSearchResultNode';
  imagePath?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type WatchArtworkInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type WatchArtworkPayload = {
  __typename?: 'WatchArtworkPayload';
  artwork?: Maybe<ArtworkNode>;
  clientMutationId?: Maybe<Scalars['String']>;
};

export type AllArtworksWithCountCountingConnection = {
  __typename?: 'allArtworksWithCountCountingConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AllArtworksWithCountCountingEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `allArtworksWithCountCounting` and its cursor. */
export type AllArtworksWithCountCountingEdge = {
  __typename?: 'allArtworksWithCountCountingEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ArtworkNode>;
};

export type UserBidsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserBidsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', id: string, offers?: { __typename?: 'OfferNodeConnection', edges: Array<{ __typename?: 'OfferNodeEdge', node?: { __typename?: 'OfferNode', id: string, isWinningBid: boolean, price: number, created: any, artwork?: { __typename?: 'ArtworkNode', id: string, title: string, currentBid?: number | null, slug: string, eventStartDate?: any | null, eventStartDateLocal?: any | null, artists?: { __typename?: 'ArtistNodeConnection', edges: Array<{ __typename?: 'ArtistNodeEdge', node?: { __typename?: 'ArtistNode', slug: string, fullName: string } | null } | null> } | null, auctionSet?: { __typename?: 'AuctionNodeConnection', edges: Array<{ __typename?: 'AuctionNodeEdge', node?: { __typename?: 'AuctionNode', start?: any | null, end?: any | null } | null } | null> } | null, venue?: { __typename?: 'VenueNode', name: string, slug: string, timeZone: string } | null } | null } | null } | null> } | null } | null };

export type GetUserCreditHistoryQueryVariables = Exact<{
  orderBy?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetUserCreditHistoryQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', id: string, credit?: number | null, creditHistory?: { __typename?: 'CreditHistoryNodeConnection', edges: Array<{ __typename?: 'CreditHistoryNodeEdge', node?: { __typename?: 'CreditHistoryNode', id: string, amount: number, summedAmount: number, uid?: number | null, createdAt: any, actionType: { __typename?: 'CreditActionTypeNode', id: string, type: string }, data?: { __typename: 'ArtistNode', id: string, fullName: string, slug: string } | { __typename: 'GrantedOrderNode' } | { __typename: 'VenueNode', id: string, slug: string, city?: string | null, name: string, state?: string | null } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } | null } | null };

export type UserOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type UserOrdersQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', id: string, orders?: { __typename?: 'GrantedOrderNodeConnection', edges: Array<{ __typename?: 'GrantedOrderNodeEdge', node?: { __typename?: 'GrantedOrderNode', pk?: string | null, id: string, status: GrantedOrderStatus, updatedAt?: any | null, totalPrice: number, totalRefunded?: number | null, createdAt: any, orderType: GrantedOrderOrderType } | null } | null> } | null } | null };

export type DeleteCreditCardMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCreditCardMutation = { __typename?: 'Mutation', removeCreditCard?: { __typename?: 'RemoveCreditCardPayload', id: string } | null };

export type UserNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserNotificationsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', id: string, notifyOnNewWorks?: boolean | null } | null };

export type UpdateUserNotificationsMutationVariables = Exact<{
  notifyOnNewWorks: Scalars['Boolean'];
}>;


export type UpdateUserNotificationsMutation = { __typename?: 'Mutation', updateUserNotifications?: { __typename?: 'UpdateUserNotificationsPayload', user?: { __typename?: 'UserNode', id: string, notifyOnNewWorks?: boolean | null } | null } | null };

export type UserBasicInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type UserBasicInformationQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', id: string, pk?: string | null, email?: string | null, firstName: string, lastName: string, type: UserType, phoneNumber?: string | null, notifyOnNewWorks?: boolean | null } | null };

export type UserOffersQueryVariables = Exact<{
  artwork: Scalars['ID'];
}>;


export type UserOffersQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', id: string, offers?: { __typename?: 'OfferNodeConnection', edges: Array<{ __typename?: 'OfferNodeEdge', node?: { __typename?: 'OfferNode', id: string, bidType: OfferBidType, isWinningBid: boolean, maxBidAmount?: number | null, paymentCompletionStatus?: OfferPaymentCompletionStatus | null, paymentStatus: OfferPaymentStatus, price: number } | null } | null> } | null } | null };

export type AuctionByArtworkQueryVariables = Exact<{
  pk: Scalars['Int'];
}>;


export type AuctionByArtworkQuery = { __typename?: 'Query', auction?: { __typename?: 'ArtworkNode', id: string, pk?: string | null, meta?: string | null, nextBid?: number | null, subTitle: string, currentBid?: number | null, startingBid?: number | null, deliveryNotes?: string | null, purchaseStatus?: string | null, startDate?: any | null, endDate?: any | null } | null };

export type SubmitForGiveawayMutationVariables = Exact<{
  input: SubmitForGiveawayInput;
}>;


export type SubmitForGiveawayMutation = { __typename?: 'Mutation', submitForGiveaway?: { __typename?: 'SubmitForGiveawayFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename?: 'SubmitForGiveawaySuccess', success?: boolean | null } | null };

export type GetAuctionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  title_Icontains?: InputMaybe<Scalars['String']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Scalars['String']>;
  isEnded?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAuctionsQuery = { __typename?: 'Query', allArtworks?: { __typename?: 'ArtworkNodeCountingConnection', edges: Array<{ __typename?: 'ArtworkNodeCountingEdge', node?: { __typename?: 'ArtworkNode', id: string, pk?: string | null, title: string, currentBid?: number | null, startingBid?: number | null, slug: string, endDate?: any | null, artistFullName?: string | null, artworkOrTourOrArtistImage?: { __typename?: 'ArtworkImageNode', id: string, path: string, extension: string } | null, venue?: { __typename?: 'VenueNode', id: string, timeZone: string } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetMarketingEventsNewQueryVariables = Exact<{
  isActive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetMarketingEventsNewQuery = { __typename?: 'Query', marketingEvents?: { __typename?: 'MarketingEventNodeConnection', edges: Array<{ __typename?: 'MarketingEventNodeEdge', node?: { __typename?: 'MarketingEventNode', title: string, id: string, slug: string, template?: { __typename?: 'TemplateNode', about?: { __typename?: 'AboutNode', title?: string | null, description?: string | null, bannerImageUrl?: string | null } | null, hero?: { __typename?: 'HeroNode', description?: string | null, mobileImageUrl?: string | null } | null } | null, artworks?: { __typename?: 'ArtworkNodeConnection', edges: Array<{ __typename?: 'ArtworkNodeEdge', node?: { __typename?: 'ArtworkNode', id: string } | null } | null> } | null } | null } | null> } | null };

export type GetStarsByFollowersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GetStarsByFollowersQuery = { __typename?: 'Query', allArtists?: { __typename?: 'ArtistNodeConnection', edges: Array<{ __typename?: 'ArtistNodeEdge', node?: { __typename?: 'ArtistNode', id: string, slug: string, followers: number, fullName: string, file?: { __typename?: 'FileNode', extension: string, path: string } | null } | null } | null> } | null };

export type FollowArtistBulkMutationVariables = Exact<{
  input: FollowArtistBulkInput;
}>;


export type FollowArtistBulkMutation = { __typename?: 'Mutation', followArtistBulk?: { __typename: 'FollowArtistBulkFailure', errorMessage?: string | null } | { __typename: 'FollowArtistBulkSuccess', success?: boolean | null } | null };

export type RecoverPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RecoverPasswordMutation = { __typename?: 'Mutation', recoverPassword?: { __typename?: 'RecoverPasswordFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename?: 'RecoverPasswordSuccess', result?: boolean | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  userId: Scalars['Int'];
  resetToken: Scalars['String'];
  password: Scalars['String'];
  confirmPassword: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ResetPasswordFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename?: 'ResetPasswordSuccess', user?: { __typename?: 'UserNode', id: string, email?: string | null } | null } | null };

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  cartId?: InputMaybe<Scalars['ID']>;
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename?: 'LoginSuccess', user?: { __typename?: 'UserNode', pk?: string | null, id: string, email?: string | null, type: UserType, lastName: string, firstName: string, fullName?: string | null, phoneNumber?: string | null, isPhoneNumberVerified: boolean } | null } | null };

export type RegistrationShortMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  newsletter: Scalars['Boolean'];
  terms: Scalars['Boolean'];
  recaptchaToken?: InputMaybe<Scalars['String']>;
}>;


export type RegistrationShortMutation = { __typename?: 'Mutation', signup?: { __typename?: 'SignupFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename?: 'SignupSuccess', user?: { __typename?: 'UserNode', id: string, pk?: string | null, firstName: string, lastName: string, email?: string | null, phoneNumber?: string | null, locationCountry?: string | null } | null } | null };

export type GetOrderPricingQueryVariables = Exact<{
  cartId: Scalars['ID'];
  fullName?: InputMaybe<Scalars['String']>;
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  promocode?: InputMaybe<Scalars['String']>;
  credit?: InputMaybe<Scalars['Float']>;
  preview?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetOrderPricingQuery = { __typename?: 'Query', orderPricing?: { __typename?: 'OrderPricingNode', cartItemPrice?: number | null, quantity?: number | null, shippingPrice?: number | null, orderTax?: number | null, serviceFee?: number | null, totalPrice?: number | null, discount?: number | null, discountError?: string | null, credit?: number | null, totalPriceWithoutDiscount?: number | null, cartPrice?: number | null, totalPriceWithPromocode?: number | null, insuranceCostsOfItems?: Array<number | null> | null, mode?: string | null } | null };

export type GetUserActiveCartDeliveryOptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserActiveCartDeliveryOptionQuery = { __typename?: 'Query', findCart?: { __typename?: 'CartNode', pk?: string | null, id: string, deliveryOption?: string | null } | null };

export type CreateCheckoutOrderMutationVariables = Exact<{
  input: CreateCheckoutOrderInput;
}>;


export type CreateCheckoutOrderMutation = { __typename?: 'Mutation', createCheckoutOrder?: { __typename?: 'OrderMutationFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename?: 'OrderMutationSuccess', paymentIntentId?: string | null, paymentIntentClientSecret?: string | null, order?: { __typename?: 'GrantedOrderNode', id: string, pk?: string | null, pay?: { __typename?: 'PaymentNode', id: string, metadata?: string | null, transactionUid: string } | null } | null } | null };

export type SaveCartCurrentShippingEmailMutationVariables = Exact<{
  input: SaveCartCurrentShippingEmailInput;
}>;


export type SaveCartCurrentShippingEmailMutation = { __typename?: 'Mutation', saveCartCurrentShippingEmail?: { __typename?: 'SaveCartCurrentShippingEmailFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename?: 'SaveCartCurrentShippingEmailSuccess', success?: boolean | null } | null };

export type GetCurrentBidDetailsQueryVariables = Exact<{
  pk: Scalars['Int'];
}>;


export type GetCurrentBidDetailsQuery = { __typename?: 'Query', findArtwork?: { __typename?: 'ArtworkNode', id: string, title: string, subTitle: string, primaryImage?: { __typename?: 'ArtworkImageNode', extension: string, path: string } | null } | null };

export type PlaceBidMutationVariables = Exact<{
  input: PlaceBidInput;
}>;


export type PlaceBidMutation = { __typename?: 'Mutation', placeBid?: { __typename?: 'PlaceBidFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename?: 'PlaceBidSuccess', artwork?: { __typename?: 'ArtworkNode', id: string } | null, data?: { __typename?: 'PlaceBidResponseNode', status?: number | null, offerId?: number | null, currentPrice?: number | null, currency?: string | null, artworkId?: number | null } | null } | null };

export type GetAuctionDataQueryVariables = Exact<{
  pk: Scalars['Int'];
}>;


export type GetAuctionDataQuery = { __typename?: 'Query', findArtwork?: { __typename?: 'ArtworkNode', id: string, title: string, slug: string, deliveryNotes?: string | null, deliveryOptions?: { __typename?: 'DeliveryOptionNodeConnection', edges: Array<{ __typename?: 'DeliveryOptionNodeEdge', node?: { __typename?: 'DeliveryOptionNode', id: string, type: string } | null } | null> } | null } | null };

export type GetUserBidLogsQueryVariables = Exact<{
  artworkId: Scalars['ID'];
}>;


export type GetUserBidLogsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', id: string, creditCards?: Array<{ __typename?: 'CreditCardNode', id: string, cardId?: string | null, last4?: string | null, name?: string | null, brand?: string | null, expMonth?: number | null, expYear?: number | null } | null> | null, bidlogSet?: { __typename?: 'BidLogNodeConnection', edges: Array<{ __typename?: 'BidLogNodeEdge', node?: { __typename?: 'BidLogNode', id: string, sourceId?: string | null, shipping?: { __typename?: 'ShippingNode', id: string, fullName: string, address1: string, address2?: string | null, city: string, state: string, country: string, zipCode: string, phoneNumber: string, email?: string | null } | null } | null } | null> } | null } | null };

export type GetLocalPriceQueryVariables = Exact<{
  price: Scalars['Float'];
}>;


export type GetLocalPriceQuery = { __typename?: 'Query', localPrice?: { __typename?: 'LocalPriceNode', price?: number | null, currency?: string | null } | null };

export type GetAvailableCreditQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableCreditQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', id: string, credit?: number | null } | null };

export type GetPackageByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPackageByIdQuery = { __typename?: 'Query', package?: { __typename?: 'PackageNode', id: string, pk?: string | null, name: string, shortDescription: string, longDescription?: string | null, minSplit: number, maxSplit: number, price: number, quantity: number, deliveryNotes?: string | null, availableQuantity: number, image?: { __typename?: 'FileNode', id: string, path: string, extension: string } | null } | null };

export type FollowArtistMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FollowArtistMutation = { __typename?: 'Mutation', followArtist?: { __typename?: 'FollowArtistFailure', errorMessage?: string | null } | { __typename?: 'FollowArtistSuccess', artist?: { __typename?: 'ArtistNode', id: string } | null } | null };

export type UnfollowArtistMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnfollowArtistMutation = { __typename?: 'Mutation', unfollowArtist?: { __typename?: 'FollowArtistFailure', errorMessage?: string | null } | { __typename?: 'FollowArtistSuccess', artist?: { __typename?: 'ArtistNode', id: string } | null } | null };

export type FollowedArtistsQueryVariables = Exact<{ [key: string]: never; }>;


export type FollowedArtistsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', id: string, type: UserType, followedArtists?: { __typename?: 'ArtistNodeConnection', edges: Array<{ __typename?: 'ArtistNodeEdge', node?: { __typename?: 'ArtistNode', id: string, slug: string, fullName: string, file?: { __typename?: 'FileNode', path: string, extension: string } | null } | null } | null> } | null } | null };

export type FollowVenueMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FollowVenueMutation = { __typename?: 'Mutation', followVenue?: { __typename?: 'FollowVenueFailure', errorMessage?: string | null } | { __typename?: 'FollowVenueSuccess', venue?: { __typename?: 'VenueNode', id: string } | null } | null };

export type UnfollowVenueMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnfollowVenueMutation = { __typename?: 'Mutation', unfollowVenue?: { __typename?: 'FollowVenueFailure', errorMessage?: string | null } | { __typename?: 'FollowVenueSuccess', venue?: { __typename?: 'VenueNode', id: string } | null } | null };

export type FollowedVenuesQueryVariables = Exact<{ [key: string]: never; }>;


export type FollowedVenuesQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', id: string, type: UserType, followedVenues?: { __typename?: 'VenueNodeConnection', edges: Array<{ __typename?: 'VenueNodeEdge', node?: { __typename?: 'VenueNode', id: string, slug: string, name: string, venuePhoto?: { __typename?: 'FileNode', path: string, extension: string } | null } | null } | null> } | null } | null };

export type AddCreditCardMutationVariables = Exact<{
  tokenId: Scalars['String'];
}>;


export type AddCreditCardMutation = { __typename?: 'Mutation', addCreditCard?: { __typename?: 'AddCreditCardFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename?: 'AddCreditCardSuccess', creditCard?: { __typename?: 'CreditCardNode', id: string, cardId?: string | null, last4?: string | null, brand?: string | null, funding?: string | null, expYear?: number | null, expMonth?: number | null } | null } | null };

export type GetBaseArtworkDataQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBaseArtworkDataQuery = { __typename?: 'Query', artwork?: { __typename?: 'ArtworkNode', endDate?: any | null, title: string, slug: string, id: string, artworkOrTourOrArtistImage?: { __typename?: 'ArtworkImageNode', path: string, extension: string } | null } | null };

export type GetFeaturedStarsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeaturedStarsQuery = { __typename?: 'Query', allArtists?: { __typename?: 'ArtistNodeConnection', edges: Array<{ __typename?: 'ArtistNodeEdge', node?: { __typename?: 'ArtistNode', id: string, fullName: string, slug: string, file?: { __typename?: 'FileNode', extension: string, path: string } | null } | null } | null> } | null };

export type LatestAndGreatestQueryVariables = Exact<{
  eventStartDateGte?: InputMaybe<Scalars['String']>;
}>;


export type LatestAndGreatestQuery = { __typename?: 'Query', allTours?: { __typename?: 'TourNodeConnection', edges: Array<{ __typename?: 'TourNodeEdge', node?: { __typename?: 'TourNode', id: string, title: string, slug: string, artistFullName?: string | null, tourPhoto?: { __typename?: 'FileNode', extension: string, path: string } | null, artworks?: Array<{ __typename?: 'ArtworkNode', id: string } | null> | null } | null } | null> } | null };

export type ToursCarouselDataQueryVariables = Exact<{
  ids?: InputMaybe<Scalars['String']>;
}>;


export type ToursCarouselDataQuery = { __typename?: 'Query', allTours?: { __typename?: 'TourNodeConnection', edges: Array<{ __typename?: 'TourNodeEdge', node?: { __typename?: 'TourNode', id: string, title: string, slug: string, artistFullName?: string | null, tourPhoto?: { __typename?: 'FileNode', extension: string, path: string } | null } | null } | null> } | null };

export type GetMarketingEventRelatedAuctionsQueryVariables = Exact<{
  ids: Scalars['String'];
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetMarketingEventRelatedAuctionsQuery = { __typename?: 'Query', allArtworks?: { __typename?: 'ArtworkNodeCountingConnection', edges: Array<{ __typename?: 'ArtworkNodeCountingEdge', node?: { __typename?: 'ArtworkNode', id: string, title: string, currentBid?: number | null, endDate?: any | null, startDate?: any | null, slug: string, salesAs: ArtworkSalesAs, venue?: { __typename?: 'VenueNode', id: string, timeZone: string } | null, artworkOrTourOrArtistImage?: { __typename?: 'ArtworkImageNode', id: string, path: string, extension: string } | null } | null } | null> } | null };

export type EditUserMutationVariables = Exact<{
  input: UpdateUserInformationInput;
}>;


export type EditUserMutation = { __typename?: 'Mutation', updateUserInformation?: { __typename: 'UpdateUserFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename: 'UpdateUserSuccess', user?: { __typename?: 'UserNode', id: string, lastName: string, firstName: string } | null } | null };

export type ArtistsFromCategoriesQueryVariables = Exact<{
  firstOrLastName_Istartswith?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  categories_Contains?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  categoryWithChild_Exact?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  venueCoordinates?: InputMaybe<Scalars['String']>;
}>;


export type ArtistsFromCategoriesQuery = { __typename?: 'Query', allArtists?: { __typename?: 'ArtistNodeConnection', edges: Array<{ __typename?: 'ArtistNodeEdge', node?: { __typename?: 'ArtistNode', id: string, fullName: string, slug: string, file?: { __typename?: 'FileNode', extension: string, path: string } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type SearchVenueQueryVariables = Exact<{
  name_Icontains?: InputMaybe<Scalars['String']>;
  state_In?: InputMaybe<Scalars['String']>;
  country_In?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchVenueQuery = { __typename?: 'Query', allVenues?: { __typename?: 'VenueNodeConnection', edges: Array<{ __typename?: 'VenueNodeEdge', cursor: string, node?: { __typename?: 'VenueNode', id: string, name: string, slug: string, city?: string | null, state?: string | null, venuePhoto?: { __typename?: 'FileNode', path: string, extension: string } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, startCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type FinishGuestAccountMutationVariables = Exact<{
  input: FinishGuestAccountInput;
}>;


export type FinishGuestAccountMutation = { __typename?: 'Mutation', finishGuestAccount?: { __typename?: 'SignupFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename?: 'SignupSuccess', user?: { __typename?: 'UserNode', id: string, pk?: string | null, firstName: string, lastName: string, email?: string | null, phoneNumber?: string | null, locationCountry?: string | null } | null } | null };

export type GetInstagramPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInstagramPostsQuery = { __typename?: 'Query', instagramPosts?: Array<{ __typename?: 'InstagramPostNode', id?: string | null, mediaType?: string | null, mediaUrl?: string | null, thumbnailUrl?: string | null, shortcode?: string | null, permalink?: string | null } | null> | null };

export type GetTicketsLowestPriceQueryVariables = Exact<{
  pk: Scalars['Int'];
}>;


export type GetTicketsLowestPriceQuery = { __typename?: 'Query', findArtwork?: { __typename?: 'ArtworkNode', id: string, pk?: string | null, lowestTicketsPrice?: number | null } | null };

export type GetUserActiveShortCartQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserActiveShortCartQuery = { __typename?: 'Query', findCart?: { __typename?: 'CartNode', pk?: string | null, id: string } | null };

export type GetEventsByTourSlugQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  tourSlug?: InputMaybe<Scalars['String']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetEventsByTourSlugQuery = { __typename?: 'Query', allArtworks?: { __typename?: 'ArtworkNodeCountingConnection', edges: Array<{ __typename?: 'ArtworkNodeCountingEdge', node?: { __typename?: 'ArtworkNode', id: string, slug: string, eventStartDateLocal?: any | null, tevoId?: number | null, externalLink?: string | null, externalVipLink?: string | null, hasPackages?: boolean | null, title: string, venue?: { __typename?: 'VenueNode', id: string, timeZone: string, city?: string | null, state?: string | null, name: string } | null, mainArtist?: { __typename?: 'ArtistNode', lastParentCategories?: Array<string | null> | null } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetTourBySlugForListHeadingQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetTourBySlugForListHeadingQuery = { __typename?: 'Query', allTours?: { __typename?: 'TourNodeConnection', edges: Array<{ __typename?: 'TourNodeEdge', node?: { __typename?: 'TourNode', id: string, title: string, artistFullName?: string | null, tourPhoto?: { __typename?: 'FileNode', id: string, path: string, extension: string } | null } | null } | null> } | null };

export type GetVenueAuctionsQueryVariables = Exact<{
  featuredDateIsNull?: InputMaybe<Scalars['Boolean']>;
  venueSlug?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GetVenueAuctionsQuery = { __typename?: 'Query', allArtworks?: { __typename?: 'ArtworkNodeCountingConnection', edges: Array<{ __typename?: 'ArtworkNodeCountingEdge', node?: { __typename?: 'ArtworkNode', id: string, slug: string, title: string, description?: string | null, currentBid?: number | null, startingBid?: number | null, endDate?: any | null, artworkOrTourOrArtistImage?: { __typename?: 'ArtworkImageNode', path: string, extension: string } | null, venue?: { __typename?: 'VenueNode', timeZone: string } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type GetVenueEventsQueryVariables = Exact<{
  announceDate_Lt?: InputMaybe<Scalars['DateTime']>;
  featuredDateIsNull?: InputMaybe<Scalars['Boolean']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  venueSlug?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GetVenueEventsQuery = { __typename?: 'Query', allArtworks?: { __typename?: 'ArtworkNodeCountingConnection', edges: Array<{ __typename?: 'ArtworkNodeCountingEdge', node?: { __typename?: 'ArtworkNode', id: string, slug: string, title: string, eventStartDateLocal?: any | null, artistFullName?: string | null, externalLink?: string | null, externalVipLink?: string | null, tevoId?: number | null, hasPackages?: boolean | null, artworkOrTourOrArtistImage?: { __typename?: 'ArtworkImageNode', path: string, extension: string } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type AddAddressMutationVariables = Exact<{
  fullName: Scalars['String'];
  country: Countries;
  address: Scalars['String'];
  city: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  zipcode: Scalars['String'];
  phone: Scalars['String'];
  isBilling?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
}>;


export type AddAddressMutation = { __typename?: 'Mutation', addUserAddress?: { __typename?: 'AddUserAddressFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename?: 'AddUserAddressSuccess', address?: { __typename?: 'UserAddressNode', id: string, pk?: string | null, isTrade: boolean, country?: Countries | null, address?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, phone?: string | null, status?: UserAddressStatus | null, fullName?: string | null, isBilling: boolean, email?: string | null } | null } | null };

export type DeleteAddressMutationVariables = Exact<{
  addressId: Scalars['ID'];
}>;


export type DeleteAddressMutation = { __typename?: 'Mutation', removeUserAddress?: { __typename?: 'RemoveUserAddressPayload', id?: string | null } | null };

export type EditAddressMutationVariables = Exact<{
  fullName: Scalars['String'];
  addressId: Scalars['ID'];
  country: Countries;
  address: Scalars['String'];
  city: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  zipcode: Scalars['String'];
  phone: Scalars['String'];
  isBilling?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
}>;


export type EditAddressMutation = { __typename?: 'Mutation', updateUserAddress?: { __typename?: 'UpdateUserAddressFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename?: 'UpdateUserAddressSuccess', address?: { __typename?: 'UserAddressNode', id: string, country?: Countries | null, address?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, phone?: string | null, status?: UserAddressStatus | null, fullName?: string | null, isBilling: boolean, email?: string | null } | null } | null };

export type CancelUserActiveCartMutationVariables = Exact<{
  cartId: Scalars['ID'];
}>;


export type CancelUserActiveCartMutation = { __typename?: 'Mutation', cancelCart?: { __typename?: 'CartMutationFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename?: 'CartMutationSuccess', cart?: { __typename?: 'CartNode', id: string, status: CartStatus } | null } | null };

export type SendVerificationCodeMutationVariables = Exact<{
  phoneNumber: Scalars['String'];
}>;


export type SendVerificationCodeMutation = { __typename?: 'Mutation', sendVerificationCode?: { __typename?: 'PhoneVerificationFailure', errorMessage?: string | null } | { __typename?: 'PhoneVerificationSuccess', ok?: boolean | null } | null };

export type CheckVerificationCodeMutationVariables = Exact<{
  phoneNumber: Scalars['String'];
  code: Scalars['String'];
  optIn?: InputMaybe<Scalars['Boolean']>;
}>;


export type CheckVerificationCodeMutation = { __typename?: 'Mutation', checkVerificationCode?: { __typename?: 'PhoneVerificationFailure', errorMessage?: string | null } | { __typename?: 'PhoneVerificationSuccess', ok?: boolean | null } | null };

export type GenerateReferralCodeMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateReferralCodeMutation = { __typename?: 'Mutation', generateReferralCode?: { __typename: 'MutationError', errorMessage?: string | null } | { __typename: 'UserReferralNode', id: string, code: string } | null };

export type RegistrationMutationVariables = Exact<{
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  newsletter: Scalars['Boolean'];
  terms: Scalars['Boolean'];
  recaptchaToken?: InputMaybe<Scalars['String']>;
  referralCode?: InputMaybe<Scalars['String']>;
}>;


export type RegistrationMutation = { __typename?: 'Mutation', signup?: { __typename?: 'SignupFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename?: 'SignupSuccess', user?: { __typename?: 'UserNode', pk?: string | null, id: string, email?: string | null, type: UserType, lastName: string, firstName: string, fullName?: string | null, phoneNumber?: string | null, isPhoneNumberVerified: boolean } | null } | null };

export type SetUserDateOfBirthMutationVariables = Exact<{
  input: SetDateOfBirthInput;
}>;


export type SetUserDateOfBirthMutation = { __typename?: 'Mutation', setDateOfBirth?: { __typename: 'SetDateOfBirthFailure', errorMessage?: string | null } | { __typename: 'SetDateOfBirthSuccess', dateOfBirth?: any | null } | null };

export type UserCreditCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserCreditCardsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', id: string, creditCards?: Array<{ __typename?: 'CreditCardNode', id: string, cardId?: string | null, brand?: string | null, last4?: string | null, expMonth?: number | null, expYear?: number | null, funding?: string | null, name?: string | null } | null> | null } | null };

export type AddressSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type AddressSettingsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', id: string, addresses?: { __typename?: 'UserAddressNodeConnection', edges: Array<{ __typename?: 'UserAddressNodeEdge', node?: { __typename?: 'UserAddressNode', id: string, pk?: string | null, country?: Countries | null, address?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, phone?: string | null, status?: UserAddressStatus | null, email?: string | null, fullName?: string | null, isBilling: boolean } | null } | null> } | null } | null };

export type BillingAddressSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingAddressSettingsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', id: string, billingAddresses?: { __typename?: 'UserAddressNodeConnection', edges: Array<{ __typename?: 'UserAddressNodeEdge', node?: { __typename?: 'UserAddressNode', id: string, pk?: string | null, country?: Countries | null, address?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, phone?: string | null, status?: UserAddressStatus | null, email?: string | null, fullName?: string | null, isBilling: boolean } | null } | null> } | null } | null };

export type OrderByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrderByIdQuery = { __typename?: 'Query', order?: { __typename?: 'GrantedOrderNode', id: string, pk?: string | null, createdAt: any, orderType: GrantedOrderOrderType, status: GrantedOrderStatus, credit: number, serviceFee: number, tax: number, totalPrice: number, shippingPrice: number, user: { __typename?: 'UserNode', id: string, type: UserType }, promocode?: { __typename?: 'PromocodeNode', id: string, type: PromocodeType, code: string, amount: number } | null, deliveryOption: { __typename?: 'DeliveryOptionNode', id: string, type: string }, pay?: { __typename?: 'PaymentNode', id: string, transactionUid: string, paymentIntent?: { __typename?: 'PaymentIntentNode', id?: string | null, paymentMethodName?: string | null, wallet?: string | null } | null, charge?: { __typename?: 'PaymentIntentNode', id?: string | null, paymentMethodName?: string | null } | null } | null, insurance?: { __typename?: 'InsuranceNode', id: string, pk?: string | null, status: InsuranceStatus, totalPrice?: number | null, policies?: Array<{ __typename?: 'InsurancePolicyNode', id: string, pk?: string | null, policyId?: string | null, status: InsurancePolicyStatus, cost: number, price?: number | null } | null> | null } | null, shipping?: { __typename?: 'ShippingNode', id: string, city: string, state: string, email?: string | null, zipCode: string, address1: string, fullName: string, phoneNumber: string } | null, tevoOrder?: { __typename?: 'TevoOrderNode', sellerRejectionReason?: string | null, sellerRejectionNotes?: string | null, shipping?: number | null, shipments?: Array<{ __typename?: 'TevoShipmentsNode', state?: string | null } | null> | null, items?: Array<{ __typename?: 'TevoOrderItemNode', ticketGroup?: { __typename?: 'TevoTicketNode', id?: string | null, row?: string | null, section?: string | null, retailPrice?: number | null, format?: string | null, inHand?: boolean | null, inHandOn?: string | null } | null } | null> | null } | null, orderitemSet?: { __typename?: 'OrderItemNodeConnection', edges: Array<{ __typename?: 'OrderItemNodeEdge', node?: { __typename?: 'OrderItemNode', id: string, quantity: number, price: number, package?: { __typename?: 'PackageNode', id: string, price: number, name: string, shortDescription: string, longDescription?: string | null, deliveryNotes?: string | null, image?: { __typename?: 'FileNode', id: string, path: string, extension: string } | null } | null, artwork: { __typename?: 'ArtworkNode', id: string, slug: string, title: string, eventStartDate?: any | null, eventStartDateLocal?: any | null, artworkOrTourOrArtistImage?: { __typename?: 'ArtworkImageNode', id: string, extension: string, path: string } | null, tour?: { __typename?: 'TourNode', id: string, title: string } | null, venue?: { __typename?: 'VenueNode', id: string, name: string, slug: string, city?: string | null, state?: string | null, timeZone: string, venuePhoto?: { __typename?: 'FileNode', id: string, path: string, extension: string } | null } | null, mainArtist?: { __typename?: 'ArtistNode', fullName: string, slug: string } | null } } | null } | null> } | null } | null };

export type GetOrderByEmailAndIdQueryVariables = Exact<{
  email: Scalars['String'];
  id: Scalars['Int'];
}>;


export type GetOrderByEmailAndIdQuery = { __typename?: 'Query', getOrderByEmailAndId?: { __typename?: 'OrderItemNode', order: { __typename?: 'GrantedOrderNode', id: string, pk?: string | null, orderType: GrantedOrderOrderType, createdAt: any, status: GrantedOrderStatus, totalRefunded?: number | null, serviceFee: number, tax: number, totalPrice: number, shippingPrice: number, pay?: { __typename?: 'PaymentNode', id: string, transactionUid: string, paymentIntent?: { __typename?: 'PaymentIntentNode', id?: string | null, paymentMethodName?: string | null } | null, charge?: { __typename?: 'PaymentIntentNode', id?: string | null, paymentMethodName?: string | null } | null } | null, tevoOrder?: { __typename?: 'TevoOrderNode', sellerRejectionReason?: string | null, sellerRejectionNotes?: string | null, shipping?: number | null, shipments?: Array<{ __typename?: 'TevoShipmentsNode', state?: string | null } | null> | null, items?: Array<{ __typename?: 'TevoOrderItemNode', ticketGroup?: { __typename?: 'TevoTicketNode', id?: string | null, row?: string | null, section?: string | null, retailPrice?: number | null, format?: string | null, inHand?: boolean | null, inHandOn?: string | null } | null } | null> | null } | null, orderitemSet?: { __typename?: 'OrderItemNodeConnection', edges: Array<{ __typename?: 'OrderItemNodeEdge', node?: { __typename?: 'OrderItemNode', id: string, quantity: number, price: number, package?: { __typename?: 'PackageNode', id: string, name: string, shortDescription: string, deliveryNotes?: string | null, image?: { __typename?: 'FileNode', id: string, path: string, extension: string } | null } | null, artwork: { __typename?: 'ArtworkNode', id: string, slug: string, title: string, eventStartDateLocal?: any | null, venue?: { __typename?: 'VenueNode', id: string, name: string, slug: string } | null, mainArtist?: { __typename?: 'ArtistNode', fullName: string, slug: string } | null } } | null } | null> } | null } } | null };

export type GetUserActiveCartDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserActiveCartDetailsQuery = { __typename?: 'Query', findCart?: { __typename?: 'CartNode', pk?: string | null, id: string, status: CartStatus, deliveryOption?: string | null, createdAt: any, items?: Array<{ __typename?: 'CartItemNode', id: string, pk?: string | null, quantity: number, price?: number | null, artwork: { __typename?: 'ArtworkNode', id: string, slug: string, title: string, subTitle: string, artistFullName?: string | null, disablePromocodes?: boolean | null, eventStartDateLocal?: any | null, artworkOrTourOrArtistImage?: { __typename?: 'ArtworkImageNode', id: string, extension: string, path: string } | null, venue?: { __typename?: 'VenueNode', id: string, city?: string | null, name: string, state?: string | null, country?: string | null, timeZone: string } | null }, package?: { __typename?: 'PackageNode', id: string, pk?: string | null, name: string, shortDescription: string, longDescription?: string | null, deliveryNotes?: string | null, price: number, image?: { __typename?: 'FileNode', path: string, extension: string } | null } | null, tevoTicketGroup?: { __typename?: 'TevoTicketNode', id?: string | null, type?: string | null, inHandOn?: string | null, format?: string | null, row?: string | null, section?: string | null, retailPrice?: number | null, quantity?: number | null, availableQuantity?: number | null } | null } | null> | null } | null };

export type UserBaseDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserBaseDataQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', pk?: string | null, id: string, email?: string | null, type: UserType, lastName: string, firstName: string, fullName?: string | null, phoneNumber?: string | null, isPhoneNumberVerified: boolean, credit?: number | null } | null };

export type GetEventsQueryVariables = Exact<{
  featuredDateIsNull?: InputMaybe<Scalars['Boolean']>;
  announceDateGte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateGte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocalGte?: InputMaybe<Scalars['DateTime']>;
  eventStartDateLocalLte?: InputMaybe<Scalars['DateTime']>;
  venueCoordinates?: InputMaybe<Scalars['String']>;
  tourSlug?: InputMaybe<Scalars['String']>;
  starSlug?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  salesAs?: InputMaybe<Scalars['String']>;
  statusIn?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GetEventsQuery = { __typename?: 'Query', allArtworks?: { __typename?: 'ArtworkNodeCountingConnection', edges: Array<{ __typename?: 'ArtworkNodeCountingEdge', node?: { __typename?: 'ArtworkNode', id: string, title: string, slug: string, eventStartDateLocal?: any | null, eventStartDate?: any | null, tevoId?: number | null, hasPackages?: boolean | null, externalLink?: string | null, externalVipLink?: string | null, artworkOrTourOrArtistImage?: { __typename?: 'ArtworkImageNode', id: string, path: string, extension: string } | null, venue?: { __typename?: 'VenueNode', id: string, city?: string | null, state?: string | null, timeZone: string, name: string, venuePhoto?: { __typename?: 'FileNode', id: string, path: string, extension: string } | null } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type GrantedWebSettingsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
}>;


export type GrantedWebSettingsQuery = {
  __typename?: 'Query',
  grantedWebSettings?: {
    __typename?: 'GrantedWebSettingsNodeConnection',
    edges: Array<{
      __typename?: 'GrantedWebSettingsNodeEdge',
      node?: {
        __typename?: 'GrantedWebSettingsNode',
        pk?: string | null,
        id: string,
        name: string,
        type?: string | null,
        settings?: string | null,
        sections?: Array<{
          __typename?: 'GrantedWebSectionNode',
          pk?: string | null,
          id: string,
          name: string,
          type: string,
          isVisible: boolean,
          settings?: string | null
        } | null> | null
      } | null } | null>
  } | null
};

export type GrantedPackagesQueryVariables = Exact<{
  artworkSlug: Scalars['String'];
  isTicket: Scalars['Boolean'];
}>;


export type AllMainHeaderMenuItemsQuery = {
  __typename?: 'Query',
  allMainHeaderMenuItems?: {
    __typename?: 'MainHeaderMenuItemNodeConnection',
    edges: Array<{
      __typename?: 'MainHeaderMenuItemNodeEdge',
      node?: {
        __typename?: 'MainHeaderMenuItemNode',
        id: string,
        pk?: string | null,
        name: string,
        path: string,
        position?: number | null,
        isVisible: boolean
      } | null
    } | null>
  } | null
};

export type AllMainHeaderMenuItemsQueryVariables = Exact<{
  orderBy: Scalars['String'];
  isVisible: Scalars['Boolean'];
}>;


export type AllUserHeaderMenuItemsQuery = {
  __typename?: 'Query',
  allUserHeaderMenuItems?: {
    __typename?: 'UserHeaderMenuItemNodeConnection',
    edges: Array<{
      __typename?: 'UserHeaderMenuItemNodeEdge',
      node?: {
        __typename?: 'UserHeaderMenuItemNode',
        id: string,
        pk?: string | null,
        name: string,
        path: string,
        position?: number | null,
        isVisible: boolean
      } | null
    } | null>
  } | null
};

export type AllUserHeaderMenuItemsQueryVariables = Exact<{
  orderBy: Scalars['String'];
  isVisible: Scalars['Boolean'];
}>;


export type GrantedPackagesQuery = { __typename?: 'Query', allPackages?: { __typename?: 'PackageNodeConnection', edges: Array<{ __typename?: 'PackageNodeEdge', node?: { __typename?: 'PackageNode', id: string, pk?: string | null, name: string, price: number, quantity: number, longDescription?: string | null, shortDescription: string, deliveryNotes?: string | null, minSplit: number, maxSplit: number, availableQuantity: number, image?: { __typename?: 'FileNode', id: string, path: string, extension: string } | null, deliveryOptions?: { __typename?: 'DeliveryOptionNodeConnection', edges: Array<{ __typename?: 'DeliveryOptionNodeEdge', node?: { __typename?: 'DeliveryOptionNode', id: string, type: string } | null } | null> } | null } | null } | null> } | null };

export type TevoTicketsQueryVariables = Exact<{
  artworkPk: Scalars['Int'];
  tevoTicketsLimit?: InputMaybe<Scalars['Int']>;
  tevoTicketsOffset?: InputMaybe<Scalars['Int']>;
}>;


export type TevoTicketsQuery = { __typename?: 'Query', findArtwork?: { __typename?: 'ArtworkNode', id: string, tevoTicketGroups?: Array<{ __typename?: 'TevoTicketNode', id?: string | null, section?: string | null, retailPrice?: number | null, type?: string | null, quantity?: number | null, row?: string | null, availableQuantity?: number | null, publicNotes?: string | null, splits?: Array<number | null> | null, format?: string | null, tevoSectionName?: string | null, discount?: { __typename?: 'TevoTicketDiscount', discount?: number | null, discountedPrice?: number | null, type?: string | null, expiresOn?: any | null } | null } | null> | null, tevoSeatingChartConfiguration?: { __typename?: 'TevoEventConfigurationNode', id?: string | null } | null } | null };

export type GrantedWebSectionQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type GrantedWebSectionQuery = { __typename?: 'Query', grantedWebSection?: { __typename?: 'GrantedWebSectionNode', id: string, name: string, type: string, settings?: string | null } | null };

export type GrantedWebSectionsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
}>;


export type GrantedWebSectionsQuery = { __typename?: 'Query', grantedWebSections?: { __typename?: 'GrantedWebSectionNodeConnection', edges: Array<{ __typename?: 'GrantedWebSectionNodeEdge', node?: { __typename?: 'GrantedWebSectionNode', id: string, name: string, settings?: string | null } | null } | null> } | null };

export type GrantedSearchQueryVariables = Exact<{
  query: Scalars['String'];
  types: Array<Scalars['String']> | Scalars['String'];
}>;


export type GrantedSearchQuery = { __typename?: 'Query', grantedSearch?: { __typename?: 'GrantedSearchResultsNode', stars?: Array<{ __typename?: 'StarSearchResultNode', slug: string, imagePath?: string | null, fullName: string } | null> | null, venues?: Array<{ __typename?: 'VenueSearchResultNode', slug: string, name: string, imagePath?: string | null } | null> | null, events?: Array<{ __typename?: 'EventSearchResultNode', slug: string, title: string, eventStartDateLocal?: any | null, city?: string | null, state?: string | null } | null> | null, tours?: Array<{ __typename?: 'TourSearchResultNode', title: string, slug: string, imagePath?: string | null } | null> | null } | null };

export type AllSubCategoriesForStarsQueryVariables = Exact<{
  categoryId: Scalars['ID'];
}>;


export type AllSubCategoriesForStarsQuery = { __typename?: 'Query', allCategories?: { __typename?: 'StarCategoryNodeConnection', edges: Array<{ __typename?: 'StarCategoryNodeEdge', node?: { __typename?: 'StarCategoryNode', id: string, name?: string | null, position?: number | null, starcategorySet?: { __typename?: 'StarCategoryNodeConnection', edges: Array<{ __typename?: 'StarCategoryNodeEdge', node?: { __typename?: 'StarCategoryNode', id: string, name?: string | null, position?: number | null, starcategorySet?: { __typename?: 'StarCategoryNodeConnection', edges: Array<{ __typename?: 'StarCategoryNodeEdge', node?: { __typename?: 'StarCategoryNode', id: string, name?: string | null, position?: number | null } | null } | null> } | null } | null } | null> } | null } | null } | null> } | null };

export type AllCategoriesQueryVariables = Exact<{
  useConcert: Scalars['Boolean'];
  useComedy: Scalars['Boolean'];
  useSport: Scalars['Boolean'];
  concertCategoryId: Scalars['ID'];
  comedyCategoryId: Scalars['ID'];
  sportCategoryId: Scalars['ID'];
}>;


export type AllCategoriesQuery = { __typename?: 'Query', concerts?: { __typename?: 'StarCategoryNodeConnection', edges: Array<{ __typename?: 'StarCategoryNodeEdge', node?: { __typename?: 'StarCategoryNode', id: string, isSearchable: boolean, name?: string | null, position?: number | null, starcategorySet?: { __typename?: 'StarCategoryNodeConnection', edges: Array<{ __typename?: 'StarCategoryNodeEdge', node?: { __typename?: 'StarCategoryNode', id: string, name?: string | null, starcategorySet?: { __typename?: 'StarCategoryNodeConnection', edges: Array<{ __typename?: 'StarCategoryNodeEdge', node?: { __typename?: 'StarCategoryNode', id: string, name?: string | null } | null } | null> } | null } | null } | null> } | null, image?: { __typename?: 'FileNode', id: string, path: string, extension: string } | null, parent?: { __typename?: 'StarCategoryNode', id: string, name?: string | null } | null } | null } | null> } | null, sports?: { __typename?: 'StarCategoryNodeConnection', edges: Array<{ __typename?: 'StarCategoryNodeEdge', node?: { __typename?: 'StarCategoryNode', id: string, isSearchable: boolean, name?: string | null, position?: number | null, starcategorySet?: { __typename?: 'StarCategoryNodeConnection', edges: Array<{ __typename?: 'StarCategoryNodeEdge', node?: { __typename?: 'StarCategoryNode', id: string, name?: string | null, starcategorySet?: { __typename?: 'StarCategoryNodeConnection', edges: Array<{ __typename?: 'StarCategoryNodeEdge', node?: { __typename?: 'StarCategoryNode', id: string, name?: string | null } | null } | null> } | null } | null } | null> } | null, image?: { __typename?: 'FileNode', id: string, path: string, extension: string } | null, parent?: { __typename?: 'StarCategoryNode', id: string, name?: string | null } | null } | null } | null> } | null, comedy?: { __typename?: 'StarCategoryNodeConnection', edges: Array<{ __typename?: 'StarCategoryNodeEdge', node?: { __typename?: 'StarCategoryNode', id: string, isSearchable: boolean, name?: string | null, position?: number | null, starcategorySet?: { __typename?: 'StarCategoryNodeConnection', edges: Array<{ __typename?: 'StarCategoryNodeEdge', node?: { __typename?: 'StarCategoryNode', id: string, name?: string | null, starcategorySet?: { __typename?: 'StarCategoryNodeConnection', edges: Array<{ __typename?: 'StarCategoryNodeEdge', node?: { __typename?: 'StarCategoryNode', id: string, name?: string | null } | null } | null> } | null } | null } | null> } | null, image?: { __typename?: 'FileNode', id: string, path: string, extension: string } | null, parent?: { __typename?: 'StarCategoryNode', id: string, name?: string | null } | null } | null } | null> } | null };

export type GetEventAuctionByIdQueryVariables = Exact<{
  pk: Scalars['Int'];
}>;


export type GetEventAuctionByIdQuery = { __typename?: 'Query', findArtwork?: { __typename?: 'ArtworkNode', id: string, pk?: string | null, slug: string, title: string, status?: ArtworkStatus | null, origin: string, salesAs: ArtworkSalesAs, description?: string | null, eventStartDate?: any | null, eventStartDateLocal?: any | null, tevoId?: number | null, artistFullName?: string | null, salesOnDateLocal?: any | null, eventExtendedStatus?: string | null, venue?: { __typename?: 'VenueNode', id: string, zip?: string | null, name: string, city?: string | null, state?: string | null, tevoId?: number | null, timeZone: string, streetAddress?: string | null } | null, images?: { __typename?: 'ArtworkImageNodeConnection', edges: Array<{ __typename?: 'ArtworkImageNodeEdge', node?: { __typename?: 'ArtworkImageNode', id: string, path: string, extension: string } | null } | null> } | null, mainArtist?: { __typename?: 'ArtistNode', fullName: string, meta?: string | null, slug: string } | null, tour?: { __typename?: 'TourNode', id: string, title: string } | null, artworkOrTourOrArtistImage?: { __typename?: 'ArtworkImageNode', path: string, extension: string } | null, packageInfo?: Array<{ __typename?: 'PackageNode', id: string, pk?: string | null, isTicket: boolean } | null> | null } | null };

export type GetCitiesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  coordinatesSort?: InputMaybe<Scalars['String']>;
}>;


export type GetCitiesQuery = { __typename?: 'Query', allCities?: { __typename?: 'CityNodeConnection', edges: Array<{ __typename?: 'CityNodeEdge', node?: { __typename?: 'CityNode', id: string, pk?: string | null, name: string, stateCode?: string | null, lat: number, lon: number } | null } | null> } | null };

export type ArtistsFromCategoriesExtendedQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  activeArtworks?: InputMaybe<Scalars['Boolean']>;
  venueCoordinates?: InputMaybe<Scalars['String']>;
  categoryWithChild_Exact?: InputMaybe<Scalars['String']>;
  annotateArtworkMinStartDate?: InputMaybe<Scalars['Boolean']>;
}>;


export type ArtistsFromCategoriesExtendedQuery = { __typename?: 'Query', allArtists?: { __typename?: 'ArtistNodeConnection', edges: Array<{ __typename?: 'ArtistNodeEdge', node?: { __typename?: 'ArtistNode', id: string, fullName: string, slug: string, file?: { __typename?: 'FileNode', extension: string, path: string } | null, categories?: { __typename?: 'StarCategoryNodeConnection', edges: Array<{ __typename?: 'StarCategoryNodeEdge', node?: { __typename?: 'StarCategoryNode', id: string } | null } | null> } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type ArtistsWithTicketsVipQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Scalars['String']>;
  activeArtworks?: InputMaybe<Scalars['Boolean']>;
}>;


export type ArtistsWithTicketsVipQuery = { __typename?: 'Query', allArtists?: { __typename?: 'ArtistNodeConnection', edges: Array<{ __typename?: 'ArtistNodeEdge', node?: { __typename?: 'ArtistNode', id: string, fullName: string, slug: string, featuredDate?: any | null, file?: { __typename?: 'FileNode', extension: string, path: string } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type IsUserExistsQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type IsUserExistsQuery = { __typename?: 'Query', isUserExists?: boolean | null };

export type GetAutomaticApplyPromocodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAutomaticApplyPromocodeQuery = { __typename?: 'Query', automaticApplyPromocode?: { __typename?: 'PromocodeNode', id: string, code: string } | null };

export type GetUserReferralCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserReferralCodeQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', id: string, redemptionsCount?: number | null, referral?: { __typename?: 'UserReferralNode', id: string, code: string } | null } | null };

export type GetUserRedemptionsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetUserRedemptionsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserNode', id: string, redemptionsCount?: number | null, redemptions?: { __typename?: 'UserNodeConnection', edges: Array<{ __typename?: 'UserNodeEdge', node?: { __typename?: 'UserNode', id: string, fullName?: string | null } | null } | null> } | null } | null };

export type UserReferralQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type UserReferralQuery = { __typename?: 'Query', findUserReferral?: { __typename?: 'UserReferralNode', id: string } | null };

export type GetCreditActionTypesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type GetCreditActionTypesQuery = { __typename?: 'Query', creditActionTypes?: { __typename?: 'CreditActionTypeNodeConnection', edges: Array<{ __typename?: 'CreditActionTypeNodeEdge', node?: { __typename?: 'CreditActionTypeNode', id: string, pk?: string | null, type: string, amount?: number | null, createdAt: any, updatedAt?: any | null } | null } | null> } | null };

export type GetUserActiveMediumCartQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserActiveMediumCartQuery = { __typename?: 'Query', findCart?: { __typename?: 'CartNode', pk?: string | null, id: string, items?: Array<{ __typename?: 'CartItemNode', id: string, quantity: number, price?: number | null, artwork: { __typename?: 'ArtworkNode', id: string, slug: string, title: string, subTitle: string, artistFullName?: string | null, eventStartDateLocal?: any | null, artworkOrTourOrArtistImage?: { __typename?: 'ArtworkImageNode', id: string, extension: string, path: string } | null }, package?: { __typename?: 'PackageNode', id: string, pk?: string | null } | null } | null> | null } | null };

export type AddOrUpdateContactListMutationVariables = Exact<{
  listNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  listIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  data: ContactData;
}>;


export type AddOrUpdateContactListMutation = { __typename?: 'Mutation', addOrUpdateContactList?: { __typename?: 'ContactMutationFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename?: 'ContactMutationSuccess', success?: boolean | null } | null };

export type SignUpGuestMutationVariables = Exact<{
  input: SignupGuestInput;
}>;


export type SignUpGuestMutation = { __typename?: 'Mutation', signupGuest?: { __typename?: 'SignupFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename?: 'SignupSuccess', user?: { __typename?: 'UserNode', id: string, pk?: string | null, firstName: string, lastName: string, email?: string | null, phoneNumber?: string | null, locationCountry?: string | null } | null } | null };

export type GetEventTypeQueryVariables = Exact<{
  pk: Scalars['Int'];
}>;


export type GetEventTypeQuery = { __typename?: 'Query', findArtwork?: { __typename?: 'ArtworkNode', salesAs: ArtworkSalesAs, venue?: { __typename?: 'VenueNode', timeZone: string } | null, auctions?: { __typename?: 'AuctionNodeConnection', edges: Array<{ __typename?: 'AuctionNodeEdge', node?: { __typename?: 'AuctionNode', end?: any | null } | null } | null> } | null } | null };

export type ProtechtTermsAndConditionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProtechtTermsAndConditionsQuery = { __typename?: 'Query', protechtTermsAndConditions?: string | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'LogoutFailure', errorMessage?: string | null, fieldsErrors?: Array<{ __typename?: 'FieldErrors', field?: string | null, messages?: Array<string | null> | null } | null> | null } | { __typename?: 'LogoutSuccess', result?: boolean | null } | null };

export type GetStarEventsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
  featuredDate_Isnull?: InputMaybe<Scalars['Boolean']>;
  salesAs?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
}>;


export type GetStarEventsQuery = { __typename?: 'Query', allArtworks?: { __typename?: 'ArtworkNodeCountingConnection', edges: Array<{ __typename?: 'ArtworkNodeCountingEdge', node?: { __typename?: 'ArtworkNode', title: string, slug: string, eventStartDateLocal?: any | null, tevoId?: number | null, hasPackages?: boolean | null, externalLink?: string | null, externalVipLink?: string | null, venue?: { __typename?: 'VenueNode', id: string, city?: string | null, state?: string | null, name: string } | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type GetStarBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
}>;


export type GetStarBySlugQuery = { __typename?: 'Query', allArtists?: { __typename?: 'ArtistNodeConnection', edges: Array<{ __typename?: 'ArtistNodeEdge', node?: { __typename?: 'ArtistNode', id: string, pk?: string | null, bio?: string | null, fullName: string, lastParentCategories?: Array<string | null> | null, meta?: string | null, slug: string, status?: ArtistStatus | null, file?: { __typename?: 'FileNode', extension: string, path: string } | null } | null } | null> } | null };

export type GetAllArtistsSlugQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']>;
}>;


export type GetAllArtistsSlugQuery = { __typename?: 'Query', allArtists?: { __typename?: 'ArtistNodeConnection', edges: Array<{ __typename?: 'ArtistNodeEdge', node?: { __typename?: 'ArtistNode', slug: string } | null } | null> } | null };

export type StarAuctionsQueryVariables = Exact<{
  artistsSlug?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  salesAs?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
}>;


export type StarAuctionsQuery = { __typename?: 'Query', allArtworks?: { __typename?: 'ArtworkNodeCountingConnection', edges: Array<{ __typename?: 'ArtworkNodeCountingEdge', node?: { __typename?: 'ArtworkNode', title: string, startingBid?: number | null, description?: string | null, currentBid?: number | null, endDate?: any | null, slug: string, venue?: { __typename?: 'VenueNode', timeZone: string } | null, artworkOrTourOrArtistImage?: { __typename?: 'ArtworkImageNode', id: string, path: string, extension: string } | null } | null } | null> } | null };

export type GetTourBySlugQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetTourBySlugQuery = { __typename?: 'Query', allTours?: { __typename?: 'TourNodeConnection', edges: Array<{ __typename?: 'TourNodeEdge', node?: { __typename?: 'TourNode', id: string, slug: string, title: string, status: string, description?: string | null, artistSlug?: string | null, artistFullName?: string | null, tourPhoto?: { __typename?: 'FileNode', id: string, path: string, extension: string } | null, featuringArtists?: Array<{ __typename?: 'ArtistNode', fullName: string } | null> | null } | null } | null> } | null };

export type GetEventsByTourSlugForSchemaQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  tourSlug?: InputMaybe<Scalars['String']>;
  eventStartDate_Gte?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetEventsByTourSlugForSchemaQuery = { __typename?: 'Query', allArtworks?: { __typename?: 'ArtworkNodeCountingConnection', edges: Array<{ __typename?: 'ArtworkNodeCountingEdge', node?: { __typename?: 'ArtworkNode', id: string, slug: string, title: string, eventStartDateLocal?: any | null, tevoId?: number | null, artworkOrTourOrArtistImage?: { __typename?: 'ArtworkImageNode', id: string, path: string, extension: string } | null, venue?: { __typename?: 'VenueNode', id: string, timeZone: string, city?: string | null, state?: string | null, name: string } | null, packageInfo?: Array<{ __typename?: 'PackageNode', id: string } | null> | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetVenueBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type GetVenueBySlugQuery = { __typename?: 'Query', venue?: { __typename?: 'VenueNode', id: string, pk?: string | null, name: string, slug: string, city?: string | null, state?: string | null, lat: number, lon: number, zip?: string | null, country?: string | null, status: string, streetAddress?: string | null, description: string, venuePhoto?: { __typename?: 'FileNode', path: string, extension: string } | null } | null };
